import { DatePipe, formatDate } from '@angular/common';
import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { EMPTY } from 'rxjs';
import { MatOption } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { SubscriptionAccountsComponent } from '../subscription-accounts/subscription-accounts.component';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { Router } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, startWith, switchMap, tap } from 'rxjs/operators';
import { CreditDebitLedgerReportComponent } from '../credit-debit-ledger-report/credit-debit-ledger-report.component';
import { RepledgerComponent } from 'src/app/repledger/repledger.component';
import { ExpenseledgerComponent } from 'src/app/expenseledger/expenseledger.component';
import { CreditorsreportComponent } from 'src/app/creditorsreport/creditorsreport.component';
import { UpdatejournalvoucherComponent } from 'src/app/updatejournalvoucher/updatejournalvoucher.component';
import { ToastrService } from 'ngx-toastr';
import { JournaledgerlvoucherComponent } from 'src/app/journaledgerlvoucher/journaledgerlvoucher.component';
import { SubexpcvdvreportComponent } from 'src/app/subexpcvdvreport/subexpcvdvreport.component';
import { TrialBalanceComponent } from 'src/app/trial-balance/trial-balance.component';
import { ExpenditureIncomeReportComponent } from 'src/app/expenditure-income-report/expenditure-income-report.component';
import { TrialBalanceNewComponent } from 'src/app/trial-balance-new/trial-balance-new.component';
import { DepositSlipReportComponent } from 'src/app/deposit-slip-report/deposit-slip-report.component';
import { DebitVoucherBillComponent } from 'src/app/debit-voucher-bill/debit-voucher-bill.component';
import { element } from 'protractor';
import { ExpenseOpeningBalanceReportComponent } from 'src/app/expense-opening-balance-report/expense-opening-balance-report.component';
import { RecoBriefReportComponent } from 'src/app/reco-brief-report/reco-brief-report.component';
import { BankRecoInBriefReportComponent } from 'src/app/bank-reco-in-brief-report/bank-reco-in-brief-report.component';
import { debug } from 'console';
import Swal from 'sweetalert2';
import { AccSubscriptionMonthwiseReportComponent } from 'src/app/acc-subscription-monthwise-report/acc-subscription-monthwise-report.component';
import { ExpenseLedgerReportComponent } from 'src/app/expense-ledger-report/expense-ledger-report.component';
import { PackageReportComponent } from 'src/app/package-report/package-report.component';
import { BalanceSheetComponent } from 'src/app/balance-sheet/balance-sheet/balance-sheet.component';
import { CreditVoucherIssuesComponent } from 'src/app/credit-voucher-issues/credit-voucher-issues.component';
import { DebitVoucherIssuesComponent } from 'src/app/debit-voucher-issues/debit-voucher-issues.component';
import * as XLSX from 'xlsx';
import { LekhReportComponent } from 'src/app/lekh-report/lekh-report.component';
import { CreditorsIssuesComponent } from 'src/app/creditors-issues/creditors-issues.component';

export const _filter1 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter2 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter3 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

// export const _filter4 = (opt: string[], value: string): string[] => {
//   const filterValue = value.toLowerCase();

//   return opt.filter((item) => item.toLowerCase().includes(filterValue));
// };

export function financialYearValidator(): ValidatorFn {
  return (control: FormControl) => {
    const selectedDateStr = control.value;
    const selectedDate = new Date(selectedDateStr);

    // Read financial year boundaries from localStorage
    const startDateStr = sessionStorage.getItem('startDate'); // e.g. "2025-04-01"
    const endDateStr = sessionStorage.getItem('endDate');     // e.g. "2026-03-31"

    if (!startDateStr || !endDateStr || isNaN(selectedDate.getTime())) {
      return { financialYear: true }; // invalid or missing data
    }

    const financialYearStart = new Date(startDateStr);
    const financialYearEnd = new Date(endDateStr);

    // Check if the selected date is within the stored financial year range
    if (selectedDate >= financialYearStart && selectedDate <= financialYearEnd) {
      return null; // Valid
    } else {
      return { financialYear: true }; // Invalid
    }
  };
}


@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.scss'],
})

export class AccountsComponent implements OnInit {

  @ViewChildren('inputRef') inputs!: QueryList<ElementRef<HTMLInputElement>>;
  months: { value: string; name: string; }[];
  loadingLekh: boolean;
  selectedMonth: string = '';
  focusNextInput(currentIndex: number): void {
    const inputsArray = this.inputs.toArray();
    const nextInput = inputsArray[currentIndex + 1];

    if (nextInput) {
      nextInput.nativeElement.focus();
    }
  }

  mainExpFilter: string = '';
  subExpFilter: string = '';

  filteredMainExpData: any[] = [];
  filteredMainExpDataForCV: any[] = [];

  filteredSubExpData: any[] = [];

  incomeData = [];
  expenditureData = [];
  liabilitiesData = [];
  assetsData = [];

  lekhakForm!: FormGroup;
  issueForm!: FormGroup;
  lekhakList: any[] = [];
  issueList: any[] = [];
  issueList1: any[] = [];
  loading = false;
  loading1 = false;
  error = '';
  editMode = false;
  editMode1 = false;
  selectedId: number | null = null;
  selectedId1: number | null = null;

  lekhEntryForm!: FormGroup;
  lekhEntryList: any[] = [];
  editLekhMode = false;
  editLekhId: number | null = null;

  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  names = [];
  names1 = [];
  names2 = [];
  names3 = [];
  names4 = [];
  names5 = [];
  names6 = [];
  creditors = 'पुरवठादार देणी'
  visibleRows: boolean[];
  subscriptionpaymentList = [];
  isDebitVoucherEditMode: boolean = false
  creditorlistactive: boolean = false
  advtpaymentList = [];
  getallVouchersData = [];
  advt_mag_name_details = [];
  ionicForm: FormGroup;
  creditvoucherForm: FormGroup;
  pkgForm: FormGroup;
  pkgBookingregisterForm: FormGroup;
  bankForm: FormGroup;
  debitForm: FormGroup;
  ExpenseLedgerForm: FormGroup;
  repledger: FormGroup;
  kharedi: FormGroup;
  journalvoucher: FormGroup;
  journalvouchergetdate: FormGroup;
  SubExpenseLedgerForm: FormGroup;
  expenseledger1: FormGroup;
  expenseledger2: FormGroup;
  expenseledger3: FormGroup;
  expenseledger4: FormGroup;
  expensereport: FormGroup;
  trialbalance: FormGroup;
  profitloss: FormGroup;
  depositslip: FormGroup;
  balancesheet: FormGroup;
  issueDetectionForm: FormGroup;
  bankReco: FormGroup;
  subscription: FormGroup;
  package: FormGroup;
  chequeCancel: FormGroup;
  id;
  debit_voucher_id;
  displaycrform = false;
  advtCategorylist;
  vouchervalue: string = 'CR';
  filteredOptions1: Observable<string[]>;
  filteredOptions2: Observable<String[]>;
  filteredOptions3: Observable<String[]>;
  filteredOptions4: Observable<String[]>;
  filteredOptions5: Observable<String[]>;
  issue_seller_name = [];
  packageData;
  packagenames = [];
  pkgBookingData = [];
  FilteredpkgBookingData = [];
  totalcrdtvreport;
  // pkgBookingData3 = [];
  // pkgBookingData5 = [];
  pkgBookingnames = [];
  pkgBookingrepnames = [];
  pkgBookingoffrepnames = [];
  pkgBookingcustnames = [];
  BankData = [];
  RCSBankData = [];
  allCreditVoucherListData = [];
  mainExpData = [];
  missingCVData = [];
  missingDVData = [];
  mainExpData101 = [];
  mainExpDataForPackageManager = [];
  mainExpData1 = [];
  subExpData = [];
  getSubExpData;
  getSubExpData101;
  getDebitSubExpData;
  items: any[] = [];
  deleteditems: any[] = [];
  items1: any[] = [];
  deletedItems: any[] = []; // holds items marked for deletion
  updateMode: boolean = false;
  isEditMode: boolean = false;

  departmentTypes: string[] = [
    'जाहिरात',
    'वर्गणी',
    'पुस्तक',
    'अंक विक्री',
    'जमा',
    'क्रेडिट खर्च',
    'पॅकेज'
  ];

  expTypeData = [
    { id: 1, exp_name: 'Assent' },
    { id: 2, exp_name: 'Liabilities' },
    { id: 3, exp_name: 'Income' },
    { id: 4, exp_name: 'Expenditure' }
  ];

  isAllSelected = false;
  otherDepositExpensesUpdated: boolean = false;
  expenditureExpensesUpdated: boolean = false;
  packagesUpdated: boolean = false;
  hasCreditVoucherPermission: boolean = true;
  hasDebitVoucherPermission: boolean = true;
  permissions: any[] = [];
  hasCreditVoucherAddPermission: boolean = true;
  hasCreditVoucherUpdatePermission: boolean = true;
  hasCreditVoucherDeletePermission: boolean = true;
  hasDebitVoucherAddPermission: boolean = true;
  hasDebitVoucherUpdatePermission: boolean = true;
  hasDebitVoucherDeletePermission: boolean = true;
  hasJournalVoucherPermission: boolean = true;
  hasJournalVoucherAddPermission: boolean = true;
  hasJournalVoucherUpdatePermission: boolean = true;
  hasJournalVoucherDeletePermission: boolean = true;
  hasJournalVoucherViewPermission: boolean = true;
  hasCreditorsViewPermission: boolean = true;
  hasCreditorsAddPermission: boolean = true;
  hasCreditorsDeletePermission: boolean = true;
  hasCreditorsUpdatePermission: boolean = true;
  hasBankReportViewPermission: boolean = true;

  hasBankRecoViewPermission: boolean = true;
  hasBankRecoAddPermission: boolean = true;
  hasBankRecoUpdatePermission: boolean = true;
  hasBankRecoDeletePermission: boolean = true;
  hasBankRecoReportViewPermission: boolean = true;

  hasExpenseMasterAddPermission: boolean = true;
  hasExpenseMasterUpdatePermission: boolean = true;
  hasExpenseMasterDeletePermission: boolean = true;

  hasExpenseReportViewPermission: boolean = true;
  hasRepLedgerViewPermission: boolean = true;

  hasTrialBalRepoViewPermission: boolean = true;
  hasProfitLossRepoViewPermission: boolean = true;
  hasBalanceSheetRepoViewPermission: boolean = true;
  hasDepositSlipRepoViewPermission: boolean = true;

  hasPackageManagerAddPermission: boolean = true;
  hasPackageManagerUpdatePermission: boolean = true;

  hasSubMonthlyRepoViewPermission: boolean = true;

  toggleDepartmentSelection(event: any): void {
    const selected = event.value;

    if (selected.includes('all')) {
      this.isAllSelected = !this.isAllSelected;

      if (this.isAllSelected) {
        this.repledger.get('department_type')?.setValue([...this.departmentTypes]);
      } else {
        this.repledger.get('department_type')?.setValue([]);
      }
    }
  }

  creditdebitDateRange = new FormGroup({
    start: new FormControl(''),
    end: new FormControl(''),
  });

  reconsilationDateRange = new FormGroup({
    start: new FormControl(''),
    end: new FormControl(''),
  });
  BankData1: any;
  BankDataForBankReco: any;
  opening_yes_no: any = null;
  forupdate: any;
  vouchers_status: any;
  mergedArray1: any[];
  narrationname: any;
  creditornumber: any;
  insertid: any;
  demo1TabIndex: number;
  filteredArray: any[];
  searchQuery: string = '';
  journalvouchernumber: any;
  jnumber: any;
  journaldata: any;
  getjournaldata: any;
  deletevoucher_no: any;
  checkedstatus: any;
  getchquedata: any;
  debitvoucherlist: any;
  creditorslist: boolean = false;
  transformedResult: { debitvoucher: { id: any; }[]; };
  mainidforupdatedebit: any;
  updatevoucherno: any
  mainidforupdatecreditor: any
  selectbank: any;
  selectvocuherdate: any;
  StartDate: any;
  EndDate: any;
  subexpense2: boolean;
  creditorId: any;
  deletedMainExpenses: any[] = [];
  deletedSubExpenses: any[] = [];

  packages: any[] = [];


  constructor(
    public service: DigisubservicesService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private toaster: ToastrService,
    private router: Router, private datePipe: DatePipe
  ) {

    this.addItem();

    this.ionicForm = this.formBuilder.group({
      advtpayment: [''],
      bookpayment: [''],
      subpayment: [''],
      bookcomment: [''],
      advtcomment: [''],
      subcomment: [''],
    });

    this.lekhakForm = this.formBuilder.group({
      name: ['', Validators.required],
      mobile: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[6-9]\d{9}$/)   // Indian mobile number
        ]
      ],
      email: [''],
      acc_no: ['', Validators.required],
      ifsc: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[A-Z]{4}0[A-Z0-9]{6}$/) // IFSC format
        ]
      ],
      bank_name: [''],
      branch: ['']
    });

    this.lekhEntryForm = this.formBuilder.group({
      lekhak_id: [''],
      issue_id: [''],
      month: [''],
      lekh_rate: ['']
    });

    this.creditvoucherForm = this.formBuilder.group({
      v_no: [{ value: '', disabled: false }],
      bcaccount: [{ value: '', disabled: false }],
      vnumber: [{ value: '', disabled: false }],
      // voucherdate: new FormControl({ value: '', disabled: false }, [Validators.required, financialYearValidator()]),
      voucherdate: [{ value: '', disabled: false }], // Always disabled (read-only)
      rname: [{ value: '', disabled: false }],
      othername: [{ value: '', disabled: false }],
      damount: [{ value: '', disabled: false }],
      pymtoptions: [{ value: '', disabled: false }],
      cnumber: [{ value: '', disabled: false }],
      bank: [{ value: '', disabled: false }],
      branch: [{ value: '', disabled: false }],
      chequedate: [{ value: '', disabled: false }],
      entrydate: [{ value: '', disabled: false }],
      types: [{ value: '', disabled: false }],
      subscription: [{ value: '', disabled: false }],
      subscriptionname: [{ value: '', disabled: false }],
      isale: [{ value: '', disabled: false }],
      isname: [{ value: '', disabled: false }],
      adverties: [{ value: '', disabled: false }],
      advertiesname: [{ value: '', disabled: false }],
      deposits: [{ value: '', disabled: false }],
      depositsname: [{ value: '', disabled: false }],
      granthbook: [{ value: '', disabled: false }],
      booksellername: [{ value: '', disabled: false }],
      granthbooknames: [{ value: '', disabled: false }],
      granthbookname: [{ value: '', disabled: false }],
      bookName: [{ value: '', disabled: false }],
      package: [{ value: '', disabled: false }],
      packagename: [{ value: '', disabled: false }],
      packageamt: [{ value: '', disabled: false }],
      donation: [{ value: '', disabled: false }],
      pancard: [{ value: '', disabled: false }],
      narration: [{ value: '', disabled: false }],
      donationname: [{ value: '', disabled: false }],
      odeposit: [{ value: '', disabled: false }],
      odepositname: [{ value: '', disabled: false }],
      packagecount: [{ value: '', disabled: false }],
      packageamount: [{ value: '', disabled: false }],
      otheramount: [{ value: '', disabled: false }],
      total: [{ value: '', disabled: false }],
      expenditure: [{ value: '', disabled: false }],
      travels: [{ value: '', disabled: false }],
      subscommission: [{ value: '', disabled: false }],
      issuecommission: [{ value: '', disabled: false }],
      advtcommission: [{ value: '', disabled: false }],
      bookcommission: [{ value: '', disabled: false }],
      other: [{ value: '', disabled: false }],
      expname: [{ value: '', disabled: false }],
      subexpname: [{ value: '', disabled: false }],
      exp_amt: [{ value: '', disabled: false }],
      totalexp: [{ value: '', disabled: false }],
      ndeposit: [{ value: '', disabled: false }],
      entername: [{ value: '', disabled: false }],
      expnameother: [{ value: '', disabled: false }],
      subexpnameother: [{ value: '', disabled: false }],
      expnameotherd: [{ value: '', disabled: false }],
      subexpnameotherd: [{ value: '', disabled: false }],
      exp_amtother: [{ value: '', disabled: false }],
      name: [{ value: '', disabled: false }],
    });

    this.pkgForm = this.formBuilder.group({
      pkgname: [''],
      start: [''],
      end: [''],
      pkgamt: [''],
      expledgerForOtherConcession: [''],
      // expledgerForHindiVivek: [''],
      // expledgerForVaidyraj: [''],
      // expledgerForCourier: [''],
      periodicity: [''],
      vivekm1actualamt: [''],
      vivekm1concessionamt: [''],
      vivekh1actualamt: [''],
      vivekh1concessionamt: [''],
      vaidyraj1actualamt: [''],
      vaidyraj1concessionamt: [''],
      granth11actualamt: [''],
      granth11concessionamt: [''],
      granth21actualamt: [''],
      granth21concessionamt: [''],
      donation1actualamt: [''],
      donation1concessionamt: [''],
      advt1actualamt: [''],
      advt1concessionamt: [''],
      courier1actualamt: [''],
      courier1concessionamt: [''],
      other1actualamt: [''],
      other1concessionamt: [''],
      vivekm3actualamt: [''],
      vivekm3concessionamt: [''],
      vivekh3actualamt: [''],
      vivekh3concessionamt: [''],
      vaidyraj3actualamt: [''],
      vaidyraj3concessionamt: [''],
      granth13actualamt: [''],
      granth13concessionamt: [''],
      granth23actualamt: [''],
      granth23concessionamt: [''],
      donation3actualamt: [''],
      donation3concessionamt: [''],
      advt3actualamt: [''],
      advt3concessionamt: [''],
      courier3actualamt: [''],
      courier3concessionamt: [''],
      other3actualamt: [''],
      other3concessionamt: [''],
      vivekm5actualamt: [''],
      vivekm5concessionamt: [''],
      vivekh5actualamt: [''],
      vivekh5concessionamt: [''],
      vaidyraj5actualamt: [''],
      vaidyraj5concessionamt: [''],
      granth15actualamt: [''],
      granth15concessionamt: [''],
      granth25actualamt: [''],
      granth25concessionamt: [''],
      donation5actualamt: [''],
      donation5concessionamt: [''],
      advt5actualamt: [''],
      advt5concessionamt: [''],
      courier5actualamt: [''],
      courier5concessionamt: [''],
      other5actualamt: [''],
      other5concessionamt: [''],
    });

    this.pkgBookingregisterForm = this.formBuilder.group({
      pkg_name: [''],
      start: [''],
      end: [''],
      off_rep_name: [''],
      rep_name: [''],
      cust_name: [''],
    });

    this.bankForm = this.formBuilder.group({
      bank_name: [''],
      bank_short_name: [''],
      bank_o_bal: [''],
      crdtdebt: [''],
    });

    this.debitForm = this.formBuilder.group({
      bcaccount: [{ value: '', disabled: false }], // Enabled by default
      dvnumber: [{ value: '', disabled: true }], // Always disabled (read-only)
      // dvoucherdate: new FormControl({ value: '', disabled: false }, [Validators.required, financialYearValidator()]),
      dvoucherdate: [{ value: '', disabled: false }],
      rname: ['', Validators.required],
      othername: [{ value: '', disabled: false }],
      exp_amt: [{ value: '', disabled: false }],
      chequedate: [{ value: '', disabled: false }],
      chequeno: [{ value: '', disabled: false }],
      dv_no: [{ value: '', disabled: false }],
      expname: [{ value: null, disabled: false }],
      subexpname: [{ value: '', disabled: false }],
      expamt: [{ value: '', disabled: false }],
      totalexp: [{ value: '', disabled: false }],
      exptype: [{ value: '', disabled: false }],
      expId: [{ value: '', disabled: false }], // Always disabled (calculated field)
    });

    this.ExpenseLedgerForm = formBuilder.group({
      expensename: [''],
      sortOrder: [''],
      exptype: [''],
      openingbal: [''],
      opening_yes_no: [''],
      start: [''],
      end: [''],
      crdr: [''],

    });

    this.repledger = formBuilder.group({
      start: [''],
      end: [''],
      repname: [''],
      department_type: [[]],
    });

    this.kharedi = formBuilder.group({
      expnameother: [''],
      subexpnameother: [''],
      voucherdate: [''],
      creditorsnum: [''],
      totalamount: [''],
      billno: [''],
      narration: [''],
    });

    this.journalvouchergetdate = formBuilder.group({
      start: [''],
      end: [''],
    });

    this.journalvoucher = formBuilder.group({
      searchVoucherNum: [''],
      jvouchernum: [''],
      date: [''],
      narration: [''],
      voucherdate: [''],
    });

    this.SubExpenseLedgerForm = formBuilder.group({
      expname: [''],
      subexpname: [''],
      bank_name: [''],
      bank_o_bal: [''],
      crdtdebt: [''],
      bank_short_name: [''],

    });
    this.expenseledger1 = formBuilder.group({
      expnameother: [''],
      subexpnameother: [''],
      start: [''],
      end: [''],

    });

    this.expenseledger2 = formBuilder.group({
      expnameother: [''],
      subexpnameother: [''],
      start: [''],
      end: [''],

    });

    this.expenseledger3 = formBuilder.group({
      start: [''],
      end: [''],
      reportMode: [''],
    });

    this.expenseledger4 = formBuilder.group({
      start: [''],
      end: [''],
    });

    this.trialbalance = formBuilder.group({
      reportType: [''],
      start: [''],
      end: [''],
    });

    this.profitloss = formBuilder.group({
      start: [''],
      end: [''],
      dateRange: ['', [Validators.pattern(/^\d{2}-\d{2}-\d{4}\s*-\s*\d{2}-\d{2}-\d{4}$/)]],
    });

    this.depositslip = formBuilder.group({
      start: [''],
      end: [''],
    });

    this.balancesheet = formBuilder.group({
      start: [''],
      end: [''],
    });

    this.issueDetectionForm = this.formBuilder.group({
      start: [''],
      end: [''],
      voucherType: ['', Validators.required]
    });

    this.bankReco = formBuilder.group({
      start: [''],
      end: [''],
      reportType: [''],
    });

    this.subscription = formBuilder.group({
      start: [''],
      end: [''],
    });

    this.package = formBuilder.group({
      start: [''],
      end: [''],
      selectedPackage: [''],
    });

    this.chequeCancel = formBuilder.group({

    });

    this.expensereport = formBuilder.group({
      start: [''],
      end: [''],
    });

    this.totalcrdtvreport = {
      depositamt: 0,
      sub: 0,
      issue: 0,
      advt: 0,
      deposit: 0,
      book: 0,
      pkg_amt: 0,
      donation: 0,
      other_deposit: 0,
      // travel: 0,
      // other: 0,
      // sub_com: 0,
      // is_com: 0,
      // advt_com: 0,
      // gb_com: 0,
      total: 0,
      total_exp: 0,
      net_deposit: 0,
    };

  }

  public demo1BtnClick1(tabCount: any) {

    this.demo1TabIndex = Number(tabCount);

  }

  bookList: any
  getBooksList() {
    let resultState = this.service.get_book_names();
    resultState.subscribe((data) => {
      this.bookList = data;

    });
  }

  DeleteJournalVoucher: any = ""
  getDeleteJournalVoucher(obj: any) {
    const request = {
      "id": obj.jv_id
    }
    let resultState = this.service.delete_journal_voucher(request);
    resultState.subscribe((data) => {
      this.DeleteJournalVoucher = data;

      // Show success alert
      alert("Journal Voucher deleted successfully!");

      // Refresh the page after deletion
      location.reload();

    });
  }

  loadPackagesData() {
    this.service.getPackagesList().subscribe((data) => {
      this.packages = data;
    });
  }



  DeleteMainExpense: any = ""
  getDeleteMainExpense(obj: any) {
    if (!this.hasExpenseMasterDeletePermission) {
      alert("You don't have permission to Delete Main Expense!!!");
      return;
    }
    const request = {
      "id": obj.id
    }
    let resultState = this.service.delete_main_expense(request);
    resultState.subscribe((data) => {
      this.DeleteMainExpense = data;

      // Show success alert
      alert("Expense ledger deleted successfully!");

      // Refresh the page after deletion
      location.reload();

    });
  }

  DeleteSubExpense: any = ""
  getDeleteSubExpense(obj: any) {
    if (!this.hasExpenseMasterDeletePermission) {
      alert("You don't have permission to Delete Sub Expense!!!");
      return;
    }
    const request = {
      "id": obj.id
    }
    let resultState = this.service.delete_sub_expense(request);
    resultState.subscribe((data) => {
      this.DeleteSubExpense = data;

      // Show success alert
      alert("Sub-Expense ledger deleted successfully!");

      // Refresh the page after deletion
      location.reload();

    });
  }


  JournalVoucherList: any = ""
  getJournalVoucherList() {
    let resultState = this.service.get_journal_voucher_list();
    resultState.subscribe((data) => {
      this.JournalVoucherList = data;


    });
  }
  comaSepratedId: any = ""
  getGetBookIds(event: any) {
    this.comaSepratedId = event.value.join(',');
  }

  isSubmitting = false;

  insert_person_book_names() {
    if (this.isSubmitting) return;  // Prevent multiple calls
    this.isSubmitting = true;       // Set flag to true

    const request = {
      "crdt_vucher_id": this.creditvoucherForm.get('vnumber').value,
      "name": this.creditvoucherForm.get('granthbookname').value,
      "price": this.creditvoucherForm.get('granthbook').value,
      "book_ids": this.comaSepratedId
    };

    console.log("Method new payload =", request);

    this.service.insert_person_book_names(request).subscribe(
      (data) => {
        console.log("Success:", data);
        this.isSubmitting = false;  // Reset flag after success
      },
      (error) => {
        console.log("Error:", error);
        this.isSubmitting = false;  // Reset flag on error
      }
    );
  }


  getDataCreditorsOnLoad() {
    this.service.getMainExpenseLedgerForCreditors().subscribe((res) => {
      // console.log(res);
      this.mainExpData1 = res;

      const defaultExpense = this.mainExpData1.find(exp => exp.exp_name === 'पुरवठादार देणी');

      if (defaultExpense) {
        this.kharedi.get('expnameother').setValue(defaultExpense.id);
        // Or if using ngModel:
        this.creditors = defaultExpense.id;
      }
      this.getMainExpNameForCreditors(defaultExpense.id)
    });
  }

  public demo1BtnClick11(tabCount: any) {

    this.demo1TabIndex = Number(tabCount);

  }

  financialYearMin: Date;
  financialYearMax: Date;

  voucherDateControl = new FormControl();

  ngOnInit(): void {

    this.issueForm = this.formBuilder.group({
      issue_name: ['', Validators.required],
      issue_month: ['', Validators.required],
      period_start: ['', Validators.required],
      period_end: ['', Validators.required]
    });

    this.loadPackagesData();

    this.demo1BtnClick11(localStorage.getItem("tab"))
    this.getPermissions();

    // Now you can safely search
    const cvperm = this.permissions.find((p: any) => p.menu_name === "Credit Voucher");
    this.hasCreditVoucherPermission = !!(cvperm && cvperm.can_view);
    this.hasCreditVoucherAddPermission = !!(cvperm && cvperm.can_add);
    this.hasCreditVoucherUpdatePermission = !!(cvperm && cvperm.can_edit);
    this.hasCreditVoucherDeletePermission = !!(cvperm && cvperm.can_delete);

    if (!this.hasCreditVoucherPermission) {
      this.demo1TabIndex = 1; // move to next tab automatically
    }

    const dvperm = this.permissions.find((p: any) => p.menu_name === "Debit Voucher");
    this.hasDebitVoucherPermission = !!(dvperm && dvperm.can_view);
    this.hasDebitVoucherAddPermission = !!(dvperm && dvperm.can_add);
    this.hasDebitVoucherUpdatePermission = !!(dvperm && dvperm.can_edit);
    this.hasDebitVoucherDeletePermission = !!(dvperm && dvperm.can_delete);

    if (!this.hasDebitVoucherPermission) {
      this.demo1TabIndex = 2; // move to next tab automatically
    }

    const jvperm = this.permissions.find((p: any) => p.menu_name === "Journal Voucher");
    this.hasJournalVoucherViewPermission = !!(jvperm && jvperm.can_view);
    this.hasJournalVoucherAddPermission = !!(jvperm && jvperm.can_add);
    this.hasJournalVoucherUpdatePermission = !!(jvperm && jvperm.can_edit);
    this.hasJournalVoucherDeletePermission = !!(jvperm && jvperm.can_delete);

    const creditorsperm = this.permissions.find((p: any) => p.menu_name === "Creditors");
    this.hasCreditorsViewPermission = !!(creditorsperm && creditorsperm.can_view);
    this.hasCreditorsAddPermission = !!(creditorsperm && creditorsperm.can_add);
    this.hasCreditorsUpdatePermission = !!(creditorsperm && creditorsperm.can_edit);
    this.hasCreditorsDeletePermission = !!(creditorsperm && creditorsperm.can_delete);

    const bankReportperm = this.permissions.find((p: any) => p.menu_name === "Bank Report");
    this.hasBankReportViewPermission = !!(bankReportperm && bankReportperm.can_view);

    const recoperm = this.permissions.find((p: any) => p.menu_name === "Reconsilation Report");
    this.hasBankRecoViewPermission = !!(recoperm && recoperm.can_view);
    this.hasBankRecoAddPermission = !!(recoperm && recoperm.can_add);
    this.hasBankRecoUpdatePermission = !!(recoperm && recoperm.can_edit);
    this.hasBankRecoDeletePermission = !!(recoperm && recoperm.can_delete);

    const recoReportperm = this.permissions.find((p: any) => p.menu_name === "Bank Reco Report");
    this.hasBankRecoReportViewPermission = !!(recoReportperm && recoReportperm.can_view);

    const expenseMasterperm = this.permissions.find((p: any) => p.menu_name === "Expense Master");
    this.hasExpenseMasterAddPermission = !!(expenseMasterperm && expenseMasterperm.can_add);
    this.hasExpenseMasterUpdatePermission = !!(expenseMasterperm && expenseMasterperm.can_edit);
    this.hasExpenseMasterDeletePermission = !!(expenseMasterperm && expenseMasterperm.can_delete);

    const ExpenseReportperm = this.permissions.find((p: any) => p.menu_name === "Expense Report");
    this.hasExpenseReportViewPermission = !!(ExpenseReportperm && ExpenseReportperm.can_view);

    const trialBalRepoPerm = this.permissions.find((p: any) => p.menu_name === "Trial Balance");
    this.hasTrialBalRepoViewPermission = !!(trialBalRepoPerm && trialBalRepoPerm.can_view);

    const profitLossRepoPerm = this.permissions.find((p: any) => p.menu_name === "Profit-Loss Account");
    this.hasProfitLossRepoViewPermission = !!(profitLossRepoPerm && profitLossRepoPerm.can_view);

    const balanceSheetRepoPerm = this.permissions.find((p: any) => p.menu_name === "Balance Sheet");
    this.hasBalanceSheetRepoViewPermission = !!(balanceSheetRepoPerm && balanceSheetRepoPerm.can_view);

    const depositSlipRepoPerm = this.permissions.find((p: any) => p.menu_name === "Deposit-Slip Account");
    this.hasDepositSlipRepoViewPermission = !!(depositSlipRepoPerm && depositSlipRepoPerm.can_view);

    const packageManagerPerm = this.permissions.find((p: any) => p.menu_name === "Package Manager");
    this.hasPackageManagerAddPermission = !!(packageManagerPerm && packageManagerPerm.can_add);
    this.hasPackageManagerUpdatePermission = !!(packageManagerPerm && packageManagerPerm.can_edit);

    const subMonthlyRepoPerm = this.permissions.find((p: any) => p.menu_name === "Subscription Monthly Report");
    this.hasSubMonthlyRepoViewPermission = !!(subMonthlyRepoPerm && subMonthlyRepoPerm.can_view);

    const start = sessionStorage.getItem('startDate'); // e.g. "2025-04-01"
    const end = sessionStorage.getItem('endDate');     // e.g. "2026-03-31"

    this.financialYearMin = start ? new Date(start) : new Date('1900-01-01');
    this.financialYearMax = end ? new Date(end) : new Date('2099-12-31');

    this.generateFinancialMonths(start, end);

    // this.demo1BtnClick11(localStorage.getItem("tab"))

    this.getJournalVoucherList();
    this.getBooksList();

    this.repledger.get('department_type')?.setValue([...this.departmentTypes]);

    this.service.getMainExpenseLedger().subscribe((res) => {
      // console.log(res);
      this.mainExpData = res;
      this.filteredMainExpData = res;
      this.filteredMainExpDataForCV = res;
      this.loadMainExpData();

    });
    this.service.getMainExpenseLedger1().subscribe((res) => {
      // console.log(res);
      this.mainExpData101 = res;
    });

    this.getDataCreditorsOnLoad();
    this.service.getIssuesellersname().subscribe((data) => {
      this.issue_seller_name = data;

      // Set default value here (e.g., first rep)
      const defaultRep = this.issue_seller_name.find(rep => rep.name === 'कार्यालय लेखा विभाग') || this.issue_seller_name[0];
      if (defaultRep) {
        this.debitForm.get('rname')?.setValue(defaultRep.name);
      }

      // console.log('issue_seller_name', this.issue_seller_name);
    });
    // console.log(new Date().getDate());
    // console.log(new Date().getHours());
    // console.log(new Date().getMinutes());
    // console.log(formatDate(new Date(), 'dd-MM-yyyy', 'en-IN', 'GMT+0530'));

    this.service.getAdvtCategory().subscribe((data) => {
      // console.log('Database data', data);
      this.advtCategorylist = data;
    });

    // this.service.getPackageBookingData().subscribe((data) => {
    //   this.pkgBookingData = data;
    //   this.FilteredpkgBookingData = this.pkgBookingData;

    //   for (
    //     let index = 0;
    //     index < Object.keys(this.FilteredpkgBookingData).length;
    //     index++
    //   ) {
    //     this.pkgBookingnames.push({
    //       pkg_name: this.FilteredpkgBookingData[index]['pkg_name'],
    //     });

    //     if (this.FilteredpkgBookingData[index]['rep_name'] != '') {
    //       this.pkgBookingrepnames.push({
    //         rep_name: this.FilteredpkgBookingData[index]['rep_name'],
    //       });
    //     }

    //     // this.pkgBookingoffrepnames.push({
    //     //   off_rep_name: this.FilteredpkgBookingData[index]['off_rep_name'],
    //     // });

    //     if (this.FilteredpkgBookingData[index]['client_name'] != '') {
    //       this.pkgBookingcustnames.push({
    //         cust_name: this.FilteredpkgBookingData[index]['client_name'],
    //       });
    //     }
    //   }

    //   this.pkgBookingnames = this.uniqueid(
    //     this.pkgBookingnames,
    //     (a) => a['pkg_name']
    //   );

    //   this.pkgBookingrepnames = this.uniqueid(
    //     this.pkgBookingrepnames,
    //     (a) => a.rep_name
    //   );

    //   this.pkgBookingcustnames = this.uniqueid(
    //     this.pkgBookingcustnames,
    //     (a) => a.cust_name
    //   );
    // });

    // this.service.getPackageBookingData3().subscribe((data) => {
    //   console.log(data);
    //   this.pkgBookingData3 = data;
    // });

    // this.service.getPackageBookingData5().subscribe((data) => {
    //   console.log(data);
    //   this.pkgBookingData5 = data;
    // });

    // this.getCreditVoucherNextId();

    this.service.getPackageId().subscribe((data) => {
      // console.log(data);
      if (data['id'] === null) {
        this.pkgForm.get('pkgname').setValue('शताब्दी ग्रंथ');
      } else {
        this.pkgForm.get('pkgname').setValue('शताब्दी ग्रंथ');
      }
    });

    // this.getDebitVoucherNextId();

    this.service.getPackageData().subscribe((data) => {
      this.packageData = data;
      console.log(data);

      for (
        let index = 0;
        index < Object.keys(this.packageData).length;
        index++
      ) {
        this.packagenames.push({
          pkgid: this.packageData[index]['pkg_id'],
          pkgname: this.packageData[index]['pkg_name'],
        });
      }
    });

    this.filteredautocom();

    this.creditvoucherForm
      .get('entrydate')
      .setValue(formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530'));

    // this.getAllVouchers();
    this.getAdvtMagDetails();
    // this.getAllCreditVouchers(); // hiding because it is not is use in this component
    this.getAllCreditVoucherList();
    this.getBankNames();
    this.getBankNames1();

    this.getMainExpenseData();
    this.getMainExpenseDataForPackageManager();
    this.getSubExpenseData();

    this.loadIssueList();
    this.loadLekhak();
    this.loadLekhEntryList();

  }

  loadMainExpData() {
    debugger
    this.incomeData = this.mainExpData.filter(item => item.exp_type === 'Income');
    this.expenditureData = this.mainExpData.filter(item => item.exp_type === 'Expenditure');
    this.liabilitiesData = this.mainExpData.filter(item => item.exp_type === 'Liabilities');
    this.assetsData = this.mainExpData.filter(item => item.exp_type === 'Assent');
  }

  // Filter for Main Expense
  filterMainExp(searchValue: string) {
    this.mainExpFilter = searchValue.toLowerCase().trim();
    this.filteredMainExpData = this.mainExpData.filter(exp =>
      exp.exp_name.toLowerCase().includes(this.mainExpFilter)
    );
  }

  filterSubExp(searchValue: string) {
    this.subExpFilter = searchValue.trim().toLowerCase();
    this.filteredSubExpData = this.getDebitSubExpData.filter(exp =>
      exp.sub_exp_name.toLowerCase().includes(this.subExpFilter)
    );
  }

  getPermissions() {
    const storedPermissions = sessionStorage.getItem("permissions");

    if (storedPermissions) {
      try {
        const parsed = JSON.parse(storedPermissions);
        this.permissions = parsed.permissions || []; // ✅ correctly take the array
      } catch (e) {
        console.error("Failed to parse permissions", e);
        this.permissions = [];
      }
    }
  }

  // Filter function: only allow dates within min/max range
  dateFilter = (date: Date | null): boolean => {
    if (!date || !this.financialYearMin || !this.financialYearMax) return false;

    const selectedDate = this.stripTime(date);
    const minDate = this.stripTime(this.financialYearMin);
    const maxDate = this.stripTime(this.financialYearMax);

    return selectedDate >= minDate && selectedDate <= maxDate;
  };

  stripTime(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  // getAllCreditVouchers() {
  //   this.service.getAllCreditVouchersData().subscribe((res) => {
  //     console.log(res);
  //   });
  // }

  // getDebitVoucherNextId(date, type) {
  //   // console.log({ date });

  //   this.service.getDebitVoucherPackageId(date, type).subscribe((res) => {
  //     // console.log({ res });
  //     if (Object.keys(res).length > 0) {
  //       let d = `${('0' + (date.getMonth() + 1)).slice(-2)}${(
  //         '0' + date.getDate()
  //       ).slice(-2)}`;
  //       // console.log('d', d, res[0]['d_voucher_no'].indexOf(d));
  //       let startIndex = res[0]['d_voucher_no'].indexOf(d) + d.length;
  //       // console.log('startIndex', startIndex);
  //       this.debit_voucher_id = parseInt(
  //         res[0]['d_voucher_no'].substring(startIndex)
  //       );
  //       if (isNaN(this.debit_voucher_id)) {
  //         this.debit_voucher_id = 0;
  //       }
  //       // console.log('debit_voucher_id', this.debit_voucher_id);
  //     } else {
  //       this.debit_voucher_id = 0;
  //       // console.log('debit_voucher_id', this.debit_voucher_id);
  //     }
  //   });
  // }

  generateDebitVoucherNo(event) {
    // this.onVoucherDateChange(event);
    let today = new Date(event.target.value);

    this.service.getDebitVoucherPackageId(today, this.debitbanktype).subscribe((res) => {

      if (Object.keys(res).length > 0) {
        const voucherNo = res[0]['d_voucher_no'];
        const parts = voucherNo.split('-');

        if (parts.length === 2) {
          this.debit_voucher_id = parseInt(parts[1], 10);

          if (isNaN(this.debit_voucher_id)) {
            this.debit_voucher_id = 0;
          }
        } else {
          this.debit_voucher_id = 0;
        }
      } else {
        this.debit_voucher_id = 0;
      }

      // ✅ Call `getDebitVoucherNo()` after `debit_voucher_id` is set
      this.getDebitVoucherNo(this.debitbanktype, today);
    });
  }

  generateDebitVoucherNo1(res: any) {
    let today = new Date();
    let bankType = res[0].bank_cash_account;

    this.service.getDebitVoucherPackageId(today, bankType).subscribe((res) => {

      if (Object.keys(res).length > 0) {
        const voucherNo = res[0]['d_voucher_no'];
        const parts = voucherNo.split('-');

        if (parts.length === 2) {
          this.debit_voucher_id = parseInt(parts[1], 10);

          if (isNaN(this.debit_voucher_id)) {
            this.debit_voucher_id = 0;
          }
        } else {
          this.debit_voucher_id = 0;
        }
      } else {
        this.debit_voucher_id = 0;
      }

      // ✅ Call `getDebitVoucherNo()` after `debit_voucher_id` is set
      this.getDebitVoucherNo1(bankType, today, res);
    });
  }


  expense_report() {
    const dialogdata = this.dialog.open(ExpenseledgerComponent, {
      data: {
        startDate: this.expenseledgerStartDate,
        endDate: this.expenseledgerEndDate,
        mainexp: this.expenseledger1.value.expnameother,
        subexp: this.expenseledger1.value.subexpnameother,
        mainexp1: this.expenseledger1.value.expnameotherd,
        subexp1: this.expenseledger1.value.subexpnameotherd,

      },

      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
    dialogdata.afterClosed().subscribe(result => {
      this.ngOnInit();

    });
    console.log(this.expenseledger1.value)
  }

  isExpenseReportDialogOpen = false;

  expense_report_new() {
    // Guards against a second overlapping dialog if this fires twice in a row
    // (e.g. Enter inside the form plus a click on "Get Report").
    if (this.isExpenseReportDialogOpen) {
      return;
    }

    const subCtrl = this.expenseledger1.get('subexpnameother');

    // Case: sub expense is required and not selected
    if (this.subexpense && (!subCtrl?.value || subCtrl.value === '')) {
      alert('Please select sub expense');
      return;
    }

    this.isExpenseReportDialogOpen = true;

    const dialogdata = this.dialog.open(ExpenseLedgerReportComponent, {
      data: {
        startDate: this.expenseledgerStartDate,
        endDate: this.expenseledgerEndDate,
        mainexp: this.expenseledger1.value.expnameother,
        subexp: this.expenseledger1.value.subexpnameother,
      },
      width: '1300px',
      height: '1300px',
      maxWidth: '100%',
    });
    dialogdata.afterClosed().subscribe(result => {
      this.isExpenseReportDialogOpen = false;
      this.ngOnInit();
    });
  }

  generateReport() {
    const reportType = this.trialbalance.get('reportType')?.value;

    if (reportType === 'v_report') {
      this.trial_balance_report(); // Call method for विस्तृत अहवाल
    } else if (reportType === 's_report') {
      this.trial_balance_report1(); // Call method for संक्षिप्त अहवाल
    }
  }

  compareExpense(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  }


  trial_balance_report() {
    const dialogdata = this.dialog.open(TrialBalanceComponent, {
      data: {
        startDate: this.trialBalanceStartDate,
        endDate: this.trialBalanceEndDate,
        reportType: this.trialbalance.value.reportType
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
    dialogdata.afterClosed().subscribe(result => {
      this.ngOnInit();

    });
    console.log(this.expenseledger1.value)
  }

  trial_balance_report1() {
    const dialogdata = this.dialog.open(TrialBalanceNewComponent, {
      data: {
        startDate: this.trialBalanceStartDate,
        endDate: this.trialBalanceEndDate,
        reportType: this.trialbalance.value.reportType
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
    dialogdata.afterClosed().subscribe(result => {
      this.ngOnInit();

    });
    console.log(this.expenseledger1.value)
  }

  deposit_slip_report() {
    const dialogdata = this.dialog.open(DepositSlipReportComponent, {
      data: {
        startDate: this.depositSlipStartDate,
        endDate: this.depositSlipEndDate
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
    dialogdata.afterClosed().subscribe(result => {
      this.ngOnInit();

    });
  }

  _balance_sheet() {
    this.dialog.open(BalanceSheetComponent, {
      data: {
        startDate: this.balanceSheetStartDate,
        endDate: this.balanceSheetEndDate
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
      disableClose: true
    });
  }

  generateBankRecoReport() {
    const reportType = this.bankReco.get('reportType')?.value;

    if (reportType === 'v_report') {
      this.bank_reco_report(); // Call method for विस्तृत अहवाल
    } else if (reportType === 's_report') {
      this.bank_reco_report1(); // Call method for संक्षिप्त अहवाल
    }
  }

  generateSubscriptionMonthwiseReport() {

    const dialogdata = this.dialog.open(AccSubscriptionMonthwiseReportComponent, {
      data: {
        startDate: this.subscriptionStartDate,
        endDate: this.subscriptionEndDate,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
    dialogdata.afterClosed().subscribe(result => {
      this.ngOnInit();
    });

  }

  generatePackageReport() {

    const dialogdata = this.dialog.open(PackageReportComponent, {
      data: {
        startDate: this.packageStartDate,
        endDate: this.packageEndDate,
        selectedPackageId: this.package.value.selectedPackage  // Passing the selected package ID
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
    dialogdata.afterClosed().subscribe(result => {
      this.ngOnInit();
    });

  }

  bank_reco_report() {
    const dialogdata = this.dialog.open(RecoBriefReportComponent, {
      data: {
        startDate: this.bankRecoStartDate,
        endDate: this.bankRecoEndDate,
        bankType: this.selectedRCSBank1
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
    dialogdata.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }

  bank_reco_report1() {
    const dialogdata = this.dialog.open(BankRecoInBriefReportComponent, {
      data: {
        startDate: this.bankRecoStartDate,
        endDate: this.bankRecoEndDate,
        bankType: this.selectedRCSBank1
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
    dialogdata.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }

  profit_loss_report() {
    const dialogdata = this.dialog.open(ExpenditureIncomeReportComponent, {
      data: {
        startDate: this.profitLossStartDate,
        endDate: this.profitLossEndDate
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
    dialogdata.afterClosed().subscribe(result => {
      this.ngOnInit();

    });
  }

  ExpenseEedgeCvDvReport() {
    const subexp = this.expenseledger2.value.subexpnameother.filter((value) => value !== 'all');
    const dialogdata = this.dialog.open(SubexpcvdvreportComponent, {
      data: {
        startDate: this.expenseledger2.value.start,
        endDate: this.expenseledger2.value.end,
        mainexp: this.expenseledger2.value.expnameother,
        subexp: subexp,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });

    dialogdata.afterClosed().subscribe((result) => {
      this.ngOnInit();
    });

    console.log(this.expenseledger2.value);
  }

  expenseledger4StartDate = '';
  expenseledger4EndDate = '';
  expenseledger4DateRange() {
    if (
      this.expenseledger4.get('start').value != null &&
      this.expenseledger4.get('end').value != null
    ) {
      this.expenseledger4StartDate = formatDate(
        this.expenseledger4.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      this.expenseledger4EndDate = formatDate(
        this.expenseledger4.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );
    }
  }

  ExpenseOpeningBalanceReport() {
    const dialogdata = this.dialog.open(ExpenseOpeningBalanceReportComponent, {
      data: {
        startDate: this.expenseledger4StartDate,
        endDate: this.expenseledger4EndDate,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });

    dialogdata.afterClosed().subscribe(() => {
      this.ngOnInit();
    });
  }

  onDateRangeInput() {
    // You can add extra logic here, like parsing and validating the dates
    const value = this.profitloss.get('dateRange')?.value;
    if (value) {
      const dates = value.split('-');
      // Further date validation can be done here if needed
    }
  }

  journal_report() {
    console.log(this.expenReportStartDate11);
    console.log(this.expenReportEndDate11);
    const dialogdata = this.dialog.open(JournaledgerlvoucherComponent, {
      data: {
        startDate: this.expenReportStartDate11,
        endDate: this.expenReportEndDate11,
      },

      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
    dialogdata.afterClosed().subscribe(result => {
      this.ngOnInit();

    });
    console.log(this.expenseledger1.value)
  }

  // getCreditVoucherNextId(date, type) {
  //   // console.log(date);
  //   this.service.getCreditVoucherId(date, type).subscribe((data) => {
  //     let dateObject = new Date(date);
  //     if (Object.keys(data).length > 0) {
  //       // console.log('id', this.id);
  //       let d = `${('0' + (dateObject.getMonth() + 1)).slice(-2)}${(
  //         '0' + dateObject.getDate()
  //       ).slice(-2)}`;
  //       let startIndex = data[0]['voucher_no'].indexOf(d) + d.length;
  //       this.id = parseInt(data[0]['voucher_no'].substring(startIndex));
  //       // this.id = 0;
  //       this.getCreditVoucherNo(dateObject);
  //     } else {
  //       this.id = 0;
  //       this.getCreditVoucherNo(dateObject);
  //       // console.log('id', this.id);
  //     }
  //     // console.log('id', this.id);
  //   });
  // }

  getCreditVoucherNextId(date, type) {
    this.service.getCreditVoucherId(date, type).subscribe((data: { id: number; voucher_no: string }[]) => {
      let dateObject = new Date(date);

      if (data.length > 0) {
        // Extract last 2 digits (sequence)
        let lastVoucher = data[0]['voucher_no'];
        let seq = parseInt(lastVoucher.slice(-2)); // assuming 2-digit sequence
        this.id = seq;
      } else {
        this.id = 0;
      }

      this.getCreditVoucherNo(dateObject);
    });
  }

  getBankNames() {
    this.service.read_bank_names().subscribe((data) => {
      // console.log(data);
      if (data) {
        this.BankData = data;
        this.RCSBankData = data.filter((a) => a['bank_short_name'] !== 'CASH');
      }
    });
  }

  getBankNames1() {
    this.service.read_bank_names1().subscribe((data) => {
      // console.log(data);
      if (data) {
        this.BankData1 = data;

        this.BankDataForBankReco = data.filter(item => item.short_name !== 'CASH');
        console.log(this.BankData1, "bank detaolks")
        // this.RCSBankData = data.filter((a) => a['bank_short_name'] !== 'CASH');
      }
    });
  }

  selectBankByCode(code: string) {
    const matchedBank = this.BankData1.find(bank => bank.bank_code === code?.trim());
    if (matchedBank) {
      this.creditvoucherForm.get('bcaccount')?.setValue(matchedBank.short_name);
      this.getBankCash({ value: matchedBank.short_name });
    } else {
      alert('Bank code not found!');
    }
  }

  selectBankByCode1(code: string) {
    const matchedBank = this.BankData1.find(bank => bank.bank_code?.toLowerCase() === code?.trim().toLowerCase());

    if (matchedBank) {
      this.debitForm.get('bcaccount')?.setValue(matchedBank.short_name);
      this.getBankCashDebit({ value: matchedBank.short_name });
    } else {
      alert('Bank code not found!');
    }
  }

  filteredautocom() {
    this.filteredOptions1 = this.creditvoucherForm
      .get('rname')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.name)),
        map((name) =>
          name ? this._filter1(name) : this.issue_seller_name.slice()
        )
      );

    this.filteredOptions2 = this.pkgForm.get('pkgname').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.pkgname)),
      map((pkgname) =>
        pkgname ? this._filter2(pkgname) : this.packagenames.slice()
      )
    );

    this.filteredOptions3 = this.pkgBookingregisterForm
      .get('pkg_name')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.pkg_name)),
        map((pkg_name) =>
          pkg_name ? this._filter3(pkg_name) : this.pkgBookingnames.slice()
        )
      );

    this.filteredOptions4 = this.debitForm.get('rname').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.rep_name)),
      map((rep_name) =>
        rep_name ? this._filter1(rep_name) : this.issue_seller_name.slice()
      )
    );

    this.filteredOptions5 = this.repledger.get('repname').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.rep_name)),
      map((rep_name) =>
        rep_name ? this._filter5(rep_name) : this.issue_seller_name.slice()
      )
    );
  }

  private _filter1(name: string): any[] {
    const filterValue = name.toLowerCase();

    return this.issue_seller_name.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter5(name: string): any[] {
    const filterValue = name.toLowerCase();

    return this.issue_seller_name.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter2(pkgname: string): any[] {
    const filterValue = pkgname.toLowerCase();

    return this.packagenames.filter((option) =>
      option.pkgname.toLowerCase().includes(filterValue)
    );
  }

  private _filter3(pkg_name: string): any[] {
    const filterValue = pkg_name.toLowerCase();

    return this.pkgBookingnames.filter((option) =>
      option.pkg_name.toLowerCase().includes(filterValue)
    );
  }

  // private _filter4(rep_name: string): any[] {
  //   const filterValue = rep_name.toLowerCase();

  //   return this.pkgBookingrepnames.filter((option) =>
  //     option.rep_name.toLowerCase().includes(filterValue)
  //   );
  // }

  cashtype = true;
  bankType = '';
  getBankCash(event) {
    if (!this.hasCreditVoucherAddPermission) {
      alert("You don't have permission to Add Credit Voucher!!!");
      this.creditvoucherForm.get('bcaccount').setValue(null);
      return;
    }
    this.bankType = event.value;

    this.cashtype = true;
    if (event.value === 'CASH') this.cashtype = false;
    this.creditvoucherForm.get('bcaccount').valueChanges.subscribe((val) => {
      if (event.value === 'CASH') {
        this.creditvoucherForm.controls['cnumber'].setValidators([
          Validators.required,
        ]);
      } else {
        this.creditvoucherForm.controls['cnumber'].clearValidators();
      }
      this.creditvoucherForm.controls['cnumber'].updateValueAndValidity();
    });
    // console.log(this.cashtype);
    this.check();

    if (!this.cashtype) {
      this.creditvoucherForm.get('cnumber')?.disable();
      this.creditvoucherForm.get('chequedate')?.disable();
      this.creditvoucherForm.get('bank')?.disable();
      this.creditvoucherForm.get('branch')?.disable();
    } else {
      this.creditvoucherForm.get('cnumber')?.enable();
      this.creditvoucherForm.get('chequedate')?.enable();
      this.creditvoucherForm.get('bank')?.enable();
      this.creditvoucherForm.get('branch')?.enable();
    }
  }

  generateVoucherNo(event) {
    // console.log(event.target.value);
    // console.log(this.creditvoucherForm.get('voucherdate').value);
    let today = new Date(event.target.value);
    let formattedDate = formatDate(today, 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
    console.log(formattedDate, "date format ")

    this.getCreditVoucherNextId(formattedDate, this.bankType);
    // this.getCreditVoucherNo(today);
  }

  onVoucherDateBlur1(event: Event): void {

    const dateStr = this.creditvoucherForm.get('voucherdate')?.value;
    if (!dateStr) return;

    if (dateStr) {
      this.creditvoucherForm.get('chequedate')?.setValue(dateStr);
    }

    const bank = this.creditvoucherForm.get('bcaccount')?.value;
    this.getMissingCVNumbers(dateStr, bank);

    const selectedDate = new Date(dateStr);
    const min = new Date(this.financialYearMin);
    const max = new Date(this.financialYearMax);

    if (selectedDate < min || selectedDate > max) {
      alert('Date is outside the allowed range.');
      this.creditvoucherForm.get('voucherdate')?.setValue(null);
    }

    const input = (event.target as HTMLInputElement).value;
    const year = new Date(input).getFullYear();

    if (year < 1900 || year > 2099) {
      alert('❌ Invalid year! Please enter a year between 1900 and 2099.');
      this.creditvoucherForm.get('voucherdate')?.setValue(null);
    } else {
      this.generateVoucherNo(event); // Call your original method if needed
    }
  }

  onChequeDateBlurForCV(): void {

    debugger
    const chequeDateStr = this.creditvoucherForm.get('chequedate')?.value;
    const voucherDateStr = this.creditvoucherForm.get('voucherdate')?.value;

    console.log('Cheque date on blur:', chequeDateStr);

    if (!chequeDateStr || !voucherDateStr) return;

    const chequeDate = new Date(chequeDateStr);
    const voucherDate = new Date(voucherDateStr);

    // Check 1: Cheque date cannot be after voucher date
    if (chequeDate > voucherDate) {
      alert('Cheque date cannot be after voucher date');
      this.creditvoucherForm.get('chequedate')?.setValue(voucherDateStr);
      return;
    }

    // Check 2: Cheque date must not be more than 3 months before voucher date
    const threeMonthsBefore = new Date(voucherDate);
    threeMonthsBefore.setMonth(threeMonthsBefore.getMonth() - 3);

    if (chequeDate < threeMonthsBefore) {
      alert('Cheque date cannot be more than 3 months before voucher date');
      this.creditvoucherForm.get('chequedate')?.setValue(voucherDateStr);
    }
  }

  onChequeDateBlurForDV(): void {
    const chequeDateStr = this.debitForm.get('chequedate')?.value;
    const voucherDateStr = this.debitForm.get('dvoucherdate')?.value;

    if (!chequeDateStr || !voucherDateStr) return;

    const chequeDate = new Date(chequeDateStr);
    const voucherDate = new Date(voucherDateStr);

    // Check 1: Cheque date should not be after voucher date
    if (chequeDate > voucherDate) {
      alert('Cheque date cannot be after voucher date');
      this.debitForm.get('chequedate')?.setValue(voucherDateStr);
      return;
    }

    // Check 2: Cheque date should not be more than 3 months before voucher date
    const threeMonthsBefore = new Date(voucherDate);
    threeMonthsBefore.setMonth(threeMonthsBefore.getMonth() - 3);

    if (chequeDate < threeMonthsBefore) {
      alert('Cheque date cannot be more than 3 months before voucher date');
      this.debitForm.get('chequedate')?.setValue(voucherDateStr);
    }
  }

  onVoucherDateBlur(event: Event): void {

    const voucherDate = this.debitForm.get('dvoucherdate')?.value;
    const bank = this.debitForm.get('bcaccount')?.value;
    console.log('Voucher Date on blur:', voucherDate);

    this.getMissingDVNumbers(voucherDate, bank);

    if (voucherDate) {
      this.debitForm.get('chequedate')?.setValue(voucherDate);
    }

    // Optional validation
    if (voucherDate) {
      const enteredDate = new Date(voucherDate);
      const minDate = new Date(this.financialYearMin);
      const maxDate = new Date(this.financialYearMax);

      if (enteredDate < minDate || enteredDate > maxDate) {
        alert('Voucher date is outside the allowed financial year range');
        this.debitForm.get('dvoucherdate')?.setValue(null);
      }
    }

    const value = (event.target as HTMLInputElement).value;
    if (!value) return;

    const year = new Date(value).getFullYear();

    if (year < 1900 || year > 2099) {
      alert('❌ Invalid year! Please enter a year between 1900 and 2099.');
      this.debitForm.get('dvoucherdate')?.setValue(null);
    } else {
      this.generateDebitVoucherNo(event); // Only call if valid
    }
  }

  // getCreditVoucherNo(today) {
  //   setTimeout(() => {
  //     console.log('id', this.id);
  //     let voucherNo = `${this.vouchervalue}${this.bankType}${(
  //       '0' +
  //       (today.getMonth() + 1)
  //     ).slice(-2)}${('0' + today.getDate()).slice(-2)}${this.id < 9 ? '0' + (parseInt(this.id) + 1) : this.id + 1
  //       }`;
  //     this.creditvoucherForm.get('vnumber').setValue(voucherNo);
  //   }, 200);
  // }

  getCreditVoucherNo(today) {
    setTimeout(() => {
      const year = today.getFullYear();
      const month = ('0' + (today.getMonth() + 1)).slice(-2);
      const day = ('0' + today.getDate()).slice(-2);
      const sequence = this.id < 9 ? '0' + (this.id + 1) : (this.id + 1);

      let voucherNo = `${this.vouchervalue}${this.bankType}${year}${month}${day}-${sequence}`;
      this.creditvoucherForm.get('vnumber').setValue(voucherNo);
    }, 200);
  }


  // getCreditVoucherNo(today) {
  //   setTimeout(() => {
  //     console.log('id before increment', this.id);
  //     this.id = parseInt(this.id) + 1; // Increment id by 1
  //     console.log('id after increment', this.id);

  // //     // Calculate financial year in "YY-YY" format
  // //     let currentYear = today.getFullYear();
  // //     let currentMonth = today.getMonth() + 1; // Month is zero-based
  // //     let financialYear;

  // //     // Financial year starts in April
  // //     if (currentMonth >= 4) {
  // //       let nextYear = currentYear + 1;
  // //       financialYear = `${currentYear % 100}-${nextYear % 100}`;
  // //     } else {
  // //       let lastYear = currentYear - 1;
  // //       financialYear = `${lastYear % 100}-${currentYear % 100}`;
  // //     }

  // //     // Generate the voucher number with only month and financial year
  // //     let voucherNo = `${this.vouchervalue}${this.bankType}${(
  // //       '0' + currentMonth
  // //     ).slice(-2)}${financialYear}/${
  // //       this.id < 10 ? '0' + this.id : this.id
  // //     }`;

  // //     // Set the voucher number in the form
  // //     this.creditvoucherForm.get('vnumber').setValue(voucherNo);
  // //   }, 200);
  // // }
  // // getCreditVoucherNo(today) {
  // //   setTimeout(() => {
  // //     console.log('id before increment', this.id);
  // //     this.id = parseInt(this.id) + 1; // Increment id by 1
  // //     console.log('id after increment', this.id);

  // //     // Calculate financial year in "YY-YY" format
  // //     let currentYear = today.getFullYear();
  // //     let currentMonth = today.getMonth() + 1; // Month is zero-based
  // //     let financialYear;

  // //     // Adjust financial year logic
  // //     if (currentMonth >= 4) {
  // //       // From April to December, financial year is currentYear-nextYear
  // //       let nextYear = currentYear + 1;
  // //       financialYear = `${currentYear % 100}-${nextYear % 100}`;
  // //     } else {
  // //       // From January to March, financial year is currentYear-nextYear
  // //       let nextYear = currentYear + 1;
  // //       financialYear = `${currentYear % 100}-${nextYear % 100}`;
  // //     }

  // //     // Generate the voucher number with only month and financial year
  // //     let voucherNo = `${this.vouchervalue}${this.bankType}${(
  // //       '0' + currentMonth
  // //     ).slice(-2)}${financialYear}/${
  // //       this.id < 10 ? '0' + this.id : this.id
  // //     }`;

  // //     // Set the voucher number in the form
  // //     this.creditvoucherForm.get('vnumber').setValue(voucherNo);
  // //   }, 200);
  // }







  debitbanktype = '';
  getBankCashDebit(event) {
    if (!this.hasDebitVoucherAddPermission) {
      alert("You don't have permission to Add Debit Voucher!!!");
      this.debitForm.get('bcaccount').setValue(null);
      return;
    }
    this.debitbanktype = event.value;
  }

  // generateDebitVoucherNo(event) {

  //   let today = new Date(event.target.value);
  //   this.getDebitVoucherNextId(today, this.debitbanktype);

  //   // Delay execution to allow `this.debit_voucher_id` to be set
  //   setTimeout(() => {
  //     this.getDebitVoucherNo(this.debitbanktype, today);
  //   }, 800);
  //   // this.getDebitVoucherNo(this.debitbanktype, today);
  // }

  // getDebitVoucherNo(type, today) {

  //   setTimeout(() => {
  //     // console.log('this.debit_voucher_id ', this.debit_voucher_id);

  //     let voucherNo = `DR${type}${('0' + (today.getMonth() + 1)).slice(-2)}${(
  //       '0' + today.getDate()
  //     ).slice(-2)}${this.debit_voucher_id < 9
  //       ? '0' + (parseInt(this.debit_voucher_id) + 1)
  //       : this.debit_voucher_id + 1
  //       }`;
  //     // console.log(voucherNo);
  //     this.debitForm.get('dvnumber').setValue(voucherNo);
  //   }, 200);
  // }

  getDebitVoucherNo(type, today) {
    setTimeout(() => {
      const year = today.getFullYear();
      const month = ('0' + (today.getMonth() + 1)).slice(-2);
      const day = ('0' + today.getDate()).slice(-2);
      const nextId = this.debit_voucher_id + 1;
      const increment = nextId < 10 ? '0' + nextId : nextId;

      const voucherNo = `DR${type}${year}${month}${day}-${increment}`;

      this.debitForm.get('dvnumber').setValue(voucherNo);
    }, 200);
  }

  getDebitVoucherNo1(type, today, res: any) {
    setTimeout(() => {
      const year = today.getFullYear();
      const month = ('0' + (today.getMonth() + 1)).slice(-2);
      const day = ('0' + today.getDate()).slice(-2);
      const nextId = this.debit_voucher_id + 1;
      const increment = nextId < 10 ? '0' + nextId : nextId;

      const voucherNo = `DR${type}${year}${month}${day}-${increment}`;

      let data = {
        bcaccount: res[0].bank_cash_account,
        dvnumber: voucherNo,
        dvoucherdate: new Date().toISOString().split('T')[0],
        rname: res[0].rep_name,
        othername: res[0].other_name,
        // exp_amt: this.debitForm.get('exp_amt').value,
        chequeno: res[0].cheque_no,
        chequedate: res[0].cheque_date,
        totalexp: res[0].deposit_amt,
      };

    }, 200);
  }

  getAdvtMagDetails() {
    this.advt_mag_name_details = [];
    // this.stateGroups = [];
    let abc;
    this.service.getAdvtMagNames().subscribe((data) => {
      // console.log(data);
      for (let index = 0; index < Object.keys(data).length; index++) {
        // console.log(data[index]);
        this.advt_mag_name_details.push({
          id: data[index]['id'],
          is_active: data[index]['is_active'],
          issue_name: data[index]['issue_name'],
          category: data[index]['category'],
          publishing_date: data[index]['publishing_date'].split(','),
        });

        if (index == 0) {
          // console.log(
          //   data.filter((a) => a.category == data[index]['category'])
          // );
        }
      }
    });
  } //end of getAdvtMagDetails

  issueName;
  bookingdate;
  advtsizebyCategory;
  getFilterMagPublishDates = ['10-10-2021', ''];
  getMagIssueDatesandNames;
  getIssues(e) {
    // console.log(e);
    this.issueName = e.value;
    // console.log('jgfdfgh', this.issueName);
    this.service.getAdvtSizeByCategory(e.value).subscribe((data) => {
      this.advtsizebyCategory = data;
    });

    // console.log(
    //   'advt_mag_name_details',
    //   this.advt_mag_name_details.filter((a) => a.issue_name == this.issueName)
    // );
    this.service.getAdvtDatesAndNames(e.value).subscribe((data) => {
      this.getMagIssueDatesandNames = data;
      // console.log('Issue Dates and Names:', this.getMagIssueDatesandNames);
    });
  }

  getDates;
  stringdates;
  getAdvtDates(e) {
    // console.log(e.value.toString());
    this.getDates = e.value;
    this.getDates = this.getDates.filter((a) => a != 'all');
    // console.log('getDates', this.getDates);
    this.stringdates = this.getDates.toString();
    // console.log('StringDates', this.stringdates);
  }

  allSelected = false;
  @ViewChild('mySel') skillSel: MatSelect;
  toggleAllSelection() {
    this.allSelected = !this.allSelected; // to control select-unselect
    // console.log(this.skillSel.options);
    if (this.allSelected) {
      this.skillSel.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSel.close();
  }

  allSelected1 = false;
  @ViewChild('mySel1') skillSel1: MatSelect;
  toggleAllSelection1() {
    this.allSelected1 = !this.allSelected1; // to control select-unselect
    // console.log(this.skillSel1.options);
    if (this.allSelected1) {
      this.skillSel1.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel1.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSel1.close();
  }

  allSelected2 = false;
  @ViewChild('mySel2') skillSel2: MatSelect;
  toggleAllSelection2() {
    this.allSelected2 = !this.allSelected2; // to control select-unselect
    // console.log(this.skillSel2.options);
    if (this.allSelected2) {
      this.skillSel2.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel2.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSel2.close();
  }

  allSelected3 = false;
  @ViewChild('mySel3') skillSel3: MatSelect;
  toggleAllSelection3() {
    this.allSelected3 = !this.allSelected3; // to control select-unselect
    if (this.allSelected3) {
      this.skillSel3.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel3.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSel3.close();
  }

  getAllVouchers() {
    this.service.getAllVouchers().subscribe((data) => {
      // console.log(data);
      this.getallVouchersData = data;
    });
  }

  deleteVoucherId(voucher_no) {
    if (window.confirm('Do you really want to delete this voucher?')) {
      this.service.updateVoucherStatus(voucher_no).subscribe((data) => {
        // console.log(data);
        this.getAllVouchers();
      });
    }
  }

  submitAdd() {
    window.alert('Started Generating the vouchers...');
    for (
      let index = 0;
      index < Object.keys(this.departmentSelection).length;
      index++
    ) {
      if (this.departmentSelection[index] == 'book') {
        this.service
          .insertCreditVoucher(
            this.vouchernumber,
            this.departmentSelection[index],
            this.ionicForm.get('bookcomment').value,
            this.ionicForm.get('bookpayment').value
          )
          .subscribe((data) => {
            console.log(data);
          });
      } else if (this.departmentSelection[index] == 'subscription') {
        this.service
          .insertCreditVoucher(
            this.vouchernumber,
            this.departmentSelection[index],
            this.ionicForm.get('subcomment').value,
            this.ionicForm.get('subpayment').value
          )
          .subscribe((data) => {
            console.log(data);
          });
      } else if (this.departmentSelection[index] == 'advertisement') {
        this.service
          .insertCreditVoucher(
            this.vouchernumber,
            this.departmentSelection[index],
            this.ionicForm.get('advtcomment').value,
            this.ionicForm.get('advtpayment').value
          )
          .subscribe((data) => {
            console.log(data);
          });
      }
    }

    setTimeout(() => {
      window.alert('Vouchers has been generated!');
      this.getAllVouchers();
      this.displaycrform = false;
      this.ionicForm.reset();
    }, 2000);
  }
  // val = [];
  // val1 = [];
  // val2 = [];
  // val3 = [];
  // val4 = [];
  // val5 = [];
  // val6 = [];

  sadd(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.names.push(value);
    }

    // Clear the input value
    if (event.input) {
      event.input.value = '';
    }
  }

  isadd(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // let value1 = [];
    // Add our fruit
    if (value) {
      this.names1.push(value);
    }
    // Clear the input value
    if (event.input) {
      event.input.value = '';
      // this.val1 = [];
    }
  }

  aadd(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.names2.push(value);
    }

    // Clear the input value
    if (event.input) {
      event.input.value = '';
    }
  }
  dadd(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.names3.push(value);
    }

    // Clear the input value
    if (event.input) {
      event.input.value = '';
    }
  }
  gbadd(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.names4.push(value);
    }

    // Clear the input value
    if (event.input) {
      event.input.value = '';
    }
  }
  donadd(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.names5.push(value);
    }

    // Clear the input value
    if (event.input) {
      event.input.value = '';
    }
  }

  odadd(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.names6.push(value);
    }

    // Clear the input value
    // event.chipInput!.clear();
    if (event.input) {
      event.input.value = '';
    }
  }

  remove(fruit): void {
    const index = this.names.indexOf(fruit);
    const index1 = this.names1.indexOf(fruit);
    const index2 = this.names2.indexOf(fruit);
    const index3 = this.names3.indexOf(fruit);
    const index4 = this.names4.indexOf(fruit);
    const index5 = this.names5.indexOf(fruit);
    const index6 = this.names6.indexOf(fruit);

    if (index >= 0) {
      this.names.splice(index, 1);
    }
    if (index1 >= 0) {
      this.names1.splice(index1, 1);
    }
    if (index2 >= 0) {
      this.names2.splice(index2, 1);
    }
    if (index3 >= 0) {
      this.names3.splice(index3, 1);
    }
    if (index4 >= 0) {
      this.names4.splice(index4, 1);
    }
    if (index5 >= 0) {
      this.names5.splice(index5, 1);
    }
    if (index6 >= 0) {
      this.names6.splice(index6, 1);
    }
  }

  amt = 0;
  total(event) {
    let subscription =
      this.creditvoucherForm.get('subscription').value === ''
        ? 0
        : this.creditvoucherForm.get('subscription').value;
    let isale =
      this.creditvoucherForm.get('isale').value === ''
        ? 0
        : this.creditvoucherForm.get('isale').value;
    let adverties =
      this.creditvoucherForm.get('adverties').value === ''
        ? 0
        : this.creditvoucherForm.get('adverties').value;
    let deposits =
      this.creditvoucherForm.get('deposits').value === ''
        ? 0
        : this.creditvoucherForm.get('deposits').value;
    let granthbook =
      this.creditvoucherForm.get('granthbook').value === ''
        ? 0
        : this.creditvoucherForm.get('granthbook').value;
    let donation =
      this.creditvoucherForm.get('donation').value === ''
        ? 0
        : this.creditvoucherForm.get('donation').value;
    let odeposit =
      this.creditvoucherForm.get('odeposit').value === ''
        ? 0
        : this.creditvoucherForm.get('odeposit').value;
    // let value = event.target.value;
    // console.log('value', value);
    this.amt =
      parseFloat(subscription) +
      parseFloat(isale) +
      parseFloat(adverties) +
      parseFloat(deposits) +
      parseFloat(granthbook) +
      parseFloat(donation) +
      parseFloat(odeposit);
    this.creditvoucherForm.get('otheramount').setValue(this.amt);
    this.totalAmt();
    this.totalAmount();
  }

  total_amt = 0;
  totalAmt() {
    // console.log('totalAmt run');
    let pkgamt = 0 + this.creditvoucherForm.get('packageamount')?.value;
    let otheramt = 0 + this.creditvoucherForm.get('otheramount')?.value;
    // console.log(this.creditvoucherForm.get('packageamount')?.value);
    // console.log(this.creditvoucherForm.get('otheramount')?.value);
    this.total_amt = parseFloat(pkgamt) + parseFloat(otheramt);
    // console.log(this.total_amt);

    this.creditvoucherForm.get('total').setValue(this.total_amt);
    this.creditvoucherForm.get('ndeposit').setValue(this.total_amt);
  }

  expamt = 0;
  totalExpense(event) {
    let travels =
      this.creditvoucherForm.get('travels').value === ''
        ? 0
        : this.creditvoucherForm.get('travels').value;
    let other =
      this.creditvoucherForm.get('other').value === ''
        ? 0
        : this.creditvoucherForm.get('other').value;
    let advtcommission =
      this.creditvoucherForm.get('advtcommission').value === ''
        ? 0
        : this.creditvoucherForm.get('advtcommission').value;
    let subscommission =
      this.creditvoucherForm.get('subscommission').value === ''
        ? 0
        : this.creditvoucherForm.get('subscommission').value;
    let issuecommission =
      this.creditvoucherForm.get('issuecommission').value === ''
        ? 0
        : this.creditvoucherForm.get('issuecommission').value;
    let bookcommission =
      this.creditvoucherForm.get('bookcommission').value === ''
        ? 0
        : this.creditvoucherForm.get('bookcommission').value;
    this.expamt =
      parseFloat(travels) +
      parseFloat(other) +
      parseFloat(subscommission) +
      parseFloat(issuecommission) +
      parseFloat(bookcommission) +
      parseFloat(advtcommission);
    this.creditvoucherForm.get('totalexp').setValue(this.expamt);

    if (this.total_amt != 0 && this.expamt != 0) {
      console.log(this.total_amt);

      this.creditvoucherForm
        .get('ndeposit')
        .setValue(this.total_amt - this.expamt);
    }
  }

  expdamt = 0;
  totaldebitExpense() {
    let travels =
      this.debitForm.get('travels').value === ''
        ? 0
        : this.debitForm.get('travels').value;
    let other =
      this.debitForm.get('other').value === ''
        ? 0
        : this.debitForm.get('other').value;
    let advtcommission =
      this.debitForm.get('advtcommission').value === ''
        ? 0
        : this.debitForm.get('advtcommission').value;
    let subscommission =
      this.debitForm.get('subscommission').value === ''
        ? 0
        : this.debitForm.get('subscommission').value;
    let issuecommission =
      this.debitForm.get('issuecommission').value === ''
        ? 0
        : this.debitForm.get('issuecommission').value;
    let bookcommission =
      this.debitForm.get('bookcommission').value === ''
        ? 0
        : this.debitForm.get('bookcommission').value;
    // console.log('bookcommission', bookcommission);
    this.expdamt =
      parseFloat(travels) +
      parseFloat(other) +
      parseFloat(subscommission) +
      parseFloat(issuecommission) +
      parseFloat(bookcommission) +
      parseFloat(advtcommission);
    this.debitForm.get('totalexp').setValue(this.expdamt);
    console.log(this.expdamt);

    // if (this.total_amt != 0 && this.expamt != 0) {
    //   this.creditvoucherForm
    //     .get('ndeposit')
    //     .setValue(this.total_amt - this.expamt);
    // }
  }

  displayadvtinput = false;
  displaybookinput = false;
  displaysubinput = false;
  departmentSelection = [];
  vouchernumber = '';
  getDepartment(event) {
    this.vouchernumber =
      formatDate(new Date(), 'yyyyMMdd', 'en-IN', 'GMT+0530') +
      new Date().getHours() +
      new Date().getMinutes();
    console.log(new Date().getMinutes());
    console.log('vouchernumber', this.vouchernumber);
    this.departmentSelection = event.value;

    if (event.value.find((a) => a == 'book') == 'book') {
      this.displaybookinput = true;
    } else {
      this.displaybookinput = false;
    }

    if (event.value.find((a) => a == 'subscription') == 'subscription') {
      this.displaysubinput = true;
    } else {
      this.displaysubinput = false;
    }

    if (event.value.find((a) => a == 'advertisement') == 'advertisement') {
      this.displayadvtinput = true;
    } else {
      this.displayadvtinput = false;
    }
  }

  save_credit_voucher111() {

  }

  credit_id = 0;
  save_creditvoucher() {

    if (!confirm('Do you want add credit voucher')) {
      return;
    }

    const ndeposit = Number(this.creditvoucherForm.get('ndeposit')?.value);
    const damount = Number(this.creditvoucherForm.get('damount')?.value);

    if (isNaN(ndeposit) || isNaN(damount) || ndeposit !== damount) {
      alert('Please check the amount.');
      return;
    }

    let creditvoucher = {

      entrydate: this.creditvoucherForm.get('entrydate').value,       //enrty date
      vnumber: this.creditvoucherForm.get('vnumber').value,           //voucher number
      bcaccount: this.creditvoucherForm.get('bcaccount').value,       //bank/cash account dropdown
      voucherdate: this.creditvoucherForm.get('voucherdate').value,   //voucher date
      othername: this.creditvoucherForm.get('othername').value,       //narration
      rname: this.creditvoucherForm.get('rname').value,               //representative name
      damount: this.creditvoucherForm.get('damount').value,           //deposit amount
      pymtoptions: this.creditvoucherForm.get('pymtoptions').value,   //payment options
      cnumber: this.creditvoucherForm.get('cnumber').value,           //cheque number
      chequedate: this.creditvoucherForm.get('chequedate').value,     //cheque date
      bank: this.creditvoucherForm.get('bank').value,                 //bank name
      branch: this.creditvoucherForm.get('branch').value,             //branch name

      deposits: this.creditvoucherForm.get('deposits').value,         //deposits
      depositsname: this.creditvoucherForm.get('depositsname').value,         //deposits name
      pancard: this.creditvoucherForm.get('pancard').value,           //pan card number
      narration: this.creditvoucherForm.get('narration').value,       //pan card narration

      odeposit: this.creditvoucherForm.get('odeposit').value,             //other deposit amt
      packagecount: this.creditvoucherForm.get('packagecount').value,     //package count
      packageamount: this.creditvoucherForm.get('packageamount').value,   //package amount
      otheramount: this.creditvoucherForm.get('otheramount').value,       //other amount
      total: this.creditvoucherForm.get('total').value,                   //total
      expenditure: this.creditvoucherForm.get('expenditure').value,       //expenditure amount

      totalexp: this.creditvoucherForm.get('totalexp').value,             //total expense
      ndeposit: this.creditvoucherForm.get('ndeposit').value,             //net deposit

    };

    this.service.insertcreditVoucher(creditvoucher).pipe(

      switchMap(res => {
        this.credit_id = Number(res['id']);

        const apiCalls: any[] = [];

        /* -------------------- PACKAGES -------------------- */
        this.selectedPackages.forEach(pkg => {
          apiCalls.push(
            this.service.insertCrdtPackage({
              crdt_id: this.credit_id,
              pkg_id: pkg.pkg_id,
              pkg_name: pkg.pkg_name,
              pkg_amt: pkg.pkg_amt,
              client_name: pkg.client_name
            }).pipe(
              switchMap(pkgRes => {
                const pkgDetailCalls = [];

                const pkgData = this.packageData.find(p => p.pkg_id === pkg.pkg_id);
                if (!pkgData) return of(null);

                const periodicities = pkgData.periodicity.split(',');

                periodicities.forEach(period => {
                  let details: any = null;

                  if (period === '1 year') {
                    details = {
                      crdt_pkg_details_id: pkgRes['id'],
                      year: '1 year',
                      sub_actual_amt: pkgData.vivek_m_1_actual_amt,
                      sub_concession_amt: pkgData.vivek_m_1_concession_amt,
                      vivek_h_actual_amt: pkgData.vivek_h_1_actual_amt,
                      vivek_h_concession_amt: pkgData.vivek_h_1_concession_amt,
                      vaidyraj_actual_amt: pkgData.vaidyraj_1_actual_amt,
                      vaidyraj_concession_amt: pkgData.vaidyraj_1_concession_amt,
                      granth_actual_amt: pkgData.granth1_1_actual_amt,
                      granth_remaining_amt: pkg.pkg_amt,
                      granth_concession_amt: pkgData.granth1_1_concession_amt,
                      book_actual_amt: pkgData.granth2_1_actual_amt,
                      book_concession_amt: pkgData.granth2_1_concession_amt,
                      donation_actual_amt: pkgData.donation_1_actual_amt,
                      donation_concession_amt: pkgData.donation_1_concession_amt,
                      courier_actual_amt: pkgData.courier_1_actual_amt,
                      courier_concession_amt: pkgData.courier_1_concession_amt,
                      advt_actual_amt: pkgData.advt_1_actual_amt,
                      advt_concession_amt: pkgData.advt_1_concession_amt,
                      other_actual_amt: pkgData.other_1_actual_amt,
                      other_concession_amt: pkgData.other_1_concession_amt,
                    };
                  } else if (period === '3 year') {
                    details = {
                      crdt_pkg_details_id: pkgRes['id'],
                      year: '3 year',
                      sub_actual_amt: pkgData.vivek_m_3_actual_amt,
                      sub_concession_amt: pkgData.vivek_m_3_concession_amt,
                      vivek_h_actual_amt: pkgData.vivek_h_3_actual_amt,
                      vivek_h_concession_amt: pkgData.vivek_h_3_concession_amt,
                      vaidyraj_actual_amt: pkgData.vaidyraj_3_actual_amt,
                      vaidyraj_concession_amt: pkgData.vaidyraj_3_concession_amt,
                      granth_actual_amt: pkgData.granth1_3_actual_amt,
                      granth_remaining_amt: pkg.pkg_amt,
                      granth_concession_amt: pkgData.granth1_3_concession_amt,
                      book_actual_amt: pkgData.granth2_3_actual_amt,
                      book_concession_amt: pkgData.granth2_3_concession_amt,
                      donation_actual_amt: pkgData.donation_3_actual_amt,
                      donation_concession_amt: pkgData.donation_3_concession_amt,
                      courier_actual_amt: pkgData.courier_3_actual_amt,
                      courier_concession_amt: pkgData.courier_3_concession_amt,
                      advt_actual_amt: pkgData.advt_3_actual_amt,
                      advt_concession_amt: pkgData.advt_3_concession_amt,
                      other_actual_amt: pkgData.other_3_actual_amt,
                      other_concession_amt: pkgData.other_3_concession_amt
                    };
                  } else if (period === '5 year') {
                    details = {
                      crdt_pkg_details_id: pkgRes['id'],
                      year: '5 year',
                      sub_actual_amt: pkgData.vivek_m_5_actual_amt,
                      sub_concession_amt: pkgData.vivek_m_5_concession_amt,
                      vivek_h_actual_amt: pkgData.vivek_h_5_actual_amt,
                      vivek_h_concession_amt: pkgData.vivek_h_5_concession_amt,
                      vaidyraj_actual_amt: pkgData.vaidyraj_5_actual_amt,
                      vaidyraj_concession_amt: pkgData.vaidyraj_5_concession_amt,
                      granth_actual_amt: pkgData.granth1_5_actual_amt,
                      granth_remaining_amt: pkg.pkg_amt,
                      granth_concession_amt: pkgData.granth1_5_concession_amt,
                      book_actual_amt: pkgData.granth2_5_actual_amt,
                      book_concession_amt: pkgData.granth2_5_concession_amt,
                      donation_actual_amt: pkgData.donation_5_actual_amt,
                      donation_concession_amt: pkgData.donation_5_concession_amt,
                      courier_actual_amt: pkgData.courier_5_actual_amt,
                      courier_concession_amt: pkgData.courier_5_concession_amt,
                      advt_actual_amt: pkgData.advt_5_actual_amt,
                      advt_concession_amt: pkgData.advt_5_concession_amt,
                      other_actual_amt: pkgData.other_5_actual_amt,
                      other_concession_amt: pkgData.other_5_concession_amt,
                    };
                  }

                  if (details) {
                    pkgDetailCalls.push(
                      this.service.insertCrdtPackageDetails(details)
                    );
                  }
                });

                return pkgDetailCalls.length ? forkJoin(pkgDetailCalls) : of(null);
              })
            )
          );
        });

        /* -------------------- DEPOSITS -------------------- */
        // if (Number(this.creditvoucherForm.get('deposits')?.value) > 0) {
        //   apiCalls.push(
        //     this.service.insertCreditVoucherDepositsNames(
        //       this.credit_id,
        //       this.names3.toString()
        //     )
        //   );
        // }

        /* -------------------- EXPENSES -------------------- */
        apiCalls.push(
          this.service.saveCrdtVoucherAllOtherExpenses({
            voucher_id: this.credit_id,
            expenses: this.selectedMainExpenses1.map(main => ({
              mainexpid: main.mainexpid,
              expamt: main.expamt,
              subexpenses: this.selectedsubExpenses1
                .filter(sub => sub.mainexpid === main.mainexpid)
                .map(sub => ({
                  subexpid: sub.subexpid,
                  expamt: sub.expamt
                }))
            }))
          })
        );

        apiCalls.push(
          this.service.saveCrdtVoucherAllExpExpenses({
            voucher_id: this.credit_id,
            expenses: this.selectedMainExpenses.map(main => ({
              mainexpid: main.mainexpid,
              expamt: main.expamt,
              subexpenses: this.selectedsubExpenses
                .filter(sub => sub.mainexpid === main.mainexpid)
                .map(sub => ({
                  subexpid: sub.subexpid,
                  expamt: sub.expamt
                }))
            }))
          })
        );

        /* -------------------- SUBSCRIPTION -------------------- */
        if (Number(this.creditvoucherForm.get('subscription')?.value) > 0) {
          apiCalls.push(
            this.service.insertCreditVoucherSubscribers({
              crdt_vucher_id: this.credit_id,
              subscription: this.creditvoucherForm.get('subscription')?.value
            }).pipe(
              switchMap(sub =>
                this.service.insertCreditVoucherSubscribersNames(
                  sub['id'],
                  this.names.toString()
                )
              )
            )
          );
        }

        /* -------------------- ADVERTISEMENT -------------------- */
        if (Number(this.creditvoucherForm.get('adverties')?.value) > 0) {
          apiCalls.push(
            this.service.insertCreditVoucherAdvt({
              crdt_vucher_id: this.credit_id,
              adverties: this.creditvoucherForm.get('adverties')?.value
            }).pipe(
              switchMap(advt =>
                this.service.insertCreditVoucherAdvtNames(
                  advt['id'],
                  this.names2.toString()
                )
              )
            )
          );
        }

        /* -------------------- ISSUE SALE -------------------- */
        if (Number(this.creditvoucherForm.get('isale')?.value) > 0) {
          apiCalls.push(
            this.service.insertCreditVoucherIssueSale({
              crdt_vucher_id: this.credit_id,
              isale: this.creditvoucherForm.get('isale')?.value
            }).pipe(
              switchMap(issue =>
                this.service.insertCreditVoucherIssueSaleNames(
                  issue['id'],
                  this.names1.toString()
                )
              )
            )
          );
        }

        /* -------------------- GRANTH BOOK -------------------- */
        if (Number(this.creditvoucherForm.get('granthbook')?.value) > 0) {
          apiCalls.push(
            this.service.insertCreditVoucherBook({
              crdt_vucher_id: this.credit_id,
              granthbook: this.creditvoucherForm.get('granthbook')?.value
            }).pipe(
              switchMap(book =>
                this.service.insertCreditVoucherBookNames(
                  book['id'],
                  this.creditvoucherForm.get('booksellername')?.value,
                  this.creditvoucherForm.get('granthbooknames')?.value
                )
              )
            )
          );
        }

        return apiCalls.length ? forkJoin(apiCalls) : of(null);
      })

    ).subscribe({
      next: () => {
        Swal.fire({
          icon: 'success',
          title: 'Credit Voucher Added Successfully!',
          html: `Voucher No: <b style="color:red;">${this.creditvoucherForm.get('vnumber')?.value}</b>`
        }).then(() => {
          this.creditvoucherForm.reset();
          this.selectedMainExpenses = [];
          this.selectedsubExpenses = [];
          this.selectedMainExpenses1 = [];
          this.selectedsubExpenses1 = [];
          this.selectedPackages = [];
          window.location.reload();
        });
      },
      error: err => {
        console.error(err);
        Swal.fire('Error', 'Error while saving credit voucher', 'error');
      }
    });
  }

  SelectRepresentative() { }

  getAllCreditVoucherList() {
    this.service.getAllCreditVoucherList().subscribe((res) => {
      // console.log(res);
      this.allCreditVoucherListData = res;

      this.totalcrdtvreport = {
        depositamt: 0,
        sub: 0,
        issue: 0,
        advt: 0,
        deposit: 0,
        book: 0,
        pkg_amt: 0,
        donation: 0,
        other_deposit: 0,
        // travel: 0,
        // other: 0,
        // sub_com: 0,
        // is_com: 0,
        // advt_com: 0,
        // gb_com: 0,
        total: 0,
        total_exp: 0,
        net_deposit: 0,
      };
      for (let i = 0; i < this.allCreditVoucherListData.length; i++) {
        this.totalcrdtvreport['depositamt'] += parseInt(
          this.allCreditVoucherListData[i]['deposit_amt']
        );
        this.totalcrdtvreport['sub'] += parseInt(
          this.allCreditVoucherListData[i]['subscription']
        );
        this.totalcrdtvreport['issue'] += parseInt(
          this.allCreditVoucherListData[i]['issuesale']
        );
        this.totalcrdtvreport['advt'] += parseInt(
          this.allCreditVoucherListData[i]['advertiesment']
        );
        this.totalcrdtvreport['deposit'] += parseInt(
          this.allCreditVoucherListData[i]['deposits']
        );
        this.totalcrdtvreport['book'] += parseInt(
          this.allCreditVoucherListData[i]['book']
        );
        this.totalcrdtvreport['pkg_amt'] += parseInt(
          this.allCreditVoucherListData[i]['packageamount']
        );
        this.totalcrdtvreport['donation'] += parseInt(
          this.allCreditVoucherListData[i]['donation']
        );
        this.totalcrdtvreport['other_deposit'] += parseInt(
          this.allCreditVoucherListData[i]['other_deposit']
        );
        this.totalcrdtvreport['total'] += parseInt(
          this.allCreditVoucherListData[i]['total']
        );
        // this.totalcrdtvreport['travel'] += parseInt(
        //   this.allCreditVoucherListData[i]['travels']
        // );
        // this.totalcrdtvreport['other'] += parseInt(
        //   this.allCreditVoucherListData[i]['other']
        // );
        // this.totalcrdtvreport['sub_com'] += parseInt(
        //   this.allCreditVoucherListData[i]['sub_commission']
        // );
        // this.totalcrdtvreport['is_com'] += parseInt(
        //   this.allCreditVoucherListData[i]['issue_commission']
        // );
        // this.totalcrdtvreport['advt_com'] += parseInt(
        //   this.allCreditVoucherListData[i]['advt_commission']
        // );
        // this.totalcrdtvreport['gb_com'] += parseInt(
        //   this.allCreditVoucherListData[i]['book_commission']
        // );
        this.totalcrdtvreport['total_exp'] += parseInt(
          this.allCreditVoucherListData[i]['totalexp']
        );
        this.totalcrdtvreport['net_deposit'] += parseInt(
          this.allCreditVoucherListData[i]['net_deposit']
        );
      }
    });
  }

  //hold on for now
  // save_debitvoucher() {
  //   setTimeout(() => {


  //     let data = {
  //       bcaccount: this.debitForm.get('bcaccount').value,
  //       dvnumber: this.debitForm.get('dvnumber').value,
  //       dvoucherdate: this.debitForm.get('dvoucherdate').value,
  //       rname: this.debitForm.get('rname').value,
  //       othername: this.debitForm.get('othername').value,
  //       exp_amt: this.debitForm.get('exp_amt').value,
  //       chequeno: this.debitForm.get('chequeno').value,
  //       chequedate: this.datePipe.transform(this.debitForm.get('chequedate').value, 'yyyy-MM-dd'),
  //       totalexp: this.debitForm.get('totalexp').value,
  //     };

  //     // console.log({ data });
  //     if (confirm('Are you sure you want to add this debit voucher?')) {
  //       if (
  //         parseInt(this.debitForm.get('exp_amt').value) ===
  //         parseInt(this.debitForm.get('totalexp').value)
  //       ) {
  //         this.service.addDebitVoucher(data).subscribe((res) => {
  //           this.selecteddebitMainExpenses.map((exp) => {
  //             let data = {
  //               voucher_id: res['id'],
  //               mainexpid: exp.mainexpid,
  //               expamt: exp.expamt,
  //               status: exp.status
  //             };
  //             debugger
  //             let subData = this.selecteddebitsubExpenses.filter(
  //               (a) => a['mainexpid'] === data['mainexpid']
  //             );
  //             this.service.addOrUpdateOrDeleteDebitMainExpense(data).subscribe((result) => {
  //               subData.map((a) => {
  //                 let subexpdata = {
  //                   mainid: result['id'],
  //                   subexpid: a['subexpid'],
  //                   expamt: a['expamt'],
  //                   status: exp.status
  //                 };
  //                 this.service
  //                   .addOrUpdateOrDeleteDebitSubExpense(subexpdata)
  //                   .subscribe((data) => {

  //                   });
  //               });
  //             });
  //           });
  //           alert('Debit Voucher Added Successfully...');
  //           this.debitForm.reset();
  //           this.selecteddebitMainExpenses = [];
  //           this.selecteddebitsubExpenses = [];
  //           this.ngOnInit();
  //         });
  //       } else {
  //         alert('Please check the amount.');
  //       }
  //     }
  //   }, 200);
  // }

  isSaving = false;
  save_debitvoucher() {

    if (this.isSaving) {
      return;
    }

    if (!confirm('Are you sure you want to add this debit voucher?')) {
      return;
    }

    if (
      parseInt(this.debitForm.get('exp_amt').value) !==
      parseInt(this.debitForm.get('totalexp').value)
    ) {
      alert('Please check the amount.');
      return;
    }

    this.isSaving = true;

    const data = {
      bcaccount: this.debitForm.get('bcaccount').value,
      dvnumber: this.debitForm.get('dvnumber').value,
      dvoucherdate: this.debitForm.get('dvoucherdate').value,
      rname: this.debitForm.get('rname').value,
      othername: this.debitForm.get('othername').value,
      exp_amt: this.debitForm.get('exp_amt').value,
      chequeno: this.debitForm.get('chequeno').value,
      chequedate: this.datePipe.transform(
        this.debitForm.get('chequedate').value,
        'yyyy-MM-dd'
      ),
      totalexp: this.debitForm.get('totalexp').value,
    };

    this.service.addDebitVoucher(data).subscribe({
      next: (res) => {

        this.selecteddebitMainExpenses.forEach((exp) => {

          const mainData = {
            voucher_id: res['id'],
            mainexpid: exp.mainexpid,
            expamt: exp.expamt,
            status: exp.status
          };

          const subData = this.selecteddebitsubExpenses.filter(
            a => a.mainexpid === exp.mainexpid
          );

          this.service.addOrUpdateOrDeleteDebitMainExpense(mainData)
            .subscribe(result => {

              subData.forEach(a => {
                const subexpdata = {
                  mainid: result['id'],
                  subexpid: a.subexpid,
                  expamt: a.expamt,
                  status: exp.status
                };

                this.service.addOrUpdateOrDeleteDebitSubExpense(subexpdata).subscribe();
              });

            });
        });

        Swal.fire({
          icon: 'success',
          title: 'Debit Voucher Added Successfully!',
          html: `Voucher No: <b style="color:red;">${this.debitForm.get('dvnumber')?.value}</b>`
        }).then(() => {
          this.debitForm.reset();
          this.selecteddebitMainExpenses = [];
          this.selecteddebitsubExpenses = [];
          this.isSaving = false;
          this.debitForm.get('exptype').setValue('Assent');
          this.getMainExpensesByType({ value: 'Assent' });
          window.location.reload();
        });

      },
      error: () => {
        this.isSaving = false;
        alert('Error while saving voucher');
      }
    });
  }

  update_debitvoucher() {
    if (confirm("Are you sure you want to update this debit voucher?")) {
      debugger
      if (
        parseInt(this.debitForm.get('exp_amt').value) ===
        parseInt(this.debitForm.get('totalexp').value)
      ) {
        //delete all expenses
        // this.service.deleteDebitVoucherlist(this.transformedResult).subscribe((data: any) => {
        // });

        let debitVoucherData = {
          // bcaccount: this.debitForm.get('bcaccount').value,
          dvnumber: this.debitForm.get('dvnumber').value,
          // dvoucherdate: this.debitForm.get('dvoucherdate').value,
          rname: this.debitForm.get('rname').value,
          othername: this.debitForm.get('othername').value,
          exp_amt: this.debitForm.get('exp_amt').value,
          chequeno: this.debitForm.get('chequeno').value,
          chequedate: this.datePipe.transform(this.debitForm.get('chequedate').value, 'yyyy-MM-dd'),
          totalexp: this.debitForm.get('totalexp').value,
        };
        //update debit voucher data
        this.service.updateDebitVoucherData(debitVoucherData).subscribe((result) => {
        });

        const combinedExpenses = [...this.selecteddebitMainExpenses, ...this.deletedMainExpenses];

        combinedExpenses.map((exp) => {
          let data = {
            voucher_id: this.mainidforupdatedebit,
            mainexpid: exp.mainexpid,
            expamt: exp.expamt,
            status: exp.status,
            id: exp.id
          };

          let subData = this.selecteddebitsubExpenses.filter(
            (a) => a['mainexpid'] === data['mainexpid']
          );

          debugger
          this.service.addOrUpdateOrDeleteDebitMainExpense(data).subscribe((result: any) => {
            subData.map((a) => {
              let subexpdata = {
                mainid: result.id,
                subexpid: a['subexpid'],
                expamt: a['expamt'],
                status: a.status,
                id: a.id
              };

              this.service
                .addOrUpdateOrDeleteDebitSubExpense(subexpdata)
                .subscribe((data) => {
                  console.log(data);
                });
            });
            // }
          });
        });
        alert('Debit Voucher Updated Successfully...');
        this.selecteddebitMainExpenses = [];
        this.selecteddebitsubExpenses = [];
        this.debitForm.reset();
        // location.reload();
      } else {
        alert('Please check the amount.');
      }
    }
  }

  pkgStartDate = '';
  pkgEndDate = '';
  getChangedDatepkgv() {
    if (
      this.pkgForm.get('start').value != null &&
      this.pkgForm.get('end').value != null
    ) {
      this.pkgStartDate = formatDate(
        new Date(this.pkgForm.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      ).toString();
      this.pkgEndDate = formatDate(
        new Date(this.pkgForm.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      ).toString();

      // console.log(this.pkgStartDate);
      // console.log(this.pkgEndDate);
    }
  }

  show1year: boolean = false;
  show3year: boolean = false;
  show5year: boolean = false;
  getPeriodicity(event) {
    // let data = event.value.toString();
    // console.log('object',data.split(','));
    // console.log(event.value.toString());

    if (event.value.find((a) => a == '1 year') == '1 year') {
      this.show1year = true;
    } else {
      this.show1year = false;
    }

    if (event.value.find((a) => a == '3 year') == '3 year') {
      this.show3year = true;
    } else {
      this.show3year = false;
    }

    if (event.value.find((a) => a == '5 year') == '5 year') {
      this.show5year = true;
    } else {
      this.show5year = false;
    }
  }

  actualamt1total = 0;
  getActualAmt1(event) {
    // console.log(event.target.value);
    this.actualamt1total =
      (this.pkgForm.get('vivekm1actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('vivekm1actualamt').value)) +
      (this.pkgForm.get('vivekh1actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('vivekh1actualamt').value)) +
      (this.pkgForm.get('vaidyraj1actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('vaidyraj1actualamt').value)) +
      (this.pkgForm.get('granth11actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('granth11actualamt').value)) +
      (this.pkgForm.get('granth21actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('granth21actualamt').value)) +
      (this.pkgForm.get('donation1actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('donation1actualamt').value)) +
      (this.pkgForm.get('advt1actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('advt1actualamt').value)) +
      (this.pkgForm.get('courier1actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('courier1actualamt').value)) +
      (this.pkgForm.get('other1actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('other1actualamt').value));
  }

  concessionamt1total = 0;
  getConcessionAmt1(event) {
    this.concessionamt1total =
      (this.pkgForm.get('vivekm1concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('vivekm1concessionamt').value)) +
      (this.pkgForm.get('vivekh1concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('vivekh1concessionamt').value)) +
      (this.pkgForm.get('vaidyraj1concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('vaidyraj1concessionamt').value)) +
      (this.pkgForm.get('granth11concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('granth11concessionamt').value)) +
      (this.pkgForm.get('granth21concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('granth21concessionamt').value)) +
      (this.pkgForm.get('donation1concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('donation1concessionamt').value)) +
      (this.pkgForm.get('advt1concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('advt1concessionamt').value)) +
      (this.pkgForm.get('courier1concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('courier1concessionamt').value)) +
      (this.pkgForm.get('other1concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('other1concessionamt').value));
  }

  actualamt3total = 0;
  getActualAmt3(event) {
    // console.log(event.target.value);
    this.actualamt3total =
      (this.pkgForm.get('vivekm3actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('vivekm3actualamt').value)) +
      (this.pkgForm.get('vivekh3actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('vivekh3actualamt').value)) +
      (this.pkgForm.get('vaidyraj3actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('vaidyraj3actualamt').value)) +
      (this.pkgForm.get('granth13actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('granth13actualamt').value)) +
      (this.pkgForm.get('granth23actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('granth23actualamt').value)) +
      (this.pkgForm.get('donation3actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('donation3actualamt').value)) +
      (this.pkgForm.get('advt3actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('advt3actualamt').value)) +
      (this.pkgForm.get('courier3actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('courier3actualamt').value)) +
      (this.pkgForm.get('other3actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('other3actualamt').value));
  }

  concessionamt3total = 0;
  getConcessionAmt3(event) {
    this.concessionamt3total =
      (this.pkgForm.get('vivekm3concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('vivekm3concessionamt').value)) +
      (this.pkgForm.get('vivekh3concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('vivekh3concessionamt').value)) +
      (this.pkgForm.get('vaidyraj3concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('vaidyraj3concessionamt').value)) +
      (this.pkgForm.get('granth13concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('granth13concessionamt').value)) +
      (this.pkgForm.get('granth23concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('granth23concessionamt').value)) +
      (this.pkgForm.get('donation3concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('donation3concessionamt').value)) +
      (this.pkgForm.get('advt3concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('advt3concessionamt').value)) +
      (this.pkgForm.get('courier3concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('courier3concessionamt').value)) +
      (this.pkgForm.get('other3concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('other3concessionamt').value));
  }

  actualamt5total = 0;
  getActualAmt5(event) {
    // console.log(event.target.value);
    this.actualamt5total =
      (this.pkgForm.get('vivekm5actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('vivekm5actualamt').value)) +
      (this.pkgForm.get('vivekh5actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('vivekh5actualamt').value)) +
      (this.pkgForm.get('vaidyraj5actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('vaidyraj5actualamt').value)) +
      (this.pkgForm.get('granth15actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('granth15actualamt').value)) +
      (this.pkgForm.get('granth25actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('granth25actualamt').value)) +
      (this.pkgForm.get('donation5actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('donation5actualamt').value)) +
      (this.pkgForm.get('advt5actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('advt5actualamt').value)) +
      (this.pkgForm.get('courier5actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('courier5actualamt').value)) +
      (this.pkgForm.get('other5actualamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('other5actualamt').value));
  }

  concessionamt5total = 0;
  getConcessionAmt5(event) {
    this.concessionamt5total =
      (this.pkgForm.get('vivekm5concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('vivekm5concessionamt').value)) +
      (this.pkgForm.get('vivekh5concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('vivekh5concessionamt').value)) +
      (this.pkgForm.get('vaidyraj5concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('vaidyraj5concessionamt').value)) +
      (this.pkgForm.get('granth15concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('granth15concessionamt').value)) +
      (this.pkgForm.get('granth25concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('granth25concessionamt').value)) +
      (this.pkgForm.get('donation5concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('donation5concessionamt').value)) +
      (this.pkgForm.get('advt5concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('advt5concessionamt').value)) +
      (this.pkgForm.get('courier5concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('courier5concessionamt').value)) +
      (this.pkgForm.get('other5concessionamt').value === ''
        ? 0
        : parseFloat(this.pkgForm.get('other5concessionamt').value));
  }

  AddPackage() {
    let data = {
      pkgname: this.pkgForm.get('pkgname').value,
      startdate: this.pkgStartDate,
      enddate: this.pkgEndDate,
      pkgamt: this.pkgForm.get('pkgamt').value,
      other_concession_exp_id: this.expIdForPackageManager,
      // hindi_vivek_exp_id: this.expIdForPackageManager,
      // vaidyraj_exp_id: this.expIdForPackageManager1,
      // courier_exp_id: this.expIdForPackageManager2,
      periodicity: this.pkgForm.get('periodicity').value.toString(),
    };

    // console.log('before api call', data);
    this.service.addPackage(data).subscribe((data) => {
      console.log(data);
      if (this.show1year) {
        // console.log('inside 1 year');

        let pkgdata1 = {
          pkg_id: data['id'],
          vivekm1actualamt: this.pkgForm.get('vivekm1actualamt').value,
          vivekm1concessionamt: this.pkgForm.get('vivekm1concessionamt').value,
          vivekh1actualamt: this.pkgForm.get('vivekh1actualamt').value,
          vivekh1concessionamt: this.pkgForm.get('vivekh1concessionamt').value,
          vaidyraj1actualamt: this.pkgForm.get('vaidyraj1actualamt').value,
          vaidyraj1concessionamt: this.pkgForm.get('vaidyraj1concessionamt')
            .value,
          granth11actualamt: this.pkgForm.get('granth11actualamt').value,
          granth11concessionamt: this.pkgForm.get('granth11concessionamt')
            .value,
          granth21actualamt: this.pkgForm.get('granth21actualamt').value,
          granth21concessionamt: this.pkgForm.get('granth21concessionamt')
            .value,
          donation1actualamt: this.pkgForm.get('donation1actualamt').value,
          donation1concessionamt: this.pkgForm.get('donation1concessionamt')
            .value,
          advt1actualamt: this.pkgForm.get('advt1actualamt').value,
          advt1concessionamt: this.pkgForm.get('advt1concessionamt').value,
          courier1actualamt: this.pkgForm.get('courier1actualamt').value,
          courier1concessionamt: this.pkgForm.get('courier1concessionamt')
            .value,
          other1actualamt: this.pkgForm.get('other1actualamt').value,
          other1concessionamt: this.pkgForm.get('other1concessionamt').value,
        };

        this.service.addPackage1(pkgdata1).subscribe((data) => {
          console.log('pkgdata1', data);
        });
      }

      if (this.show3year) {
        // console.log('inside 3 year');
        let pkgdata3 = {
          pkg_id: data['id'],
          vivekm3actualamt: this.pkgForm.get('vivekm3actualamt').value,
          vivekm3concessionamt: this.pkgForm.get('vivekm3concessionamt').value,
          vivekh3actualamt: this.pkgForm.get('vivekh3actualamt').value,
          vivekh3concessionamt: this.pkgForm.get('vivekh3concessionamt').value,
          vaidyraj3actualamt: this.pkgForm.get('vaidyraj3actualamt').value,
          vaidyraj3concessionamt: this.pkgForm.get('vaidyraj3concessionamt')
            .value,
          granth13actualamt: this.pkgForm.get('granth13actualamt').value,
          granth13concessionamt: this.pkgForm.get('granth13concessionamt')
            .value,
          granth23actualamt: this.pkgForm.get('granth23actualamt').value,
          granth23concessionamt: this.pkgForm.get('granth23concessionamt')
            .value,
          donation3actualamt: this.pkgForm.get('donation3actualamt').value,
          donation3concessionamt: this.pkgForm.get('donation3concessionamt')
            .value,
          advt3actualamt: this.pkgForm.get('advt3actualamt').value,
          advt3concessionamt: this.pkgForm.get('advt3concessionamt').value,
          courier3actualamt: this.pkgForm.get('courier3actualamt').value,
          courier3concessionamt: this.pkgForm.get('courier3concessionamt')
            .value,
          other3actualamt: this.pkgForm.get('other3actualamt').value,
          other3concessionamt: this.pkgForm.get('other3concessionamt').value,
        };

        this.service.addPackage3(pkgdata3).subscribe((data) => {
          console.log('pkgdata3', data);
        });
      }

      if (this.show5year) {
        console.log('inside 5 year');
        let pkgdata5 = {
          pkg_id: data['id'],
          vivekm5actualamt: this.pkgForm.get('vivekm5actualamt').value,
          vivekm5concessionamt: this.pkgForm.get('vivekm5concessionamt').value,
          vivekh5actualamt: this.pkgForm.get('vivekh5actualamt').value,
          vivekh5concessionamt: this.pkgForm.get('vivekh5concessionamt').value,
          vaidyraj5actualamt: this.pkgForm.get('vaidyraj5actualamt').value,
          vaidyraj5concessionamt: this.pkgForm.get('vaidyraj5concessionamt')
            .value,
          granth15actualamt: this.pkgForm.get('granth15actualamt').value,
          granth15concessionamt: this.pkgForm.get('granth15concessionamt')
            .value,
          granth25actualamt: this.pkgForm.get('granth25actualamt').value,
          granth25concessionamt: this.pkgForm.get('granth25concessionamt')
            .value,
          donation5actualamt: this.pkgForm.get('donation5actualamt').value,
          donation5concessionamt: this.pkgForm.get('donation5concessionamt')
            .value,
          advt5actualamt: this.pkgForm.get('advt5actualamt').value,
          advt5concessionamt: this.pkgForm.get('advt5concessionamt').value,
          courier5actualamt: this.pkgForm.get('courier5actualamt').value,
          courier5concessionamt: this.pkgForm.get('courier5concessionamt')
            .value,
          other5actualamt: this.pkgForm.get('other5actualamt').value,
          other5concessionamt: this.pkgForm.get('other5concessionamt').value,
        };

        this.service.addPackage5(pkgdata5).subscribe((data) => {
          console.log('pkgdata5', data);
        });
      }

      alert('Data added successfully...');
      this.pkgForm.reset();
      this.ngOnInit();
    });
  }

  showpkg: boolean = false;
  shownopkg: boolean = false;
  changeType(event) {
    // console.log(event.value);
    if (event.value == 'package') {
      this.showpkg = true;
    } else if (event.value == 'nopackage') {
      this.showpkg = false;
      this.shownopkg = true;
    }
  }

  selected_package_details(pkgid) {
    console.log(pkgid);
  }

  pkgAmount = 0;
  packageAmount(event) {
    // console.log(event.target.value);
    this.pkgAmount =
      event.target.value === '' ? 0 : parseInt(event.target.value);
    // console.log(this.pkgAmount);
  }

  user_id = 0;
  isUser: boolean = false;
  getpkgname(event, option) {
    debugger
    if (event.isUserInput) {
      this.user_id = option['pkgid'];
      let data = this.packageData.filter((a) => a['pkg_id'] == this.user_id);
      if (Object.keys(data).length > 0) {
        this.isUser = true;
        // this.show1year = true;
        // this.show3year = true;
        // this.show5year = true;

        // console.log(data);
        // this.pkgForm.get('pkgname').setValue(data['pkg_name']);
        this.pkgForm.get('start').setValue(data[0]['pkg_start_date']);
        this.pkgForm.get('end').setValue(data[0]['pkg_end_date']);
        this.pkgForm.get('pkgamt').setValue(data[0]['pkg_amt']);
        this.pkgForm.get('expledgerForOtherConcession').setValue(data[0]['other_concession_exp_id']);
        // this.pkgForm.get('expledgerForHindiVivek').setValue(data[0]['hindi_vivek_exp_id']);
        // this.pkgForm.get('expledgerForVaidyraj').setValue(data[0]['vaidyraj_exp_id']);
        // this.pkgForm.get('expledgerForCourier').setValue(data[0]['courier_exp_id']);
        debugger
        this.pkgForm
          .get('periodicity')
          .setValue(data[0]['periodicity'].split(','));
        // console.log('db',data[0]['periodicity']);
        let check = data[0]['periodicity'].split(',');
        if (check.find((a) => a == '1 year') == '1 year') {
          this.show1year = true;
        } else {
          this.show1year = false;
        }

        if (check.find((a) => a == '3 year') == '3 year') {
          this.show3year = true;
        } else {
          this.show3year = false;
        }

        if (check.find((a) => a == '5 year') == '5 year') {
          this.show5year = true;
        } else {
          this.show5year = false;
        }
        if (this.show1year) {
          debugger
          this.pkgForm
            .get('vivekm1actualamt')
            .setValue(data[0]['vivek_m_1_actual_amt']);
          this.pkgForm
            .get('vivekm1concessionamt')
            .setValue(data[0]['vivek_m_1_concession_amt']);
          this.pkgForm
            .get('vivekh1actualamt')
            .setValue(data[0]['vivek_h_1_actual_amt']);
          this.pkgForm
            .get('vivekh1concessionamt')
            .setValue(data[0]['vivek_h_1_concession_amt']);
          this.pkgForm
            .get('vaidyraj1actualamt')
            .setValue(data[0]['vaidyraj_1_actual_amt']);
          this.pkgForm
            .get('vaidyraj1concessionamt')
            .setValue(data[0]['vaidyraj_1_concession_amt']);
          this.pkgForm
            .get('granth11actualamt')
            .setValue(data[0]['granth1_1_actual_amt']);
          this.pkgForm
            .get('granth11concessionamt')
            .setValue(data[0]['granth1_1_concession_amt']);
          this.pkgForm
            .get('granth21actualamt')
            .setValue(data[0]['granth2_1_actual_amt']);
          this.pkgForm
            .get('granth21concessionamt')
            .setValue(data[0]['granth2_1_concession_amt']);
          this.pkgForm
            .get('donation1actualamt')
            .setValue(data[0]['donation_1_actual_amt']);
          this.pkgForm
            .get('donation1concessionamt')
            .setValue(data[0]['donation_1_concession_amt']);
          this.pkgForm
            .get('advt1actualamt')
            .setValue(data[0]['advt_1_actual_amt']);
          this.pkgForm
            .get('advt1concessionamt')
            .setValue(data[0]['advt_1_concession_amt']);
          this.pkgForm
            .get('courier1actualamt')
            .setValue(data[0]['courier_1_actual_amt']);
          this.pkgForm
            .get('courier1concessionamt')
            .setValue(data[0]['courier_1_concession_amt']);
          this.pkgForm
            .get('other1actualamt')
            .setValue(data[0]['other_1_actual_amt']);
          this.pkgForm
            .get('other1concessionamt')
            .setValue(data[0]['other_1_concession_amt']);

          this.actualamt1total =
            parseInt(data[0]['other_1_actual_amt']) +
            parseInt(data[0]['courier_1_actual_amt']) +
            parseInt(data[0]['advt_1_actual_amt']) +
            parseInt(data[0]['donation_1_actual_amt']) +
            parseInt(data[0]['granth2_1_actual_amt']) +
            parseInt(data[0]['granth1_1_actual_amt']) +
            parseInt(data[0]['vaidyraj_1_actual_amt']) +
            parseInt(data[0]['vivek_h_1_actual_amt']) +
            parseInt(data[0]['vivek_m_1_actual_amt']);

          this.concessionamt1total =
            parseInt(data[0]['other_1_concession_amt']) +
            parseInt(data[0]['courier_1_concession_amt']) +
            parseInt(data[0]['advt_1_concession_amt']) +
            parseInt(data[0]['donation_1_concession_amt']) +
            parseInt(data[0]['granth2_1_concession_amt']) +
            parseInt(data[0]['granth1_1_concession_amt']) +
            parseInt(data[0]['vaidyraj_1_concession_amt']) +
            parseInt(data[0]['vivek_h_1_concession_amt']) +
            parseInt(data[0]['vivek_m_1_concession_amt']);
        }
        if (this.show3year) {
          this.pkgForm
            .get('vivekm3actualamt')
            .setValue(data[0]['vivek_m_3_actual_amt']);
          this.pkgForm
            .get('vivekm3concessionamt')
            .setValue(data[0]['vivek_m_3_concession_amt']);
          this.pkgForm
            .get('vivekh3actualamt')
            .setValue(data[0]['vivek_h_3_actual_amt']);
          this.pkgForm
            .get('vivekh3concessionamt')
            .setValue(data[0]['vivek_h_3_concession_amt']);
          this.pkgForm
            .get('vaidyraj3actualamt')
            .setValue(data[0]['vaidyraj_3_actual_amt']);
          this.pkgForm
            .get('vaidyraj3concessionamt')
            .setValue(data[0]['vaidyraj_3_concession_amt']);
          this.pkgForm
            .get('granth13actualamt')
            .setValue(data[0]['granth1_3_actual_amt']);
          this.pkgForm
            .get('granth13concessionamt')
            .setValue(data[0]['granth1_3_concession_amt']);
          this.pkgForm
            .get('granth23actualamt')
            .setValue(data[0]['granth2_3_actual_amt']);
          this.pkgForm
            .get('granth23concessionamt')
            .setValue(data[0]['granth2_3_concession_amt']);
          this.pkgForm
            .get('donation3actualamt')
            .setValue(data[0]['donation_3_actual_amt']);
          this.pkgForm
            .get('donation3concessionamt')
            .setValue(data[0]['donation_3_concession_amt']);
          this.pkgForm
            .get('advt3actualamt')
            .setValue(data[0]['advt_3_actual_amt']);
          this.pkgForm
            .get('advt3concessionamt')
            .setValue(data[0]['advt_3_concession_amt']);
          this.pkgForm
            .get('courier3actualamt')
            .setValue(data[0]['courier_3_actual_amt']);
          this.pkgForm
            .get('courier3concessionamt')
            .setValue(data[0]['courier_3_concession_amt']);
          this.pkgForm
            .get('other3actualamt')
            .setValue(data[0]['other_3_actual_amt']);
          this.pkgForm
            .get('other3concessionamt')
            .setValue(data[0]['other_3_concession_amt']);

          this.actualamt3total =
            parseInt(data[0]['other_3_actual_amt']) +
            parseInt(data[0]['courier_3_actual_amt']) +
            parseInt(data[0]['advt_3_actual_amt']) +
            parseInt(data[0]['donation_3_actual_amt']) +
            parseInt(data[0]['granth2_3_actual_amt']) +
            parseInt(data[0]['granth1_3_actual_amt']) +
            parseInt(data[0]['vaidyraj_3_actual_amt']) +
            parseInt(data[0]['vivek_h_3_actual_amt']) +
            parseInt(data[0]['vivek_m_3_actual_amt']);

          this.concessionamt3total =
            parseInt(data[0]['other_3_concession_amt']) +
            parseInt(data[0]['courier_3_concession_amt']) +
            parseInt(data[0]['advt_3_concession_amt']) +
            parseInt(data[0]['donation_3_concession_amt']) +
            parseInt(data[0]['granth2_3_concession_amt']) +
            parseInt(data[0]['granth1_3_concession_amt']) +
            parseInt(data[0]['vaidyraj_3_concession_amt']) +
            parseInt(data[0]['vivek_h_3_concession_amt']) +
            parseInt(data[0]['vivek_m_3_concession_amt']);
        }
        if (this.show5year) {
          this.pkgForm
            .get('vivekm5actualamt')
            .setValue(data[0]['vivek_m_5_actual_amt']);
          this.pkgForm
            .get('vivekm5concessionamt')
            .setValue(data[0]['vivek_m_5_concession_amt']);
          this.pkgForm
            .get('vivekh5actualamt')
            .setValue(data[0]['vivek_h_5_actual_amt']);
          this.pkgForm
            .get('vivekh5concessionamt')
            .setValue(data[0]['vivek_h_5_concession_amt']);
          this.pkgForm
            .get('vaidyraj5actualamt')
            .setValue(data[0]['vaidyraj_5_actual_amt']);
          this.pkgForm
            .get('vaidyraj5concessionamt')
            .setValue(data[0]['vaidyraj_5_concession_amt']);
          this.pkgForm
            .get('granth15actualamt')
            .setValue(data[0]['granth1_5_actual_amt']);
          this.pkgForm
            .get('granth15concessionamt')
            .setValue(data[0]['granth1_5_concession_amt']);
          this.pkgForm
            .get('granth25actualamt')
            .setValue(data[0]['granth2_5_actual_amt']);
          this.pkgForm
            .get('granth25concessionamt')
            .setValue(data[0]['granth2_5_concession_amt']);
          this.pkgForm
            .get('donation5actualamt')
            .setValue(data[0]['donation_5_actual_amt']);
          this.pkgForm
            .get('donation5concessionamt')
            .setValue(data[0]['donation_5_concession_amt']);
          this.pkgForm
            .get('advt5actualamt')
            .setValue(data[0]['advt_5_actual_amt']);
          this.pkgForm
            .get('advt5concessionamt')
            .setValue(data[0]['advt_5_concession_amt']);
          this.pkgForm
            .get('courier5actualamt')
            .setValue(data[0]['courier_5_actual_amt']);
          this.pkgForm
            .get('courier5concessionamt')
            .setValue(data[0]['courier_5_concession_amt']);
          this.pkgForm
            .get('other5actualamt')
            .setValue(data[0]['other_5_actual_amt']);
          this.pkgForm
            .get('other5concessionamt')
            .setValue(data[0]['other_5_concession_amt']);

          this.actualamt5total =
            parseInt(data[0]['other_5_actual_amt']) +
            parseInt(data[0]['courier_5_actual_amt']) +
            parseInt(data[0]['advt_5_actual_amt']) +
            parseInt(data[0]['donation_5_actual_amt']) +
            parseInt(data[0]['granth2_5_actual_amt']) +
            parseInt(data[0]['granth1_5_actual_amt']) +
            parseInt(data[0]['vaidyraj_5_actual_amt']) +
            parseInt(data[0]['vivek_h_5_actual_amt']) +
            parseInt(data[0]['vivek_m_5_actual_amt']);

          this.concessionamt5total =
            parseInt(data[0]['other_5_concession_amt']) +
            parseInt(data[0]['courier_5_concession_amt']) +
            parseInt(data[0]['advt_5_concession_amt']) +
            parseInt(data[0]['donation_5_concession_amt']) +
            parseInt(data[0]['granth2_5_concession_amt']) +
            parseInt(data[0]['granth1_5_concession_amt']) +
            parseInt(data[0]['vaidyraj_5_concession_amt']) +
            parseInt(data[0]['vivek_h_5_concession_amt']) +
            parseInt(data[0]['vivek_m_5_concession_amt']);
        }
      }
    }
  }

  updatePackageManager() {

    if (confirm('Are you sure you want to update this package?')) {

      let data = {
        pkgid: this.user_id,
        pkgname: this.pkgForm.get('pkgname').value,
        startdate: formatDate(this.pkgForm.get('start').value, 'yyyy-MM-dd', 'en-IN', 'GMT+0530'),
        enddate: formatDate(this.pkgForm.get('end').value, 'yyyy-MM-dd', 'en-IN', 'GMT+0530'),
        periodicity: this.pkgForm.get('periodicity').value,
        pkgamt: this.pkgForm.get('pkgamt').value,
        other_concession_exp_id: this.pkgForm.get('expledgerForOtherConcession').value.toString(),
        // hindi_vivek_exp_id: this.pkgForm.get('expledgerForHindiVivek').value.toString(),
        // vaidyraj_exp_id: this.pkgForm.get('expledgerForVaidyraj').value.toString(),
        // courier_exp_id: this.pkgForm.get('expledgerForCourier').value.toString(),
      };

      // console.log(data);
      this.service.updatePackageManager(data).subscribe((data) => {

        if (this.show1year) {
          debugger
          let pkg1year = {
            pkgid: this.user_id,
            vivekm1actualamt: this.pkgForm.get('vivekm1actualamt').value,
            vivekm1concessionamt: this.pkgForm.get('vivekm1concessionamt').value,
            vivekh1actualamt: this.pkgForm.get('vivekh1actualamt').value,
            vivekh1concessionamt: this.pkgForm.get('vivekh1concessionamt').value,
            vaidyraj1actualamt: this.pkgForm.get('vaidyraj1actualamt').value,
            vaidyraj1concessionamt: this.pkgForm.get('vaidyraj1concessionamt')
              .value,
            granth11actualamt: this.pkgForm.get('granth11actualamt').value,
            granth11concessionamt: this.pkgForm.get('granth11concessionamt')
              .value,
            granth21actualamt: this.pkgForm.get('granth21actualamt').value,
            granth21concessionamt: this.pkgForm.get('granth21concessionamt')
              .value,
            donation1actualamt: this.pkgForm.get('donation1actualamt').value,
            donation1concessionamt: this.pkgForm.get('donation1concessionamt')
              .value,
            advt1actualamt: this.pkgForm.get('advt1actualamt').value,
            advt1concessionamt: this.pkgForm.get('advt1concessionamt').value,
            courier1actualamt: this.pkgForm.get('courier1actualamt').value,
            courier1concessionamt: this.pkgForm.get('courier1concessionamt')
              .value,
            other1actualamt: this.pkgForm.get('other1actualamt').value,
            other1concessionamt: this.pkgForm.get('other1concessionamt').value,
          };

          this.service.updatePackage1(pkg1year).subscribe((data) => { });
        }

        if (this.show3year) {
          debugger
          let pkg3year = {
            pkgid: this.user_id,
            vivekm3actualamt: this.pkgForm.get('vivekm3actualamt').value,
            vivekm3concessionamt: this.pkgForm.get('vivekm3concessionamt').value,
            vivekh3actualamt: this.pkgForm.get('vivekh3actualamt').value,
            vivekh3concessionamt: this.pkgForm.get('vivekh3concessionamt').value,
            vaidyraj3actualamt: this.pkgForm.get('vaidyraj3actualamt').value,
            vaidyraj3concessionamt: this.pkgForm.get('vaidyraj3concessionamt')
              .value,
            granth13actualamt: this.pkgForm.get('granth13actualamt').value,
            granth13concessionamt: this.pkgForm.get('granth13concessionamt')
              .value,
            granth23actualamt: this.pkgForm.get('granth23actualamt').value,
            granth23concessionamt: this.pkgForm.get('granth23concessionamt')
              .value,
            donation3actualamt: this.pkgForm.get('donation3actualamt').value,
            donation3concessionamt: this.pkgForm.get('donation3concessionamt')
              .value,
            advt3actualamt: this.pkgForm.get('advt3actualamt').value,
            advt3concessionamt: this.pkgForm.get('advt3concessionamt').value,
            courier3actualamt: this.pkgForm.get('courier3actualamt').value,
            courier3concessionamt: this.pkgForm.get('courier3concessionamt')
              .value,
            other3actualamt: this.pkgForm.get('other3actualamt').value,
            other3concessionamt: this.pkgForm.get('other3concessionamt').value,
          };

          this.service.updatePackage3(pkg3year).subscribe((data) => { });
        }

        if (this.show5year) {
          debugger
          let pkg5year = {
            pkgid: this.user_id,
            vivekm5actualamt: this.pkgForm.get('vivekm5actualamt').value,
            vivekm5concessionamt: this.pkgForm.get('vivekm5concessionamt').value,
            vivekh5actualamt: this.pkgForm.get('vivekh5actualamt').value,
            vivekh5concessionamt: this.pkgForm.get('vivekh5concessionamt').value,
            vaidyraj5actualamt: this.pkgForm.get('vaidyraj5actualamt').value,
            vaidyraj5concessionamt: this.pkgForm.get('vaidyraj5concessionamt')
              .value,
            granth15actualamt: this.pkgForm.get('granth15actualamt').value,
            granth15concessionamt: this.pkgForm.get('granth15concessionamt')
              .value,
            granth25actualamt: this.pkgForm.get('granth25actualamt').value,
            granth25concessionamt: this.pkgForm.get('granth25concessionamt')
              .value,
            donation5actualamt: this.pkgForm.get('donation5actualamt').value,
            donation5concessionamt: this.pkgForm.get('donation5concessionamt')
              .value,
            advt5actualamt: this.pkgForm.get('advt5actualamt').value,
            advt5concessionamt: this.pkgForm.get('advt5concessionamt').value,
            courier5actualamt: this.pkgForm.get('courier5actualamt').value,
            courier5concessionamt: this.pkgForm.get('courier5concessionamt')
              .value,
            other5actualamt: this.pkgForm.get('other5actualamt').value,
            other5concessionamt: this.pkgForm.get('other5concessionamt').value,
          };

          this.service.updatePackage5(pkg5year).subscribe((data) => { });
        }

        alert('Package updated successfully...');
        this.pkgForm.reset();
        location.reload();

      });

    }
  }

  updatePackage() {
    this.selectedPackages.forEach(element => {
      if (element.pkg_name === this.creditvoucherForm.get('package').value) {
        element.pkg_amt = this.creditvoucherForm.get('packageamt').value;
        element.client_name = this.creditvoucherForm.get('packagename').value;
      }
    });

    // Recalculate total package amount after update
    let pkg_amt_total = 0;
    for (let i = 0; i < this.selectedPackages.length; i++) {
      pkg_amt_total += parseFloat(this.selectedPackages[i].pkg_amt);
    }

    // Update the packageamount and packagecount form controls
    this.creditvoucherForm.get('packageamount').setValue(pkg_amt_total);
    this.creditvoucherForm.get('packagecount').setValue(this.selectedPackages.length);

    // Update total and ndeposit
    this.totalAmt();
    this.totalAmount();

    // Proceed with the package update service call
    let data = {
      pkgid: this.user_id,
      pkgname: this.pkgForm.get('package').value,
      startdate: this.pkgStartDate,
      enddate: this.pkgEndDate,
      pkgamt: this.pkgForm.get('packageamt').value,
      // granth_exp_id: this.pkgForm.get('periodicity').value.toString(),
      // book_exp_id: this.pkgForm.get('periodicity').value.toString(),
    };

    this.service.updatePackage(data).subscribe((data) => {
      if (this.show1year) {
        let pkg1year = {
          pkgid: this.user_id,
          vivekm1actualamt: this.pkgForm.get('vivekm1actualamt').value,
          vivekm1concessionamt: this.pkgForm.get('vivekm1concessionamt').value,
          vivekh1actualamt: this.pkgForm.get('vivekh1actualamt').value,
          vivekh1concessionamt: this.pkgForm.get('vivekh1concessionamt').value,
          vaidyraj1actualamt: this.pkgForm.get('vaidyraj1actualamt').value,
          vaidyraj1concessionamt: this.pkgForm.get('vaidyraj1concessionamt').value,
          granth11actualamt: this.pkgForm.get('granth11actualamt').value,
          granth11concessionamt: this.pkgForm.get('granth11concessionamt').value,
          granth21actualamt: this.pkgForm.get('granth21actualamt').value,
          granth21concessionamt: this.pkgForm.get('granth21concessionamt').value,
          donation1actualamt: this.pkgForm.get('donation1actualamt').value,
          donation1concessionamt: this.pkgForm.get('donation1concessionamt').value,
          // ...
        };
        this.packagesUpdated = true;
      }
    });
  }

  vouchers_no;
  getVoucherNo(event) {
    // console.log('length',event.target.value.length);
    if (event.target.value.length > 5) {
      this.service.getCreditVoucherNo(event.target.value).subscribe((res) => {
        this.vouchers_no = res;
        // console.log(res);
      });
    }
  }

  jv_vouchers_no;
  getJournalVoucherNo(event) {
    // console.log('length',event.target.value.length);
    if (event.target.value.length > 5) {
      this.service.getJournalVoucherNo(event.target.value).subscribe((res) => {
        this.jv_vouchers_no = res;
        // console.log(res);
      });
    }
  }

  d_vouchers_no;
  getDVVoucherNo(event) {
    // console.log('length',event.target.value.length);
    if (event.target.value.length > 5) {
      this.service.getDebitVoucherNo(event.target.value).subscribe((res) => {
        this.vouchers_no = res;
        // console.log(res);
      });
    }
  }

  creditors_no;
  getCreditorNo(event) {
    if (event.target.value.length > 5) {
      this.service.getCreditorNo(event.target.value).subscribe((res) => {
        this.creditors_no = res;
      });
    }
  }


  selected_d_vouchers(event, option) {
    this.isDebitVoucherEditMode = true
    this.mainidforupdatedebit = option.id

    this.service.getDebitVoucherData(option['id']).subscribe((data) => {
      this.selectvocuherdate = data[0]['d_voucher_date']
      this.debitForm.get('bcaccount').setValue(data[0]['bank_cash_account']);
      this.debitForm.get('rname').setValue(data[0]['rep_name']);
      this.debitForm.get('dvoucherdate').setValue(data[0]['d_voucher_date']);
      this.debitForm.get('dvnumber').setValue(data[0]['d_voucher_no']);
      this.debitForm.get('othername').setValue(data[0]['other_name']);
      this.debitForm.get('exp_amt').setValue(data[0]['exp_amt']);
      this.debitForm.get('chequeno').setValue(data[0]['cheque_no']);
      this.debitForm.get('chequedate').setValue(data[0]['cheque_date']);
      this.debitForm.get('totalexp').setValue(data[0]['total_exp']);
    });

    this.enableUpdateMode(); // Disable fields when updating

    this.service.getDebitVoucherlist(option['id']).subscribe((data: any) => {
      this.debitvoucherlist = data

      debugger

      this.debitvoucherlist.forEach(element => {
        element.visible = true

        this.selecteddebitMainExpenses.push({
          mainexpname: element.exp_name,
          mainexpid: element.main_exp_id,
          expamt: element.main_exp_amt,
          status: 'UpdateMode',
          id: element.main_id
        });

        if (element.sub_exp_name !== null) {
          this.selecteddebitsubExpenses.push({
            mainexpid: element.main_exp_id,
            subexpid: element.sub_exp_id,
            mainexpname: element.exp_name,
            subexpname: element.sub_exp_name,
            expamt: element.sub_exp_amt,
            status: 'UpdateMode',
            id: element.sub_id
          });
        }

      });

    });

    this.selecteddebitsubExpenses = [];
    this.selecteddebitMainExpenses = [];

  }

  selected_creditors(event, option) {
    this.creditorlistactive = true
    this.mainidforupdatecreditor = option.id
    this.creditorslist = true

    this.service.getCreditorData(option['creditor_no']).subscribe((data: any) => {
      if (data && data.length > 0) {
        this.totalAmounts = 0; // Initialize total amount before loop
        this.items = data.map((item, index) => {
          this.totalAmounts += Number(item['net_amt']); // Accumulate total amount

          // return {
          //   expense: item['main_ex_id'],
          //   subExpense: item['sub_ex_id'],
          //   netAmount: item['net_amt'],
          //   totalAmount: item['t_amt'],
          // };

          let newItem = {
            id: item['child_id'],
            expense: item['main_ex_id'],
            subExpense: item['sub_ex_id'],
            netAmount: item['net_amt'],
            totalAmount: item['t_amt'],
            status: 'ADDED',
            getSubExpData1: [] // Initialize empty array for sub expenses
          };

          // Fetch sub-expenses based on main_ex_id and assign them to getSubExpData1
          this.service.getSubExpenseLedgerWithId(item['main_ex_id']).subscribe((subExpenses: any) => {
            newItem.getSubExpData1 = subExpenses;
          });

          return newItem;

        });
        debugger
        this.creditorId = data[0]['id'];
        this.kharedi.get('expnameother').setValue(data[0]['main_id']);
        this.kharedi.get('subexpnameother').setValue(data[0]['sub_id']);
        // this.kharedi.get('voucherdate').setValue(data[0]['creditor_date']);
        // this.kharedi.get('creditorsnum').setValue(data[0]['creditor_number']);
        this.kharedi.get('voucherdate').setValue(data[0]['creditor_date']);
        this.kharedi.get('voucherdate').disable({ onlySelf: true, emitEvent: false });
        this.kharedi.get('creditorsnum').setValue(data[0]['creditor_number']);
        this.kharedi.get('creditorsnum').disable({ onlySelf: true, emitEvent: false });
        this.kharedi.get('totalamount').setValue(data[0]['total_amt']);
        this.kharedi.get('billno').setValue(data[0]['bill_no']);
        this.kharedi.get('narration').setValue(data[0]['narration']);
      }
    });
  }

  deleterow: any[] = [];
  grandtotal: any
  removeDebitlist(item, i) {
    item.visible = false;
    this.deleterow.push(item.main_exp_id);
    this.transformedResult = {
      debitvoucher: this.deleterow.map(id => ({ id: id }))
    };

    console.log(this.transformedResult);

    console.log(this.deleterow, "delete row")
    let id = item.main_exp_id;
    let mainamt = item.main_exp_amt;
    let subamt = item.sub_exp_amt;
    let total: any
      // let grandtotal : any
      ;
    if (subamt == null) {
      subamt = 0;
    }
    if (subamt == 0) {
      total = this.debitForm.value.totalexp
      this.grandtotal = parseFloat(total) - parseFloat(mainamt)
    }
    else {
      total = this.debitForm.value.totalexp
      this.grandtotal = parseFloat(total) - parseFloat(subamt)
    }
    console.log('Grand Total:', this.grandtotal);

    this.debitForm.get('totalexp').setValue(this.grandtotal);
  }

  delete_debitvoucher1() {
    if (confirm('Are you sure you want to delete this debit voucher? This action cannot be undone.')) {
      this.service.deleteDebitVoucher(this.mainidforupdatedebit).subscribe((data: any) => {
        this.debitForm.reset();
        this.selecteddebitMainExpenses = [];
        this.selecteddebitsubExpenses = [];
        this.isDebitVoucherEditMode = false;

        // Enable specific fields
        this.debitForm.get('bcaccount')?.enable();
        this.debitForm.get('dvoucherdate')?.enable();

        alert('Debit vocuher deleted sucessfully...');
      });
    }
    this.ngOnInit()
  }

  delete_creditor() {
    this.mainidforupdatecreditor;
    if (confirm('Are you sure you want to delete this creditor? This action cannot be undone.?')) {
      this.service.deleteCreditor(this.mainidforupdatecreditor).subscribe((data: any) => { });
      this.kharedi.reset();
      this.items = [];
      this.creditorlistactive = false;
      this.totalAmounts = 0;

      // Enable specific fields
      this.kharedi.get('creditorsnum')?.enable();
      this.kharedi.get('voucherdate')?.enable();

      alert('Creditor deleted sucessfully...');
    }
    this.ngOnInit();
  }

  crdt_voucher_id = 0;
  sub_id = 0;
  book_id = 0;
  other_deposits_id = 0;
  issue_id = 0;
  donation_id = 0;
  deposits_id = 0;
  advt_id = 0;
  showCreditupdate = false;
  mainIdObject = [{ s_id: 0, a_id: 0, b_id: 0, i_id: 0 }];
  showPanAndNarrationFlag: any = false
  selected_vouchers(event, option) {
    this.selectedMainExpenses = [];
    this.selectedsubExpenses = [];
    this.selectedMainExpenses1 = [];
    this.selectedsubExpenses1 = [];
    this.selectedPackages = [];
    this.service.getCrditVoucherData(option['id']).subscribe((data) => {
      console.log(data);
      this.crdt_voucher_id = data[0]['id'];
      this.showCreditupdate = true;
      this.creditvoucherForm.get('entrydate').setValue(data[0]['entry_date']);
      this.creditvoucherForm
        .get('bcaccount')
        .setValue(data[0]['bank_cash_account']);
      if (data[0]['bank_cash_account'] === 'CASH') {
        this.cashtype = false;
      } else {
        this.cashtype = true;
      }
      this.creditvoucherForm.get('vnumber').setValue(data[0]['voucher_no']);
      this.creditvoucherForm
        .get('voucherdate')
        .setValue(data[0]['voucher_date']);
      this.creditvoucherForm.get('rname').setValue(data[0]['rep_name']);

      this.creditvoucherForm.patchValue({
        pancard: data[0].pan_card,
        narration: data[0].narration
      });

      // 👇 show if ANY ONE is present
      this.showPanAndNarrationFlag =
        !!data[0].pan_card || !!data[0].narration;

      this.creditvoucherForm
        .get('othername')
        .setValue(data[0]['narration_name']);
      this.creditvoucherForm.get('damount').setValue(data[0]['deposit_amt']);
      this.creditvoucherForm
        .get('pymtoptions')
        .setValue(data[0]['pymt_options']);
      if (this.cashtype) {
        this.creditvoucherForm.get('cnumber').setValue(data[0]['cheque_no']);
        // this.creditvoucherForm
        //   .get('chequedate')
        //   .setValue(
        //     data[0]['cheque_date'] === '0000-00-00'
        //       ? ''
        //       : data[0]['cheque_date']
        //   );
        this.creditvoucherForm
          .get('chequedate')
          .setValue(
            data[0]['cheque_date'] && data[0]['cheque_date'] !== '0000-00-00' && data[0]['cheque_date'].trim() !== ''
              ? data[0]['cheque_date']
              : ''
          );
        this.creditvoucherForm.get('bank').setValue(data[0]['bank']);
        this.creditvoucherForm.get('branch').setValue(data[0]['branch_name']);
      }
      this.enableCVUpdateMode(); // Disable fields when updating
      this.creditvoucherForm
        .get('types')
        .setValue(
          parseInt(data[0]['packagecount']) > 0 ? 'package' : 'nopackage'
        );
      if (parseInt(data[0]['packagecount']) > 0) {
        this.showpkg = true;
        // console.log(data[0]['id']);
        this.service
          .getCrditVoucherPackageData(parseInt(data[0]['id']))
          .subscribe((res) => {
            console.log(res);
            //assign these data to selectedPackages array
            let data = res;
            Object(data).map((a) => {
              this.selectedPackages.push({
                id: a['id'],
                pkg_id: a['pkg_id'],
                pkg_name: a['pkg_name'],
                pkg_amt: a['pkg_price'],
                client_name: a['client_name'],
                isupdated: 'N',
              });
            });
            console.log(this.selectedPackages);
          });
      } else {
        this.showpkg = false;
      }
      this.creditvoucherForm
        .get('subscription')
        .setValue(
          data[0]['subscription'] == null ? 0 : data[0]['subscription']
        );
      // console.log(parseInt(data[0]['subscription']));

      if (
        data[0]['subscription'] != null &&
        parseInt(data[0]['subscription']) > 0
      ) {
        // mainIdObject = [{ s_id: 0, a_id: 0, b_id: 0, i_id: 0 }];
        this.mainIdObject['s_id'] = parseInt(data[0]['s_id']);
        // console.log('sub_names', data[0]['sub_names'].split(','));
        this.sub_id = data[0]['sub_id'];
        this.names =
          data[0]['sub_names'] === null ? [] : data[0]['sub_names'].split(',');
      }
      this.creditvoucherForm
        .get('isale')
        .setValue(data[0]['issuesale'] == null ? 0 : data[0]['issuesale']);
      if (data[0]['issuesale'] != null && parseInt(data[0]['issuesale']) > 0) {
        // console.log('issuesale_names', data[0]['issuesale_names'].split(','));
        this.mainIdObject['i_id'] = parseInt(data[0]['i_id']);
        this.issue_id = data[0]['issue_id'];
        this.names1 =
          data[0]['issuesale_names'] === null
            ? []
            : data[0]['issuesale_names'].split(',');
      }
      this.creditvoucherForm
        .get('adverties')
        .setValue(
          data[0]['advertiesment'] == null ? 0 : data[0]['advertiesment']
        );
      // console.log(parseInt(data[0]['advertiesment']));
      if (
        data[0]['advertiesment'] != null &&
        parseInt(data[0]['advertiesment']) > 0
      ) {
        this.mainIdObject['a_id'] = data[0]['a_id'];
        // console.log('advt_names', data[0]['advt_names'].split(','));
        this.advt_id = parseInt(data[0]['advt_id']);
        this.names2 =
          data[0]['advt_names'] === null
            ? []
            : data[0]['advt_names'].split(',');
      }
      this.creditvoucherForm
        .get('deposits')
        .setValue(data[0]['deposits'] == null ? 0 : data[0]['deposits']);
      this.creditvoucherForm
        .get('depositsname').setValue(data[0]['depositsname']);
      if (data[0]['deposits'] != null && parseInt(data[0]['deposits']) > 0) {
        // console.log('deposits_names', data[0]['deposits_names'].split(','));
        this.deposits_id = data[0]['deposits_id'];
        // this.names3 =
        //   data[0]['deposits_names'] === null
        //     ? []
        //     : data[0]['deposits_names'].split(',');
      }
      this.creditvoucherForm
        .get('granthbook')
        .setValue(data[0]['book_price'] == null ? 0 : data[0]['book_price']);
      if (data[0]['book_price'] != null && parseInt(data[0]['book_price']) > 0) {
        // console.log('book_names', data[0]['book_names'].split(','));
        // this.mainIdObject['b_id'] = parseInt(data[0]['b_id']);
        this.book_id = data[0]['book_id'];
        // this.names4 =
        //   data[0]['book_names'] === null
        //     ? []
        //     : data[0]['book_names'].split(',');
      }
      this.creditvoucherForm
        .get('booksellername')
        .setValue(data[0]?.book_seller_name ?? '');
      this.creditvoucherForm
        .get('granthbooknames')
        .setValue(data[0]?.book_names ?? '');
      this.creditvoucherForm
        .get('donation')
        .setValue(data[0]['donation'] == null ? 0 : data[0]['donation']);
      if (data[0]['donation'] != null && parseInt(data[0]['donation']) > 0) {
        // console.log('donation_names', data[0]['donation_names'].split(','));
        this.donation_id = data[0]['donation_id'];
        this.names5 =
          data[0]['donation_names'] === null
            ? []
            : data[0]['donation_names'].split(',');
      }
      this.creditvoucherForm
        .get('odeposit')
        .setValue(
          data[0]['other_deposit'] == null ? 0 : data[0]['other_deposit']
        );
      if (
        data[0]['other_deposit'] != null &&
        parseInt(data[0]['other_deposit']) > 0
      ) {
        // console.log('donation_names', data[0]['donation_names'].split(','));
        this.other_deposits_id = data[0]['other_deposits_id'];
        this.names6 =
          data[0]['other_deposits_name'] === null
            ? []
            : data[0]['other_deposits_name'].split(',');
      }
      this.creditvoucherForm
        .get('packagecount')
        .setValue(data[0]['packagecount']);
      this.creditvoucherForm
        .get('packageamount')
        .setValue(data[0]['packageamount']);
      this.creditvoucherForm
        .get('otheramount')
        .setValue(data[0]['otheramount']);
      this.creditvoucherForm.get('total').setValue(data[0]['total']);
      this.total_amt = parseFloat(data[0]['total']);
      this.creditvoucherForm
        .get('expenditure')
        .setValue(data[0]['expenditure']);
      if (parseFloat(data[0]['expenditure']) > 0) {
        //get the credit expense data
        this.service
          .getCreditMainExpenseDataById(parseInt(data[0]['id']))
          .subscribe((res) => {
            if (Object.keys(res).length > 0) {
              for (let index = 0; index < Object.keys(res).length; index++) {
                this.service
                  .getCreditSubExpenseDataById(parseInt(res[index]['id']))
                  .subscribe((result) => {
                    if (Object.keys(result).length > 0) {
                      this.selectedMainExpenses.push({
                        id: res[index]['id'],
                        mainexpid: res[index]['exp_id'],
                        expamt: res[index]['exp_amt'],
                        mainexpname: res[index]['exp_name'],
                        isUpdated: 'N',
                        isSubExp: 'Y',
                      });
                      for (
                        let index1 = 0;
                        index1 < Object.keys(result).length;
                        index1++
                      ) {
                        this.selectedsubExpenses.push({
                          id: result[index1]['id'],
                          subexpid: result[index1]['sub_exp_id'],
                          expamt: result[index1]['sub_exp_amt'],
                          mainexpid: res[index]['exp_id'],
                          mainexpname: res[index]['exp_name'],
                          subexpname: result[index1]['sub_exp_name'],
                          isUpdated: 'N',
                        });
                      }
                    } else {
                      this.selectedMainExpenses.push({
                        id: res[index]['id'],
                        mainexpid: res[index]['exp_id'],
                        expamt: res[index]['exp_amt'],
                        mainexpname: res[index]['exp_name'],
                        isUpdated: 'N',
                        isSubExp: 'N',
                      });
                    }
                  });
              }
            }
          });
      }
      if (parseFloat(data[0]['deposit_amt']) > 0) {
        //get the credit expense data
        this.service
          .get_other_deposit_main_expenses_by_cv_id(parseInt(data[0]['id']))
          .subscribe((res) => {
            console.log(res);
            if (Object.keys(res).length > 0) {
              this.selectedMainExpenses1 = []
              for (let index = 0; index < Object.keys(res).length; index++) {
                // this.selectedMainExpenses.push({
                //   id: res[index]['id'],
                //   exp_id: res[index]['exp_id'],
                //   expamt: res[index]['exp_amt'],
                //   mainexpname: res[index]['exp_name'],
                //   isUpdated: 'N',
                // });
                this.service
                  .get_other_deposit_sub_expenses_by_exp_id(parseInt(res[index]['id']))
                  .subscribe((result) => {
                    console.log(result);
                    if (Object.keys(result).length > 0) {
                      this.selectedMainExpenses1.push({
                        id: res[index]['id'],
                        mainexpid: res[index]['exp_id'],
                        expamt: res[index]['exp_amt'],
                        mainexpname: res[index]['exp_name'],
                        isUpdated: 'N',
                        isSubExp: 'Y',
                      });
                      for (
                        let index1 = 0;
                        index1 < Object.keys(result).length;
                        index1++
                      ) {
                        this.selectedsubExpenses1.push({
                          id: result[index1]['id'],
                          subexpid: result[index1]['sub_exp_id'],
                          expamt: result[index1]['sub_exp_amt'],
                          mainexpid: res[index]['exp_id'],
                          credit_main_exp_id: res[index]['id'],
                          mainexpname: res[index]['exp_name'],
                          subexpname: result[index1]['sub_exp_name'],
                          isUpdated: 'N',
                          isSubExp: 'Y',
                        });
                      }
                    }
                    else {
                      this.selectedMainExpenses1.push({
                        id: res[index]['id'],
                        mainexpid: res[index]['exp_id'],
                        expamt: res[index]['exp_amt'],
                        mainexpname: res[index]['exp_name'],
                        isUpdated: 'N',
                        isSubExp: 'Y',
                      });
                    }
                  });
              }
            }
          });
      }
      this.creditvoucherForm.get('totalexp').setValue(data[0]['totalexp']);
      this.creditvoucherForm.get('ndeposit').setValue(data[0]['net_deposit']);
    });
  }

  selected_journal_vouchers(event, option) {
    this.service.getJournalVoucherData(option['voucher_no']).subscribe((data) => {
    });
  }

  showJVupdate = false;
  // searchJournalVoucher() {
  //   debugger
  //   console.log('Search function triggered');
  //   const voucherNum = this.journalvoucher.get('searchVoucherNum')?.value;

  //   this.updatevoucherno = voucherNum;

  //   if (!voucherNum) {
  //     console.warn('No voucher number entered');
  //     return;
  //   }

  //   this.service.getJournalVoucherData(voucherNum).subscribe((data: any) => {
  //     // console.log('API Response:', data); 

  //     if (!data.journal_voucher) {
  //       alert('Journal voucher not found');
  //       return;
  //     }

  //     if (data) {

  //       this.journalvoucher.patchValue({
  //         voucherdate: data.entry_date || '',
  //         jvouchernum: data.journal_voucher || '',
  //         narration: data.narration || ''
  //       });

  //       if (data.expenses && Array.isArray(data.expenses)) {
  //         // Map through the expenses and bind the values
  //         this.items1 = data.expenses.map((exp: any) => ({
  //           id: exp.id || null,
  //           expense: exp.exp_id || '',  // Set initial value for expenses
  //           subExpense: exp.sub_exp_id || '',  // Set initial value for sub-expenses
  //           amount: exp.amount || 0,
  //           amt_status: exp.amt_status || 'DR',
  //           status: 'update'
  //         }));

  //         // this.setMainExpData(data.expenses); // Function to populate mainExpData
  //         // this.setSubExpData(data.expenses);  // Function to populate getSubExpData1
  //         // this.getMainExpenseData();

  //       } else {
  //         console.warn('Invalid expenses data format:', data.expenses);
  //         this.items1 = [];
  //       }
  //       this.showJVupdate = true;
  //     } else {
  //       alert('Journal Voucher not found!');
  //     }
  //   }, error => {
  //     console.error('Error fetching voucher:', error);
  //   });
  // }

  searchJournalVoucher() {
    const voucherNum = this.journalvoucher.get('searchVoucherNum')?.value;
    this.updatevoucherno = voucherNum;

    if (!voucherNum) return;

    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');

    this.service.getJournalVoucherData(voucherNum, startDate, endDate).subscribe((data: any) => {

      if (!data?.journal_voucher) {
        alert('Journal voucher not found');
        return;
      }

      this.journalvoucher.patchValue({
        voucherdate: data.entry_date || '',
        jvouchernum: data.journal_voucher || '',
        narration: data.narration || ''
      });

      if (Array.isArray(data.expenses)) {

        this.items1 = data.expenses.map((exp: any) => ({
          id: exp.id || null,
          expense: exp.exp_id || '',
          subExpense: exp.sub_exp_id || '',
          amount: exp.amount || 0,
          amt_status: exp.amt_status || 'DR',
          status: 'update',
          subExpenses: []
        }));

        this.items1.forEach((item, index) => {
          if (item.expense) {
            this.service.getSubExpenseLedgerWithId(item.expense).subscribe((subs: any[]) => {
              this.items1[index].subExpenses = subs || [];

              this.items1[index].subExpense = data.expenses[index].sub_exp_id || '';
            });
          }
        });

      } else {
        this.items1 = [];
      }

      this.showJVupdate = true;

    }, error => {
      console.error('Error fetching voucher:', error);
    });
  }

  setMainExpData(expenses: any[]) {
    // Dynamically create mainExpData based on expenses data
    this.mainExpData = expenses.map((exp: any) => ({
      id: exp.exp_id,
      exp_name: exp.exp_name || `Expense ${exp.exp_id}` // Assuming there's a name or fallback
    }));
    console.log('Main Expenses Data:', this.mainExpData);
  }

  setSubExpData(expenses: any[]) {
    const subExpenses = new Set();
    expenses.forEach((exp: any) => {
      if (exp.sub_exp_id && exp.sub_exp_name) {
        subExpenses.add({ sub_id: exp.sub_exp_id, sub_exp_name: exp.sub_exp_name });
      }
    });

    // Convert the set back to an array
    this.getSubExpData1 = Array.from(subExpenses);
  }

  updatepkgId = 0;
  isupdatepkgamt: boolean = false;

  isUpdate: boolean = false;
  updatepkg(item) {
    this.updatepkgId = 0;
    this.isupdatepkgamt = false;
    this.isUpdate = true;
    this.creditvoucherForm.get('package').setValue(item['pkg_name']);
    this.creditvoucherForm.get('packagename').setValue(item['client_name']);
    this.creditvoucherForm.get('packageamt').setValue(item['pkg_amt']);

    this.updatepkgId = item['id'];
    console.log(item);
    this.packageData.map((pkg) => {
      if (
        item['pkg_id'] === pkg['pkg_id'] &&
        item['package'] != pkg['package']

      ) {
        this.isupdatepkgamt = true;
        console.log(pkg);
        this.creditvoucherForm.get('packageamt').setValue(item['pkg_amt']);
      }
    });
  }

  updateSelectedPkg() {
    for (
      let index = 0;
      index < Object.keys(this.selectedPackages).length;
      index++
    ) {
      if (this.updatepkgId === this.selectedPackages[index]['id']) {
        if (this.selectedPackageId != 0) {
          for (
            let index = 0;
            index < Object.keys(this.packageData).length;
            index++
          ) {
            if (
              this.packageData[index]['pkg_id'] == this.selectedPackageId &&
              this.packageData[index]['pkg_name'] ==
              this.creditvoucherForm.get('package').value
            ) {
              this.selectedPackages[index]['pkg_id'] =
                this.packageData[index]['pkg_id'];
              this.selectedPackages[index]['client_name'] =
                this.creditvoucherForm.get('packagename').value;
              this.selectedPackages[index]['pkg_name'] =
                this.packageData[index]['pkg_name'];
              this.selectedPackages[index]['isupdated'] = 'Y';
              if (this.pkgAmount !== 0) {
                this.selectedPackages[index]['pkg_amt'] = this.pkgAmount;
              } else {
                this.selectedPackages[index]['pkg_amt'] =
                  this.packageData[index]['pkg_amt'];
              }
            }
          }
        } else {
          this.selectedPackages[index]['client_name'] =
            this.creditvoucherForm.get('packagename').value;
          this.selectedPackages[index]['pkg_name'] =
            this.creditvoucherForm.get('package').value;
          this.selectedPackages[index]['isupdated'] = 'Y';
          if (this.isupdatepkgamt) {
            this.selectedPackages[index]['pkg_amt'] =
              this.creditvoucherForm.get('packageamt').value;
          }
        }
      }
    }
    this.creditvoucherForm.get('package').reset();
    this.creditvoucherForm.get('packagename').reset();
    this.creditvoucherForm.get('packageamt').reset();
    // this.selectedPackages = this.uniqueid(this.selectedPackages, (a) => a.pkg_id);
    // console.log(this.selectedPackages);
    let pkg_amt_total = 0;
    for (let i = 0; i < Object.keys(this.selectedPackages).length; i++) {
      pkg_amt_total =
        pkg_amt_total + parseInt(this.selectedPackages[i]['pkg_amt']);
    }
    this.creditvoucherForm.get('packageamount').setValue(pkg_amt_total);
    this.creditvoucherForm
      .get('packagecount')
      .setValue(Object.keys(this.selectedPackages).length);
    this.totalAmt();
  }


  update_creditvoucher() {

    this.forupdate = this.creditvoucherForm.get('vnumber').value;

    this.service.getCreditVoucherNo(this.forupdate).pipe(

      /* ================= CONFIRM + MAIN PAYLOAD ================= */
      switchMap(() => {

        if (!confirm('Do you want update credit voucher')) {
          return EMPTY;
        }

        const creditvoucher = {
          id: this.crdt_voucher_id,
          bcaccount: this.creditvoucherForm.get('bcaccount').value,
          vnumber: this.creditvoucherForm.get('vnumber').value,
          voucherdate: this.creditvoucherForm.get('voucherdate').value,
          rname: this.creditvoucherForm.get('rname').value,
          othername: this.creditvoucherForm.get('othername').value,
          damount: this.creditvoucherForm.get('damount').value,
          pymtoptions: this.creditvoucherForm.get('pymtoptions').value,
          cnumber: this.creditvoucherForm.get('cnumber').value,
          bank: this.creditvoucherForm.get('bank').value,
          branch: this.creditvoucherForm.get('branch').value,
          pancard: this.creditvoucherForm.get('pancard').value,
          narration: this.creditvoucherForm.get('narration').value,
          chequedate: new Date(
            new Date(this.creditvoucherForm.get('chequedate').value)
              .setDate(new Date(this.creditvoucherForm.get('chequedate').value).getDate() + 1)
          ),
          entrydate: this.creditvoucherForm.get('entrydate').value,
          deposits: this.creditvoucherForm.get('deposits').value,
          depositsname: this.creditvoucherForm.get('depositsname').value,
          donation: this.creditvoucherForm.get('donation').value,
          odeposit: this.creditvoucherForm.get('odeposit').value,
          packagecount: this.creditvoucherForm.get('packagecount').value,
          packageamount: this.creditvoucherForm.get('packageamount').value,
          otheramount: this.creditvoucherForm.get('otheramount').value,
          total: this.creditvoucherForm.get('total').value,
          expenditure: this.creditvoucherForm.get('expenditure').value,
          totalexp: this.creditvoucherForm.get('totalexp').value,
          ndeposit: this.creditvoucherForm.get('ndeposit').value,
        };

        if (+creditvoucher.ndeposit !== +creditvoucher.damount) {
          alert('Please check the amount.');
          return EMPTY;
        }

        return this.service.updatecreditVoucher(creditvoucher);
      }),

      /* ================= PACKAGES ================= */
      switchMap(() => {
        debugger

        if (!this.packagesUpdated) return of(null);

        const payload = {
          credit_id: this.crdt_voucher_id,
          packages: []
        };

        this.selectedPackages.forEach(selected => {

          const pkg = this.packageData.find(p => p.pkg_id === selected.pkg_id);
          if (!pkg) return;

          const packageInfo = {
            pkg_id: selected.pkg_id,
            pkg_name: selected.pkg_name,
            client_name: selected.client_name,
            pkg_amt: selected.pkg_amt,
            details: []
          };

          pkg.periodicity.split(',').forEach(period => {

            const suffix =
              period === '1 year' ? '1' :
                period === '3 year' ? '3' :
                  period === '5 year' ? '5' : null;

            if (!suffix) return;

            packageInfo.details.push({
              year: period,
              sub_actual_amt: pkg[`vivek_m_${suffix}_actual_amt`],
              sub_concession_amt: pkg[`vivek_m_${suffix}_concession_amt`],
              vivek_h_actual_amt: pkg[`vivek_h_${suffix}_actual_amt`],
              vivek_h_concession_amt: pkg[`vivek_h_${suffix}_concession_amt`],
              vaidyraj_actual_amt: pkg[`vaidyraj_${suffix}_actual_amt`],
              vaidyraj_concession_amt: pkg[`vaidyraj_${suffix}_concession_amt`],
              granth_actual_amt: pkg[`granth1_${suffix}_actual_amt`],
              granth_concession_amt: pkg[`granth1_${suffix}_concession_amt`],
              granth_remaining_amt: selected.pkg_amt,
              book_actual_amt: pkg[`granth2_${suffix}_actual_amt`],
              book_concession_amt: pkg[`granth2_${suffix}_concession_amt`],
              donation_actual_amt: pkg[`donation_${suffix}_actual_amt`],
              donation_concession_amt: pkg[`donation_${suffix}_concession_amt`],
              courier_actual_amt: pkg[`courier_${suffix}_actual_amt`],
              courier_concession_amt: pkg[`courier_${suffix}_concession_amt`],
              advt_actual_amt: pkg[`advt_${suffix}_actual_amt`],
              advt_concession_amt: pkg[`advt_${suffix}_concession_amt`],
              other_actual_amt: pkg[`other_${suffix}_actual_amt`],
              other_concession_amt: pkg[`other_${suffix}_concession_amt`],
            });
          });

          payload.packages.push(packageInfo);
        });

        return this.service.bulkInsertCrdtPackagesAndDetails(payload).pipe(
          tap(() => this.packagesUpdated = false)
        );
      }),

      /* ================= ALL NAME / CHILD UPDATES ================= */
      switchMap(() => forkJoin([

        /* SUBSCRIPTION */
        this.service.updateCrdtVoucherSubcribers({
          crdt_voucher_id: this.crdt_voucher_id,
          subscription: this.creditvoucherForm.get('subscription').value,
        }).pipe(
          switchMap((res: any) =>
            this.service.updateCrdtVoucherSubscribersNames(res.id, this.names.toString())
              .pipe(tap(() => {
                // Clear subscription names after successful update
                this.names = [];
              }),
                catchError((error) => {
                  console.error('Error occurred in updateCrdtVoucherSubscribersNames method:', error);
                  return of(null);
                }))
          )
        ),

        /* ISSUE SALE */
        this.service.updateCreditVoucherIssueSale({
          crdt_voucher_id: this.crdt_voucher_id,
          isale: this.creditvoucherForm.get('isale').value,
        }).pipe(
          switchMap((res: any) =>
            this.service.updateCrdtVoucherIssueSaleNames(res.id, this.names1.toString())
              .pipe(tap(() => {
                // Clear subscription names after successful update
                this.names1 = [];
              }),
                catchError((error) => {
                  console.error('Error occurred in updateCrdtVoucherIssueSaleNames method:', error);
                  return of(null);
                }))
          )
        ),

        /* ADVT */
        this.service.updateCreditVoucherAdvt({
          crdt_voucher_id: this.crdt_voucher_id,
          adverties: this.creditvoucherForm.get('adverties').value,
        }).pipe(
          switchMap((res: any) =>
            this.service.updateCrdtVoucherAdvtNames(res.id, this.names2.toString())
              .pipe(tap(() => {
                // Clear advertisement names after successful update
                this.names2 = [];
              }),
                catchError((error) => {
                  console.error('Error occurred in updateCrdtVoucherAdvtNames method:', error);
                  return of(null);
                }))
          )
        ),

        /* BOOK */
        this.service.updateCreditVoucherBook({
          crdt_vucher_id: this.crdt_voucher_id,
          granthbook: this.creditvoucherForm.get('granthbook').value,
        }).pipe(
          switchMap((res) =>
            this.service.updateCrdtVoucherBookNames(
              res.id,
              this.creditvoucherForm.get('booksellername').value,
              this.creditvoucherForm.get('granthbooknames').value
            ).pipe(catchError(() =>
              this.service.insertCreditVoucherBookNames(
                res.id,
                this.creditvoucherForm.get('booksellername').value,
                this.creditvoucherForm.get('granthbooknames').value
              )
            ))
          )
        )

      ])),

      /* ================= OTHER DEPOSIT EXPENSES ================= */
      switchMap(() => {

        if (!this.otherDepositExpensesUpdated) return of(null);

        const payload = {
          voucher_id: this.crdt_voucher_id,
          expenses: this.selectedMainExpenses1.map(mainExp => ({
            mainexpid: mainExp.mainexpid,
            expamt: mainExp.expamt,
            subexpenses: this.selectedsubExpenses1
              .filter(sub => sub.mainexpid === mainExp.mainexpid)
              .map(sub => ({
                subexpid: sub.subexpid,
                expamt: sub.expamt
              }))
          }))
        };

        return this.service.saveCrdtVoucherAllOtherExpenses(payload).pipe(
          tap(() => this.otherDepositExpensesUpdated = false)
        );
      }),

      /* ================= EXPENDITURE EXPENSES ================= */
      switchMap(() => {

        if (!this.expenditureExpensesUpdated) return of(null);

        const payload = {
          voucher_id: this.crdt_voucher_id,
          expenses: this.selectedMainExpenses.map(mainExp => ({
            mainexpid: mainExp.mainexpid,
            expamt: mainExp.expamt,
            subexpenses: this.selectedsubExpenses
              .filter(sub => sub.mainexpid === mainExp.mainexpid)
              .map(sub => ({
                subexpid: sub.subexpid,
                expamt: sub.expamt
              }))
          }))
        };

        return this.service.saveCrdtVoucherAllExpExpenses(payload).pipe(
          tap(() => this.expenditureExpensesUpdated = false)
        );
      })

    ).subscribe({
      next: () => {
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Credit Voucher has been updated successfully.',
          showConfirmButton: true,
          timer: 3000
        }).then((result) => {
          if (result.isConfirmed || result.isDismissed) {
            this.creditvoucherForm.reset();
            this.selectedPackages = [];
            this.selectedMainExpenses = [];
            this.selectedsubExpenses = [];
            this.selectedMainExpenses1 = [];
            this.selectedsubExpenses1 = [];
            this.showpkg = false;
          }
        });
      },
      error: (err) => {
        console.error('Update Error:', err);
        let errorMessage = 'Error while updating credit voucher';

        if (err.status === 422) {
          errorMessage = 'Validation error. Please check your data.';
        } else if (err.status === 404) {
          errorMessage = 'Credit voucher not found.';
        } else if (err.status === 500) {
          errorMessage = 'Server error. Please try again later.';
        }

        Swal.fire({
          icon: 'error',
          title: 'Update Failed',
          text: errorMessage,
          confirmButtonText: 'OK'
        });
      }
    });
  }


  showUpdateOnMainOrSub: boolean = false;
  main_exp_id = 0;
  updateMainExp(item) {
    // console.log(item);
    debugger
    this.showUpdateOnMainOrSub = true;
    this.main_exp_id = item['id'];
    this.creditvoucherForm.get('expname').setValue(item['mainexpid']);
    this.creditvoucherForm.get('exp_amt').setValue(item['expamt']);

    this.subexpense = false;
  }

  showUpdateOnMainOrSubOther11: boolean = false;
  debit_main_exp_id = 0;
  updateDebitMainExp(item) {
    this.showUpdateOnMainOrSubOther11 = true;

    this.debit_main_exp_id = item['mainexpid'];
    this.debitmainexpId = this.debit_main_exp_id;
    this.debitmainexpName = item['mainexpname'];

    this.debitForm.get('expname').setValue(item['mainexpid']);
    this.debitForm.get('expamt').setValue(item['expamt']);
    this.debitForm.get('subexpname')?.setValue('');
    this.debitsubexpense = false;
  }

  debitsubexpense: any
  sub_exp_id11: any
  debit_sub_exp_id = 0;
  updateDebitSubExp(item) {
    debugger
    this.showUpdateOnMainOrSubOther11 = true;

    this.getDebitMainExpName({ value: item['mainexpid'] });
    this.debitmainexpId = item['mainexpid'];
    this.debitsub_expId = item['subexpid'];
    this.debitsub_expName = item['subexpname'];
    this.debitmainexpName = item['mainexpname'];

    this.debitForm.get('expname').setValue(item['mainexpid']);
    this.debitsubexpense = true;
    this.debitForm.get('subexpname').setValue(item['subexpid']);
    this.debitForm.get('expamt').setValue(item['expamt']);
  }

  showUpdateOnMainOrSubOther: boolean = false;

  updateMainExp1(item) {
    // console.log(item);
    this.showUpdateOnMainOrSubOther = true;
    this.main_exp_id = item['id'];
    this.creditvoucherForm.get('expnameotherd').setValue(item['mainexpid']);
    this.creditvoucherForm.get('exp_amtother').setValue(item['expamt']);
    // this.creditvoucherForm.get('subexpnameotherd')?.setValue('');
    this.subexpense1 = false;
  }

  sub_exp_id = 0;
  updateSubExp(item) {
    debugger
    this.showUpdateOnMainOrSub = true;
    this.getMainExpName({ value: item['mainexpid'] });
    this.sub_exp_id = item['id'];
    this.creditvoucherForm.get('expname').setValue(item['mainexpid']);
    this.subexpense = true;
    this.creditvoucherForm.get('subexpname').setValue(item['subexpid']);
    this.creditvoucherForm.get('exp_amt').setValue(item['expamt']);
  }

  subexpense1: any
  sub_exp_id1: any
  updateSubExp1(item) {
    this.showUpdateOnMainOrSubOther = true;
    this.getMainExpName1({ value: item['mainexpid'] });
    this.sub_exp_id1 = item['id'];
    this.creditvoucherForm.get('expnameotherd').setValue(item['mainexpid']);
    this.subexpense1 = true;
    this.creditvoucherForm.get('subexpnameotherd').setValue(item['subexpid']);
    this.creditvoucherForm.get('exp_amtother').setValue(item['expamt']);
  }

  updateMainExpense() {
    const expAmt = parseFloat(this.creditvoucherForm.get('exp_amt')?.value) || 0;

    if (this.subexpense) {
      // SUB-EXPENSE update
      for (let i = 0; i < this.selectedsubExpenses.length; i++) {
        const sub = this.selectedsubExpenses[i];
        if (sub['id'] === this.sub_exp_id) {
          if (sub['subexpid'] !== this.sub_expId && this.sub_expId !== 0) {
            sub['subexpid'] = this.sub_expId;
            sub['subexpname'] = this.sub_expName;
          }

          if (sub['mainexpid'] !== this.mainexpId && this.mainexpId !== 0) {
            const oldMain = this.selectedMainExpenses.find(m => m['mainexpid'] === sub['mainexpid']);
            const newMain = this.selectedMainExpenses.find(m => m['mainexpid'] === this.mainexpId);
            if (oldMain) oldMain['isUpdated'] = 'Y';
            if (newMain) newMain['isUpdated'] = 'Y';

            sub['mainexpname'] = this.mainexpName;
            sub['mainexpid'] = this.mainexpId;
          } else {
            const main = this.selectedMainExpenses.find(m => m['mainexpid'] === sub['mainexpid']);
            if (main) main['isUpdated'] = 'Y';
          }

          sub['expamt'] = expAmt;
          sub['isUpdated'] = 'Y';

          this.creditvoucherForm.get('exp_amt')?.reset();
          this.creditvoucherForm.get('expname')?.reset();
          this.creditvoucherForm.get('subexpname')?.reset();

          this.sub_expName = '';
          this.sub_expId = 0;
          this.mainexpName = '';
          this.mainexpId = 0;
          this.subexpense = false;

          break;
        }
      }

    } else {
      // MAIN EXPENSE update — only if no sub-expenses exist
      for (let j = 0; j < this.selectedMainExpenses.length; j++) {
        const main = this.selectedMainExpenses[j];
        if (main['id'] === this.main_exp_id) {
          const hasSubs = this.selectedsubExpenses.some(sub => sub['mainexpid'] === main['mainexpid']);
          if (hasSubs) {
            alert('This expense has sub-expenses and cannot be updated directly.');
            return;
          }

          if (main['mainexpid'] !== this.mainexpId && this.mainexpId !== 0) {
            main['mainexpid'] = this.mainexpId;
            main['mainexpname'] = this.mainexpName;
          }

          main['expamt'] = expAmt;
          main['isUpdated'] = 'Y';

          this.creditvoucherForm.get('exp_amt')?.reset();
          this.creditvoucherForm.get('expname')?.reset();

          this.mainexpId = 0;
          this.mainexpName = '';
          break;
        }
      }
    }

    // Recalculate amount only for those having sub-expenses
    for (const main of this.selectedMainExpenses) {
      const subList = this.selectedsubExpenses.filter(sub => sub['mainexpid'] === main['mainexpid']);
      if (subList.length > 0) {
        main['expamt'] = subList.reduce((sum, sub) => sum + parseFloat(sub['expamt'] || 0), 0);
      }
    }

    this.showUpdateOnMainOrSub = false;
    this.expenditureExpensesUpdated = true;
    this.totalAmount();
  }

  updateMainExpense1() {
    const expAmt = parseFloat(this.creditvoucherForm.get('exp_amtother')?.value) || 0;

    if (this.subexpense1) {
      // SUB-EXPENSE update path
      for (let i = 0; i < this.selectedsubExpenses1.length; i++) {
        const sub = this.selectedsubExpenses1[i];
        if (sub['id'] === this.sub_exp_id1) {
          if (sub['sub_exp_id'] !== this.sub_expId1 && this.sub_expId1 !== 0) {
            sub['subexpname'] = this.sub_expName1;
            sub['sub_exp_id'] = this.sub_expId1;
          }

          if (sub['mainexpid'] !== this.mainexpId1 && this.mainexpId1 !== 0) {
            const oldMain = this.selectedMainExpenses1.find(m => m['mainexpid'] === sub['mainexpid']);
            const newMain = this.selectedMainExpenses1.find(m => m['mainexpid'] === this.mainexpId1);
            if (oldMain) oldMain['isUpdated'] = 'Y';
            if (newMain) newMain['isUpdated'] = 'Y';

            sub['mainexpname'] = this.mainexpName1;
            sub['mainexpid'] = this.mainexpId1;
          } else {
            const main = this.selectedMainExpenses1.find(m => m['mainexpid'] === sub['mainexpid']);
            if (main) main['isUpdated'] = 'Y';
          }

          sub['expamt'] = expAmt;
          sub['isUpdated'] = 'Y';

          this.creditvoucherForm.get('exp_amtother')?.reset();
          this.creditvoucherForm.get('expnameotherd')?.reset();
          this.creditvoucherForm.get('subexpnameotherd')?.reset();

          this.sub_expName1 = '';
          this.sub_expId1 = 0;
          this.mainexpName1 = '';
          this.mainexpId1 = 0;
          this.subexpense1 = false;

          break;
        }
      }

    } else {
      // MAIN EXPENSE update — only if no sub-expenses exist
      for (let j = 0; j < this.selectedMainExpenses1.length; j++) {
        const main = this.selectedMainExpenses1[j];
        if (main['id'] === this.main_exp_id) {
          const hasSubs = this.selectedsubExpenses1.some(sub => sub['mainexpid'] === main['mainexpid']);
          if (hasSubs) {
            alert('This expense has sub-expenses and cannot be updated directly.');
            return;
          }

          if (main['mainexpid'] !== this.mainexpId && this.mainexpId !== 0) {
            main['mainexpid'] = this.mainexpId;
            main['mainexpname'] = this.mainexpName;
          }

          main['expamt'] = expAmt;
          main['isUpdated'] = 'Y';

          this.creditvoucherForm.get('exp_amtother')?.reset();
          this.creditvoucherForm.get('expnameotherd')?.reset();

          this.mainexpId = 0;
          this.mainexpName = '';
          break;
        }
      }
    }

    // Recalculate main expenses from sub-expenses (if any)
    for (let i = 0; i < this.selectedMainExpenses1.length; i++) {
      const main = this.selectedMainExpenses1[i];
      const subList = this.selectedsubExpenses1.filter(sub => sub['mainexpid'] === main['mainexpid']);

      if (subList.length > 0) {
        main['expamt'] = subList.reduce((total, sub) => total + parseFloat(sub['expamt'] || 0), 0);
      }
    }

    this.showUpdateOnMainOrSubOther = false;
    this.otherDepositExpensesUpdated = true;
    this.totalAmount1();
  }


  selectedPackageData = [];
  selectedPackageId;
  selectpackage(id) {
    this.isUpdate = false;
    this.selectedPackageId = 0;
    // console.log(this.packageData);

    for (let index = 0; index < Object.keys(this.packageData).length; index++) {
      if (this.packageData[index]['pkg_id'] == id) {
        this.selectedPackageId = id;
        this.selectedPackageData = this.packageData[index];
      }
    }
    // console.log(Object.keys(this.selectedPackageData).length);
    if (Object.keys(this.selectedPackageData).length != 0) {
      this.creditvoucherForm
        .get('package')
        .setValue(this.selectedPackageData['pkg_name']);
    }
  }

  selectedPackages = [];
  addPackage() {
    if (this.selectedPackageId != 0) {
      for (
        let index = 0;
        index < Object.keys(this.packageData).length;
        index++
      ) {
        if (
          this.packageData[index]['pkg_id'] == this.selectedPackageId &&
          this.packageData[index]['pkg_name'] ==
          this.creditvoucherForm.get('package').value
        ) {
          if (this.pkgAmount !== 0) {
            this.selectedPackages.push({
              pkg_id: this.packageData[index]['pkg_id'],
              pkg_name: this.packageData[index]['pkg_name'],
              pkg_amt: this.pkgAmount,
              client_name: this.creditvoucherForm.get('packagename').value,
            });
          } else {
            this.selectedPackages.push({
              pkg_id: this.packageData[index]['pkg_id'],
              pkg_name: this.packageData[index]['pkg_name'],
              pkg_amt: this.packageData[index]['pkg_amt'],
              client_name: this.creditvoucherForm.get('packagename').value,
            });
          }
        }
      }
    }
    this.creditvoucherForm.get('package').reset();
    this.creditvoucherForm.get('packagename').reset();
    // this.selectedPackages = this.uniqueid(this.selectedPackages, (a) => a.pkg_id);
    // console.log(this.selectedPackages);
    let pkg_amt_total = 0;
    for (let i = 0; i < Object.keys(this.selectedPackages).length; i++) {
      pkg_amt_total =
        pkg_amt_total + parseInt(this.selectedPackages[i]['pkg_amt']);
    }
    this.creditvoucherForm.get('packageamount').setValue(pkg_amt_total);
    this.creditvoucherForm
      .get('packagecount')
      .setValue(Object.keys(this.selectedPackages).length);
    this.totalAmt();
    this.packagesUpdated = true;
  }

  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  removepkg(i) {
    console.log(i);
    if (window.confirm('Do you really want to remove ?')) {
      this.selectedPackages.splice(i, 1);

      let pkg_amt_total = 0;
      for (let i = 0; i < Object.keys(this.selectedPackages).length; i++) {
        pkg_amt_total =
          pkg_amt_total + parseInt(this.selectedPackages[i]['pkg_amt']);
      }
      this.creditvoucherForm.get('packageamount').setValue(pkg_amt_total);
      this.creditvoucherForm
        .get('packagecount')
        .setValue(Object.keys(this.selectedPackages).length);
      this.totalAmt();
    }
    // console.log(this.selectedPackages);
  }

  pkg_name1 = '';
  getPackageName(event, name) {
    if (event.isUserInput) {
      this.pkg_name1 = name;
      // console.log(name);

      this.filters();
    }
  }

  reset_pkg_name() {
    this.pkg_name1 = '';
    this.pkgBookingregisterForm.get('pkg_name').reset();
    if (
      this.pkg_name1 == '' &&
      this.pkgbrStartDate != '' &&
      this.pkgbrEndDate != ''
    ) {
      this.FilteredpkgBookingData = this.pkgBookingData.filter(
        (a) =>
          a['entry_date'] >= this.pkgbrStartDate &&
          a['entry_date'] <= this.pkgbrEndDate
      );
    } else if (
      this.pkg_name1 == '' &&
      this.pkgbrStartDate == '' &&
      this.pkgbrEndDate == ''
    ) {
      this.FilteredpkgBookingData = this.pkgBookingData;
    }

    this.filteredautocom();
  }

  pkgbrStartDate = '';
  pkgbrEndDate = '';
  // getchangedDates() {
  //   if (
  //     this.repledger.get('start').value != '' &&
  //     this.repledger.get('end').value != ''
  //   ) {
  //     this.pkgbrStartDate = formatDate(
  //       this.repledger.get('start').value,
  //       'yyyy-MM-dd',
  //       'en-IN',
  //       'GMT+0530'
  //     );
  //     this.pkgbrEndDate = formatDate(
  //       this.repledger.get('end').value,
  //       'yyyy-MM-dd',
  //       'en-IN',
  //       'GMT+0530'
  //     );

  //     this.filters();
  //   }
  // }
  getchangedDates1() {
    if (
      this.pkgBookingregisterForm.get('start').value != '' &&
      this.pkgBookingregisterForm.get('end').value != ''
    ) {
      this.pkgbrStartDate = formatDate(
        this.pkgBookingregisterForm.get('start').value,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.pkgbrEndDate = formatDate(
        this.pkgBookingregisterForm.get('end').value,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      console.log(this.pkgbrStartDate, this.pkgbrEndDate, "this.pkgbrStartDate ")

      this.filters();
    }
  }
  repledStartDate = '';
  repledEndDate = '';
  getchangedDatesrepledger() {

    if (!this.hasRepLedgerViewPermission) {
      alert("You don't have permission to View Report!!!");
      this.repledger.reset();
      return;
    }

    if (
      this.repledger.get('start').value != '' &&
      this.repledger.get('end').value != ''
    ) {
      this.repledStartDate = formatDate(
        this.repledger.get('start').value,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.repledEndDate = formatDate(
        this.repledger.get('end').value,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      console.log(this.repledStartDate, this.repledEndDate, "this.pkgbrStartDate ")

      this.filters();
    }
  }

  kharediStartDate = '';
  kharediEndDate = '';
  getchangedDates2() {

    if (
      this.kharedi.get('start').value != '' &&
      this.kharedi.get('end').value != ''
    ) {
      this.kharediStartDate = formatDate(
        this.kharedi.get('start').value,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.kharediEndDate = formatDate(
        this.kharedi.get('end').value,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      console.log(this.kharediStartDate, this.kharediEndDate, "kharedi date ")

      this.filters();
    }
  }
  getrepledger() {

    this.dialog.open(RepledgerComponent, {
      data: {
        data: '',
        startDate: this.repledStartDate,
        endDate: this.repledEndDate,
        repname: this.rep_name2,
        departmentTypes: this.repledger.value.department_type
      },

      width: '1200px',
      height: '1300px',
      maxWidth: '100%',

    });

  }

  filters() {
    if (
      this.pkg_name1 != '' &&
      this.pkgbrStartDate == '' &&
      this.pkgbrEndDate == ''
    ) {
      this.FilteredpkgBookingData = this.pkgBookingData.filter(
        (a) =>
          a['pkg_name'].toLowerCase().indexOf(this.pkg_name1.toLowerCase()) > -1
      );
    } else if (
      this.pkg_name1 != '' &&
      this.pkgbrStartDate != '' &&
      this.pkgbrEndDate != ''
    ) {
      this.FilteredpkgBookingData = this.pkgBookingData.filter((a) => {
        return (
          new Date(a['voucher_date']) >= new Date(this.pkgbrStartDate) &&
          new Date(a['voucher_date']) <= new Date(this.pkgbrEndDate) &&
          a['pkg_name'].toLowerCase().indexOf(this.pkg_name1.toLowerCase()) > -1
        );
      });
    } else if (
      this.pkg_name1 == '' &&
      this.pkgbrStartDate != '' &&
      this.pkgbrEndDate != ''
    ) {
      this.FilteredpkgBookingData = this.pkgBookingData.filter((a) => {
        return (
          new Date(a['voucher_date']) >= new Date(this.pkgbrStartDate) &&
          new Date(a['voucher_date']) <= new Date(this.pkgbrEndDate)
        );
      });
    }
  }

  off_rep_name = '';
  getOffrepnames(event) {
    if (event.isUserInput) {
      this.off_rep_name = event.value;
      // console.log(event.value);
      if (this.off_rep_name != '') {
        this.FilteredpkgBookingData = this.pkgBookingData.filter((a) =>
          this.off_rep_name.includes(a['off_rep_name'])
        );
      }
    }
  }

  rep_name1 = '';
  getrepnames(event) {
    console.log(event);
    this.rep_name1 = event.value;
    if (this.rep_name1 != '') {
      this.FilteredpkgBookingData = this.pkgBookingData.filter((a) => {
        return this.rep_name1.includes(a['rep_name']);
      });
    }
  }

  rep_name2: any;
  getrepnames1(event) {
    console.log(event);
    debugger
    this.rep_name2 = event.option.value;
  }

  reset_rep_name() {
    this.rep_name1 = '';
    this.pkgBookingregisterForm.get('rep_name').reset();
    if (this.rep_name1 == '') {
      this.FilteredpkgBookingData = this.pkgBookingData;
    }
    this.filteredautocom();
  }

  cust_name1 = '';
  getcustnames(event) {
    console.log(event);
    this.cust_name1 = event.value;
    if (this.cust_name1 != '') {
      this.FilteredpkgBookingData = this.pkgBookingData.filter((a) => {
        return this.cust_name1.includes(a['client_name']);
      });
    }
  }

  reset_cust_name() {
    this.cust_name1 = '';
    this.pkgBookingregisterForm.get('cust_name').reset();
    if (this.cust_name1 == '') {
      this.FilteredpkgBookingData = this.pkgBookingData;
    }
    this.filteredautocom();
  }

  addBankName() {
    let bankData = {
      bank_name: this.bankForm.get('bank_name').value,
      bank_short_name: this.bankForm.get('bank_short_name').value,
      bank_o_bal: this.bankForm.get('bank_o_bal').value,
      crdtdebt: this.bankForm.get('crdtdebt').value,
      is_active: 'Y',
    };

    // console.log(bankData);

    this.service.insertBankName(bankData).subscribe((data) => {
      // console.log(data);
      alert('Bank name added successfully...');
      this.bankForm.reset('');
      this.ngOnInit();
    });
  }

  showUpdate: boolean = false;
  bankId = 0;
  selectBankMaster(bank) {
    if (bank) {
      this.showUpdate = true;
      this.bankId = bank['id'];
      this.bankForm.get('bank_name').setValue(bank['bank_name']);
      this.bankForm.get('bank_short_name').setValue(bank['bank_short_name']);
      this.bankForm.get('bank_o_bal').setValue(bank['opening_bal']);
      this.bankForm.get('crdtdebt').setValue(bank['crdt_debt']);
    }
  }

  updateBankMaster() {
    let bankData = {
      id: this.bankId,
      bank_name: this.bankForm.get('bank_name').value,
      bank_short_name: this.bankForm.get('bank_short_name').value,
      bank_o_bal: this.bankForm.get('bank_o_bal').value,
      crdtdebt: this.bankForm.get('crdtdebt').value,
    };

    this.service.updateBankName(bankData).subscribe((res) => {
      alert('Bank details updated successfully...');
      this.bankForm.reset('');
      this.ngOnInit();
    });
  }

  creditdebitledgerdata() {
    this.dialog.open(CreditDebitLedgerReportComponent, {
      data: {
        data: '',
        startDate: this.creditdebitStartDate,
        endDate: this.creditdebitEndDate,
        bank: this.selectedBank,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }

  creditdebitStartDate = '';
  creditdebitEndDate = '';
  getCreditDebitDateRange() {
    debugger
    if (!this.hasBankReportViewPermission) {
      alert("You don't have permission to View Bank Report!!!");
      this.debitForm.get('bcaccount').setValue(null);
      return;
    }
    if (
      this.creditdebitDateRange.get('start').value != null &&
      this.creditdebitDateRange.get('end').value != null
    ) {
      this.creditdebitStartDate = formatDate(
        this.creditdebitDateRange.get('start').value,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      // console.log(this.creditdebitStartDate);

      this.creditdebitEndDate = formatDate(
        this.creditdebitDateRange.get('end').value,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      // console.log(this.creditdebitEndDate);
    }
  }

  selectedBank = '';
  getBankCashOnCD(event) {
    this.selectedBank = event.value;
    // console.log(this.selectedBank);
  }

  reconsilationStartDate = '';
  reconsilationEndDate = '';
  getReconsilationDateRange() {
    if (!this.hasBankRecoViewPermission) {
      alert("You don't have permission to View Bank Reco!!!");
      this.reconsilationDateRange.reset();
      return;
    }
    if (
      this.reconsilationDateRange.get('start').value != null &&
      this.reconsilationDateRange.get('end').value != null
    ) {
      this.reconsilationStartDate = formatDate(
        this.reconsilationDateRange.get('start').value,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      // console.log(this.creditdebitStartDate);

      this.reconsilationEndDate = formatDate(
        this.reconsilationDateRange.get('end').value,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      // console.log(this.creditdebitEndDate);
    }
  }

  expenseledgerStartDate = '';
  expenseledgerEndDate = '';
  expenseledgerDateRange() {
    if (!this.hasExpenseReportViewPermission) {
      alert("You don't have permission to View Report!!!");
      this.expenseledger1.reset();
      return;
    }
    if (
      this.ExpenseLedgerForm.get('start').value != null &&
      this.ExpenseLedgerForm.get('end').value != null
    ) {
      this.expenseledgerStartDate = formatDate(
        this.expenseledger1.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      // console.log(this.creditdebitStartDate);

      this.expenseledgerEndDate = formatDate(
        this.expenseledger1.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );

      const startDateControl = this.expenseledger1.get('start').value;
      const endDateControl = this.expenseledger1.get('end').value;

      if (startDateControl && endDateControl) {
        const startDate = new Date(formatDate(startDateControl, 'yyyy-MM-dd', 'en-IN'));
        const endDate = new Date(formatDate(endDateControl, 'yyyy-MM-dd', 'en-IN'));

        const financialYearStart = new Date(this.financialYearMin);
        const financialYearEnd = new Date(this.financialYearMax);

        if (startDate >= financialYearStart && endDate <= financialYearEnd) {
          this.trialBalanceStartDate = formatDate(startDate, 'yyyy-MM-dd', 'en-IN');
          this.trialBalanceEndDate = formatDate(endDate, 'yyyy-MM-dd', 'en-IN');
        } else {
          alert("Selected dates are not in the current financial year!");
          this.expenseledger1.reset();
          return;
        }
      }
      // console.log(this.creditdebitEndDate);
    }
  }

  trialBalanceStartDate = '';
  trialBalanceEndDate = '';
  trialBalanceDateRange() {
    if (!this.hasExpenseMasterUpdatePermission) {
      alert("You don't have permission to View Report!!!");
      this.trialbalance.reset();
      return;
    }
    if (
      this.trialbalance.get('start').value != null &&
      this.trialbalance.get('end').value != null
    ) {
      this.trialBalanceStartDate = formatDate(
        this.trialbalance.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      this.trialBalanceEndDate = formatDate(
        this.trialbalance.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );
    }

    const startDateControl = this.trialbalance.get('start').value;
    const endDateControl = this.trialbalance.get('end').value;

    if (startDateControl && endDateControl) {
      const startDate = new Date(formatDate(startDateControl, 'yyyy-MM-dd', 'en-IN'));
      const endDate = new Date(formatDate(endDateControl, 'yyyy-MM-dd', 'en-IN'));

      const financialYearStart = new Date(this.financialYearMin);
      const financialYearEnd = new Date(this.financialYearMax);

      if (startDate >= financialYearStart && endDate <= financialYearEnd) {
        this.trialBalanceStartDate = formatDate(startDate, 'yyyy-MM-dd', 'en-IN');
        this.trialBalanceEndDate = formatDate(endDate, 'yyyy-MM-dd', 'en-IN');
      } else {
        alert("Selected dates are not in the current financial year!");
        this.trialbalance.reset();
        return;
      }
    }
  }

  profitLossStartDate = '';
  profitLossEndDate = '';
  profitLossDateRange() {
    debugger
    if (!this.hasExpenseMasterUpdatePermission) {
      alert("You don't have permission to View Report!!!");
      this.profitloss.reset();
      return;
    }
    if (
      this.profitloss.get('start').value != null &&
      this.profitloss.get('end').value != null
    ) {
      this.profitLossStartDate = formatDate(
        this.profitloss.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      this.profitLossEndDate = formatDate(
        this.profitloss.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );
    }

    const startDateControl = this.profitloss.get('start').value;
    const endDateControl = this.profitloss.get('end').value;

    if (startDateControl && endDateControl) {
      const startDate = new Date(formatDate(startDateControl, 'yyyy-MM-dd', 'en-IN'));
      const endDate = new Date(formatDate(endDateControl, 'yyyy-MM-dd', 'en-IN'));

      const financialYearStart = new Date(this.financialYearMin);
      const financialYearEnd = new Date(this.financialYearMax);

      if (startDate >= financialYearStart && endDate <= financialYearEnd) {
        this.trialBalanceStartDate = formatDate(startDate, 'yyyy-MM-dd', 'en-IN');
        this.trialBalanceEndDate = formatDate(endDate, 'yyyy-MM-dd', 'en-IN');
      } else {
        alert("Selected dates are not in the current financial year!");
        this.profitloss.reset();
        return;
      }
    }
  }

  depositSlipStartDate = '';
  depositSlipEndDate = '';
  depositSlipDateRange() {
    debugger
    if (!this.hasExpenseMasterUpdatePermission) {
      alert("You don't have permission to View Report!!!");
      this.depositslip.reset();
      return;
    }
    if (
      this.depositslip.get('start').value != null &&
      this.depositslip.get('end').value != null
    ) {
      this.depositSlipStartDate = formatDate(
        this.depositslip.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      this.depositSlipEndDate = formatDate(
        this.depositslip.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );
    }

    const startDateControl = this.depositslip.get('start').value;
    const endDateControl = this.depositslip.get('end').value;

    if (startDateControl && endDateControl) {
      const startDate = new Date(formatDate(startDateControl, 'yyyy-MM-dd', 'en-IN'));
      const endDate = new Date(formatDate(endDateControl, 'yyyy-MM-dd', 'en-IN'));

      const financialYearStart = new Date(this.financialYearMin);
      const financialYearEnd = new Date(this.financialYearMax);

      if (startDate >= financialYearStart && endDate <= financialYearEnd) {
        this.trialBalanceStartDate = formatDate(startDate, 'yyyy-MM-dd', 'en-IN');
        this.trialBalanceEndDate = formatDate(endDate, 'yyyy-MM-dd', 'en-IN');
      } else {
        alert("Selected dates are not in the current financial year!");
        this.depositslip.reset();
        return;
      }
    }
  }

  balanceSheetStartDate = '';
  balanceSheetEndDate = '';
  balanceSheetDateRange() {
    if (!this.hasExpenseMasterUpdatePermission) {
      alert("You don't have permission to View Report!!!");
      this.balancesheet.reset();
      return;
    }
    if (
      this.balancesheet.get('start').value != null &&
      this.balancesheet.get('end').value != null
    ) {
      this.balanceSheetStartDate = formatDate(
        this.balancesheet.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      this.balanceSheetEndDate = formatDate(
        this.balancesheet.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );
    }

    const startDateControl = this.balancesheet.get('start').value;
    const endDateControl = this.balancesheet.get('end').value;

    if (startDateControl && endDateControl) {
      const startDate = new Date(formatDate(startDateControl, 'yyyy-MM-dd', 'en-IN'));
      const endDate = new Date(formatDate(endDateControl, 'yyyy-MM-dd', 'en-IN'));

      const financialYearStart = new Date(this.financialYearMin);
      const financialYearEnd = new Date(this.financialYearMax);

      if (startDate >= financialYearStart && endDate <= financialYearEnd) {
        this.trialBalanceStartDate = formatDate(startDate, 'yyyy-MM-dd', 'en-IN');
        this.trialBalanceEndDate = formatDate(endDate, 'yyyy-MM-dd', 'en-IN');
      } else {
        alert("Selected dates are not in the current financial year!");
        this.balancesheet.reset();
        return;
      }
    }
  }

  issueDetectStartDate = '';
  issueDetectEndDate = '';
  issueDetectDateRange() {
    if (
      this.issueDetectionForm.get('start').value != null &&
      this.issueDetectionForm.get('end').value != null
    ) {
      this.issueDetectStartDate = formatDate(
        this.issueDetectionForm.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      this.issueDetectEndDate = formatDate(
        this.issueDetectionForm.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );
    }

    const startDateControl = this.issueDetectionForm.get('start').value;
    const endDateControl = this.issueDetectionForm.get('end').value;

    if (startDateControl && endDateControl) {
      const startDate = new Date(formatDate(startDateControl, 'yyyy-MM-dd', 'en-IN'));
      const endDate = new Date(formatDate(endDateControl, 'yyyy-MM-dd', 'en-IN'));

      const financialYearStart = new Date(this.financialYearMin);
      const financialYearEnd = new Date(this.financialYearMax);

      if (startDate >= financialYearStart && endDate <= financialYearEnd) {
        this.issueDetectStartDate = formatDate(startDate, 'yyyy-MM-dd', 'en-IN');
        this.issueDetectEndDate = formatDate(endDate, 'yyyy-MM-dd', 'en-IN');
      } else {
        alert("Selected dates are not in the current financial year!");
        this.issueDetectionForm.reset();
        return;
      }
    }
  }

  bankRecoStartDate = '';
  bankRecoEndDate = '';
  bankRecoDateRange() {
    if (!this.hasBankRecoReportViewPermission) {
      alert("You don't have permission to View Bank Reco Report!!!");
      this.bankReco.reset();
      return;
    }
    if (
      this.bankReco.get('start').value != null &&
      this.bankReco.get('end').value != null
    ) {
      this.bankRecoStartDate = formatDate(
        this.bankReco.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      this.bankRecoEndDate = formatDate(
        this.bankReco.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );
    }
  }

  subscriptionStartDate = '';
  subscriptionEndDate = '';
  subscriptionDateRange() {
    if (!this.hasSubMonthlyRepoViewPermission) {
      alert("You don't have permission to View Report!!!");
      this.subscription.reset();
      return;
    }

    if (
      this.subscription.get('start').value != null &&
      this.subscription.get('end').value != null
    ) {
      this.subscriptionStartDate = formatDate(
        this.subscription.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      this.subscriptionEndDate = formatDate(
        this.subscription.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );
    }
  }

  packageStartDate = '';
  packageEndDate = '';
  packageDateRange() {

    if (
      this.package.get('start').value != null &&
      this.package.get('end').value != null
    ) {
      this.packageStartDate = formatDate(
        this.package.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      this.packageEndDate = formatDate(
        this.package.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );
    }
  }

  expenseledger2StartDate = '';
  expenseledger2EndDate = '';
  expenseledger2DateRange() {
    if (!this.hasExpenseReportViewPermission) {
      alert("You don't have permission to View Report!!!");
      this.expenseledger2.reset();
      return;
    }
    if (
      this.expenseledger2.get('start').value != null &&
      this.expenseledger2.get('end').value != null
    ) {
      this.expenseledger2StartDate = formatDate(
        this.expenseledger2.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      // console.log(this.creditdebitStartDate);

      this.expenseledger2EndDate = formatDate(
        this.expenseledger2.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );

      const startDateControl = this.expenseledger2.get('start').value;
      const endDateControl = this.expenseledger2.get('end').value;

      if (startDateControl && endDateControl) {
        const startDate = new Date(formatDate(startDateControl, 'yyyy-MM-dd', 'en-IN'));
        const endDate = new Date(formatDate(endDateControl, 'yyyy-MM-dd', 'en-IN'));

        const financialYearStart = new Date(this.financialYearMin);
        const financialYearEnd = new Date(this.financialYearMax);

        if (startDate >= financialYearStart && endDate <= financialYearEnd) {
          this.trialBalanceStartDate = formatDate(startDate, 'yyyy-MM-dd', 'en-IN');
          this.trialBalanceEndDate = formatDate(endDate, 'yyyy-MM-dd', 'en-IN');
        } else {
          alert("Selected dates are not in the current financial year!");
          this.expenseledger2.reset();
          return;
        }
      }
      // console.log(this.creditdebitEndDate);
    }
  }

  expenseledger3StartDate = '';
  expenseledger3EndDate = '';
  expenseledger3DateRange() {
    if (!this.hasExpenseReportViewPermission) {
      alert("You don't have permission to View Report!!!");
      this.expenseledger3.reset();
      return;
    }
    if (
      this.expenseledger3.get('start').value != null &&
      this.expenseledger3.get('end').value != null
    ) {
      this.expenseledger3StartDate = formatDate(
        this.expenseledger3.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );

      this.expenseledger3EndDate = formatDate(
        this.expenseledger3.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );

      const startDateControl = this.expenseledger3.get('start').value;
      const endDateControl = this.expenseledger3.get('end').value;

      if (startDateControl && endDateControl) {
        const startDate = new Date(formatDate(startDateControl, 'yyyy-MM-dd', 'en-IN'));
        const endDate = new Date(formatDate(endDateControl, 'yyyy-MM-dd', 'en-IN'));

        const financialYearStart = new Date(this.financialYearMin);
        const financialYearEnd = new Date(this.financialYearMax);

        if (startDate >= financialYearStart && endDate <= financialYearEnd) {
          this.trialBalanceStartDate = formatDate(startDate, 'yyyy-MM-dd', 'en-IN');
          this.trialBalanceEndDate = formatDate(endDate, 'yyyy-MM-dd', 'en-IN');
        } else {
          alert("Selected dates are not in the current financial year!");
          this.expenseledger3.reset();
          return;
        }
      }
      // console.log(this.creditdebitEndDate);
    }
  }

  expenReportStartDate = '';
  expenReportEndDate = '';
  expenseReportDateRange() {
    if (
      this.expensereport.get('start').value != null &&
      this.expensereport.get('end').value != null
    ) {
      this.expenReportStartDate = formatDate(
        this.expensereport.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      // console.log(this.creditdebitStartDate);

      this.expenReportEndDate = formatDate(
        this.expensereport.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      console.log(this.expenReportStartDate);
      console.log(this.expenReportEndDate);

    }
  }

  expenReportStartDate11 = '';
  expenReportEndDate11 = '';
  expenseReportDateRange11() {
    if (
      this.journalvouchergetdate.get('start').value != null &&
      this.journalvouchergetdate.get('end').value != null
    ) {
      this.expenReportStartDate11 = formatDate(
        this.journalvouchergetdate.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      // console.log(this.creditdebitStartDate);

      this.expenReportEndDate11 = formatDate(
        this.journalvouchergetdate.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      console.log(this.expenReportStartDate11);
      console.log(this.expenReportEndDate11);



    }
  }

  selectedRCSBank = '';
  bankfullname = '';
  getBankCashOnReconsilation(event) {

    this.selectedRCSBank = event.shortName;
    this.bankfullname = event.subExpName
  }

  selectedRCSBank1 = '';
  bankfullname1 = '';
  getBankCashOnReconsilation1(event) {
    this.selectedRCSBank1 = event.shortName;
    this.bankfullname1 = event.subExpName
  }

  selectedRCSBank2 = '';
  bankfullname2 = '';
  getBankCashOnReconsilation2(event) {
    this.selectedRCSBank2 = event.shortName;
    this.bankfullname2 = event.subExpName
  }

  cheque_no = '';
  getcheque_no(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.cheque_no = inputElement.value;

  }

  reconsilationReportData;
  reconsilationReportData1;
  getReconsilationData() {
    if (
      this.reconsilationStartDate !== '' &&
      this.reconsilationEndDate !== '' &&
      this.selectedRCSBank !== '' &&
      this.bankfullname
    ) {
      this.service
        .getReconsilationReportData(
          this.reconsilationStartDate,
          this.reconsilationEndDate,
          this.selectedRCSBank,
          this.cheque_no,
          this.bankfullname
        )
        .subscribe((res) => {
          this.reconsilationReportData = res || []; // Handle undefined case
        });

      this.service
        .getReconsilationReportData1(
          this.reconsilationStartDate,
          this.reconsilationEndDate,
          this.selectedRCSBank,
          this.cheque_no,
          this.bankfullname
        )
        .subscribe((res) => {
          this.reconsilationReportData1 = res || []; // Handle undefined case

          console.log(this.reconsilationReportData, "this first");
          console.log(this.reconsilationReportData1, "this second");

          // Merge both arrays
          let mergedArray = [...this.reconsilationReportData, ...this.reconsilationReportData1];

          // Remove duplicates based on 'voucher_no'
          let uniqueVouchers = new Map();
          this.mergedArray1 = mergedArray.filter(item => {
            if (!uniqueVouchers.has(item.voucher_no)) {
              uniqueVouchers.set(item.voucher_no, true);
              return true;
            }
            return false;
          });

          // Sort records:
          this.mergedArray1.sort((a, b) => {
            // const hasClearingDateA = a.cheq_clearing_date && a.cheq_clearing_date !== '0000-00-00';
            const hasClearingDateA = a.cheq_clearing_date != null && a.cheq_clearing_date !== '0000-00-00' && a.cheq_clearing_date.trim() !== '';
            const hasClearingDateB = b.cheq_clearing_date != null && b.cheq_clearing_date !== '0000-00-00' && b.cheq_clearing_date.trim() !== '';

            // const hasClearingDateB = b.cheq_clearing_date && b.cheq_clearing_date !== '0000-00-00';

            if (!hasClearingDateA && !hasClearingDateB) {
              // Both don't have clearing dates, sort by voucher_date (Ascending)
              return new Date(a.voucher_date).getTime() - new Date(b.voucher_date).getTime();
            } else if (!hasClearingDateA && hasClearingDateB) {
              // Records without clearing dates come first
              return -1;
            } else if (hasClearingDateA && !hasClearingDateB) {
              // Records with clearing dates come last
              return 1;
            } else {
              // Both have clearing dates, sort by cheq_clearing_date (Ascending)
              return new Date(a.cheq_clearing_date).getTime() - new Date(b.cheq_clearing_date).getTime();
            }
          });
        });
    } else if (
      this.reconsilationStartDate !== '' &&
      this.reconsilationEndDate !== '' &&
      this.selectedRCSBank === ''
    ) {
      alert('Please select bank');
    } else if (
      this.reconsilationStartDate === '' &&
      this.reconsilationEndDate === '' &&
      this.selectedRCSBank !== ''
    ) {
      alert('Please select date');
    }
  }

  clearingDate = '';
  showclearingUpdatebtn = false;
  clearUpdateId = 0;
  // updateReconsilationReport(event, item) {
  //   if (event.target.value >= item['voucher_date']) {
  //     if (confirm('Are sure you want to update clearing date')) {
  //       this.service
  //         .updateClearingDate(
  //           item['id'],
  //           formatDate(event.target.value, 'yyyy-MM-dd', 'en-IN', 'GMT+0530')
  //         )
  //         .subscribe((res) => {
  //           alert('Clearing date updated successfully..');
  //           this.showclearingUpdatebtn = false;
  //           this.clearUpdateId = 0;
  //           this.getReconsilationData();
  //         });
  //       this.service
  //         .updateClearingDate1(
  //           item['id'],
  //           formatDate(event.target.value, 'yyyy-MM-dd', 'en-IN', 'GMT+0530')
  //         )
  //         .subscribe((res) => {
  //           alert('Clearing date updated successfully..');
  //           this.showclearingUpdatebtn = false;
  //           this.clearUpdateId = 0;
  //           this.getReconsilationData();
  //         });
  //     }
  //   } else {
  //     alert('Please select the date after voucher date');
  //   }
  // }

  // updateReconsilationReport(event: any, item: any) {
  //   const selectedDate = new Date(event.value);
  //   const voucherDate = new Date(item['voucher_date']);

  //   const selectedDateNew = formatDate(selectedDate, 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
  //   const formatDateNew = formatDate(voucherDate, 'yyyy-MM-dd', 'en-IN', 'GMT+0530');


  //   console.log(selectedDateNew);
  //   console.log(formatDateNew);

  //   if (selectedDateNew >= formatDateNew) {
  //     if (confirm('Are sure you want to update clearing date')) {
  //       this.service
  //         .updateClearingDate(
  //           item['id'],
  //           formatDate(selectedDate, 'yyyy-MM-dd', 'en-IN', 'GMT+0530')
  //         )
  //         .subscribe((res) => {
  //           alert('Clearing date updated successfully..');
  //           this.showclearingUpdatebtn = false;
  //           this.clearUpdateId = 0;
  //           this.getReconsilationData();
  //         });

  //       this.service
  //         .updateClearingDate1(
  //           item['id'],
  //           formatDate(selectedDate, 'yyyy-MM-dd', 'en-IN', 'GMT+0530')
  //         )
  //         .subscribe((res) => {
  //           alert('Clearing date updated successfully..');
  //           this.showclearingUpdatebtn = false;
  //           this.clearUpdateId = 0;
  //           this.getReconsilationData();
  //         });
  //     }
  //   } else {
  //     alert('Please select the date after voucher date');
  //   }
  // }

  updateReconsilationReport(event: any, item: any) {
    debugger
    if (!this.hasBankRecoAddPermission) {
      alert("You don't have permission to do Bank Reco!!!");
      return;
    }
    const selectedDate = new Date(event.target.value);
    const voucherDate = new Date(item['voucher_date']);

    const selectedDateNew = formatDate(selectedDate, 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
    const formatDateNew = formatDate(voucherDate, 'yyyy-MM-dd', 'en-IN', 'GMT+0530');

    console.log(selectedDateNew);
    console.log(formatDateNew);

    if (selectedDateNew >= formatDateNew) {
      // Check if voucher_no starts with 'CR' (Credit) or 'DR' (Debit)
      if (item['voucher_no'].startsWith('CR')) {
        this.service
          .updateClearingDate(item['id'], selectedDateNew)
          .subscribe((res) => {
            alert('Clearing date updated successfully.');
            this.showclearingUpdatebtn = false;
            this.clearUpdateId = 0;
            this.getReconsilationData();
          });
      } else if (item['voucher_no'].startsWith('DR')) {
        this.service
          .updateClearingDate1(item['id'], selectedDateNew)
          .subscribe((res) => {
            alert('Clearing date updated successfully.');
            this.showclearingUpdatebtn = false;
            this.clearUpdateId = 0;
            this.getReconsilationData();
          });
      } else {
        alert('Invalid voucher number format!'); // If it doesn't start with CR or DR
      }

    } else {
      alert('Please select a correct date.');
    }
  }

  updateClearingDate(item) {
    if (!this.hasBankRecoUpdatePermission) {
      alert("You don't have permission to Edit/Update Bank Reco!!!");
      return;
    }
    debugger
    this.showclearingUpdatebtn = true;
    this.clearUpdateId = item['id'];
    this.clearingDate = item['cheq_clearing_date'];
  }

  cancelReco(item) {

    if (!this.hasBankRecoDeletePermission) {
      alert("You don't have permission to Delete/Cancel Bank Reco!!!");
      return;
    }

    if (confirm('Are you sure you want to cancel the reco?')) {
      // Check if voucher_no starts with 'CR' (Credit) or 'DR' (Debit)
      debugger
      if (item['voucher_no'].startsWith('CR')) {
        this.service
          .cancelClearingDate(item['id'], "CR")
          .subscribe((res) => {
            alert('Reco cancelled successfully.');
            this.showclearingUpdatebtn = false;
            this.clearUpdateId = 0;
            this.getReconsilationData();
          });
      } else if (item['voucher_no'].startsWith('DR')) {
        this.service
          .cancelClearingDate(item['id'], "DR")
          .subscribe((res) => {
            alert('Reco cancelled successfully.');
            this.showclearingUpdatebtn = false;
            this.clearUpdateId = 0;
            this.getReconsilationData();
          });
      } else {
        alert('Invalid voucher number format!'); // If it doesn't start with CR or DR
      }
    }
  }

  check() {
    if (this.cashtype) {
      return true;
    }
    return false;
  }

  checkvalue_yes_no(exp) {
    if (!this.hasExpenseMasterAddPermission) {
      alert("You don't have permission to Add Sub Expense!!!");
      this.SubExpenseLedgerForm.get('expname').setValue(null);
      return;
    }

    this.opening_yes_no = exp.opening_yes_no
    console.log(exp)
  }

  checkPermission() {
    if (!this.hasExpenseMasterAddPermission) {
      alert("You don't have permission to Add Main Expense!!!");
      this.ExpenseLedgerForm.get('expensename').setValue(null);
      return;
    }
  }

  save_ExpenseLedger() {
    // console.log(this.ExpenseLedgerForm.get('openingbal').value);
    let data = {
      expensename: this.ExpenseLedgerForm.get('expensename').value,
      exptype: this.ExpenseLedgerForm.get('exptype').value,
      opening_bal: this.ExpenseLedgerForm.get('openingbal').value,
      opening_yes_no: this.ExpenseLedgerForm.get('opening_yes_no').value,
      type: this.ExpenseLedgerForm.get('crdr').value,
    };
    console.log(data);
    this.service.addMainExpenseLedger(data).subscribe((res) => {
      console.log('added main exp', res);
      alert('Expense ledger added successfully...');
      this.ExpenseLedgerForm.reset();
      this.ngOnInit();
    });
  }

  expId = 0;
  mainExpSelected = false;
  selectMainExp(exp) {
    if (!this.hasExpenseMasterUpdatePermission) {
      alert("You don't have permission to Edit Main Expense!!!");
      return;
    }
    this.expId = exp['id'];
    this.mainExpSelected = true;
    this.ExpenseLedgerForm.get('expensename').setValue(exp['exp_name']);
    this.ExpenseLedgerForm.get('exptype').setValue(exp['exp_type']);
    this.ExpenseLedgerForm.get('openingbal').setValue(exp['opening_bal']);
    this.ExpenseLedgerForm.get('sortOrder').setValue(exp['sort_order']);
    this.ExpenseLedgerForm.get('opening_yes_no').setValue(exp['opening_yes_no']);
    this.ExpenseLedgerForm.get('crdr').setValue(exp['cr_dr']);
  }

  update_ExpenseLedger() {
    this.service
      .updateMainExpenseLedger(
        this.expId,
        this.ExpenseLedgerForm.get('expensename').value,
        this.ExpenseLedgerForm.get('exptype').value,
        this.ExpenseLedgerForm.get('openingbal').value,
        this.ExpenseLedgerForm.get('sortOrder').value,
        this.ExpenseLedgerForm.get('opening_yes_no').value,
        this.ExpenseLedgerForm.get('crdr').value
      )
      .subscribe((res) => {
        // console.log('added main exp');
        alert('Expense ledger updated successfully...');
        this.ExpenseLedgerForm.reset();
        this.mainExpSelected = false;
        this.ngOnInit();
      });
  }

  getMainExpenseData() {
    this.service.getMainExpenseLedger().subscribe((res) => {
      // console.log(res);
      this.mainExpData = res;
    });
  }

  getMainExpenseDataForPackageManager() {
    this.service.getMainExpenseLedgerForPackageManager().subscribe((res) => {
      // console.log(res);
      this.mainExpDataForPackageManager = res;
    });
  }

  save_SubExpenseLedger() {
    let data = {
      mainexpid: this.SubExpenseLedgerForm.get('expname').value,
      subexpname: this.SubExpenseLedgerForm.get('subexpname').value,
      // bank_name: this.SubExpenseLedgerForm.get('bank_name').value,
      subShortName: this.SubExpenseLedgerForm.get('bank_short_name').value,
      subOpeningBal: this.SubExpenseLedgerForm.get('bank_o_bal').value,
      subStatus: this.SubExpenseLedgerForm.get('crdtdebt').value,
    };

    console.log(data, "bank exp");

    this.service.addSubExpenseLedger(data).subscribe((res) => {
      alert('SubExpense ledger added successfully...');
      this.SubExpenseLedgerForm.reset('');
      this.ngOnInit();
    });
  }

  subexpId = 0;
  subExpSelected = false;
  selectSubExp(exp) {
    if (!this.hasExpenseMasterUpdatePermission) {
      alert("You don't have permission to Edit Sub Expense!!!");
      return;
    }
    this.subexpId = exp['id'];
    this.subExpSelected = true;
    this.SubExpenseLedgerForm.get('expname').setValue(exp['main_exp_id']);
    this.SubExpenseLedgerForm.get('subexpname').setValue(exp['sub_exp_name']);
    this.SubExpenseLedgerForm.get('bank_o_bal').setValue(exp['opening_bal']);
    this.SubExpenseLedgerForm.get('bank_short_name').setValue(exp['short_name']);
    this.SubExpenseLedgerForm.get('crdtdebt').setValue(exp['status']);
  }

  update_SubExpenseLedger() {

    let data = {
      id: this.subexpId,
      mainexpid: this.SubExpenseLedgerForm.get('expname').value,
      subexpname: this.SubExpenseLedgerForm.get('subexpname').value,
      opening_bal: this.SubExpenseLedgerForm.get('bank_o_bal').value,
      short_name: this.SubExpenseLedgerForm.get('bank_short_name').value,
      status: this.SubExpenseLedgerForm.get('crdtdebt').value,
      // opba: this.SubExpenseLedgerForm.get('bank_o_bal').value,
    };

    this.service.updateSubExpenseLedger(data).subscribe((res) => {
      alert('SubExpense ledger updated successfully...');
      this.SubExpenseLedgerForm.reset('');
      this.subExpSelected = false;
      this.ngOnInit();
    });
  }

  getSubExpenseData() {
    this.service.getSubExpenseLedger().subscribe((res) => {
      // console.log(res);
      this.subExpData = res;
    });
  }

  subexpense = false;

  mainexpId = 0;
  mainexpName = '';
  mainexpId1 = 0;
  mainexpName1 = '';
  getMainExpName1(event) {
    for (let index = 0; index < Object.keys(this.mainExpData).length; index++) {
      if (this.mainExpData[index]['id'] === event.value) {
        this.mainexpId1 = this.mainExpData[index]['id'];
        this.mainexpName1 = this.mainExpData[index]['exp_name'];
      }
    }

    // console.log(exp, this.mainExpData);
    this.service.getSubExpenseLedgerWithId(event.value).subscribe((res) => {
      this.getSubExpData1 = res;      // console.log(this.getSubExpData);
      if (Object.keys(this.getSubExpData1).length > 0) {
        this.subexpense1 = true;
      } else {
        this.subexpense1 = false;
      }
    });
  }

  getMainExpNameForCreditors(event: any) {
    for (let index = 0; index < Object.keys(this.mainExpData1).length; index++) {
      if (this.mainExpData1[index]['id'] === event) {
        this.mainexpId1 = this.mainExpData1[index]['id'];
        this.mainexpName1 = this.mainExpData1[index]['exp_name'];
      }
    }

    this.service.getSubExpenseLedgerWithId(event).subscribe((res) => {
      this.getSubExpData1 = res;

      if (Array.isArray(this.getSubExpData1) && this.getSubExpData1.length > 0) {

        // Sort by Marathi alphabetical order
        this.getSubExpData1.sort((a, b) =>
          a.sub_exp_name.localeCompare(b.sub_exp_name, 'mr')
        );

        this.subexpense1 = true;
      } else {
        this.subexpense1 = false;
      }

    });
  }

  onExpenseChange(selectedValue: any, item: any) {
    setTimeout(() => {
      console.log('Updated Expense:', item.expense);  // Now it logs the updated value
      this.getMainExpName2(selectedValue, item);
    });
  }

  getSubExpData1: any
  getMainExpName2(event, item) {
    for (let index = 0; index < Object.keys(this.mainExpData).length; index++) {
      if (this.mainExpData[index]['id'] === event.value) {
        this.mainexpId = this.mainExpData[index]['id'];
        this.mainexpName = this.mainExpData[index]['exp_name'];
      }
    }
    // console.log(exp, this.mainExpData);
    this.service.getSubExpenseLedgerWithId(event.value).subscribe((res) => {
      debugger
      item.getSubExpData1 = res;
      item.subExpenses = res;
      // console.log(this.getSubExpData);
      if (Object.keys(this.getSubExpData1).length > 0) {
        this.subexpense = true;
      } else {
        this.subexpense = false;
      }
    });
  }
  getMainExpName(event) {
    debugger
    for (let index = 0; index < Object.keys(this.mainExpData).length; index++) {
      if (this.mainExpData[index]['id'] === event.value) {
        this.mainexpId = this.mainExpData[index]['id'];
        this.mainexpName = this.mainExpData[index]['exp_name'];
      }
    }
    // console.log(exp, this.mainExpData);
    this.service.getSubExpenseLedgerWithId(event.value).subscribe((res) => {
      this.getSubExpData = res;
      // console.log(this.getSubExpData);
      if (Object.keys(this.getSubExpData).length > 0) {
        this.subexpense = true;
      } else {
        this.subexpense = false;
      }
    });
  }

  // getMainExpName101(event) {
  //   debugger
  //   for (let index = 0; index < Object.keys(this.mainExpData101).length; index++) {
  //     if (this.mainExpData101[index]['id'] === event.value.id) {
  //       this.mainexpId = this.mainExpData101[index]['id'];
  //       this.mainexpName = this.mainExpData101[index]['exp_name'];
  //     }
  //   }
  //   // console.log(exp, this.mainExpData);
  //   this.service.getSubExpenseLedgerWithId(event.value.id).subscribe((res) => {
  //     this.getSubExpData101 = res;
  //     // console.log(this.getSubExpData);
  //     if (Object.keys(this.getSubExpData101).length > 0) {
  //       this.subexpense = true;
  //     } else {
  //       this.subexpense = false;
  //     }
  //   });
  // }

  getMainExpName101(event: any) {
    debugger;

    // find selected main-expense (keeps your existing loop logic)
    for (let index = 0; index < Object.keys(this.mainExpData101).length; index++) {
      if (this.mainExpData101[index]['id'] === event.value.id) {
        this.mainexpId = this.mainExpData101[index]['id'];
        this.mainexpName = this.mainExpData101[index]['exp_name'];
        break;
      }
    }

    // fetch sub-expenses for selected main
    this.service.getSubExpenseLedgerWithId(event.value.id).subscribe((res: any[]) => {
      this.getSubExpData101 = res || [];

      const subCtrl = this.expenseledger1.get('subexpnameother');

      if (this.getSubExpData101 && this.getSubExpData101.length > 0) {
        // there are sub-expenses: show/select control and make sure it's enabled
        this.subexpense = true;

        // enable the control (in case it was disabled earlier)
        if (subCtrl?.disabled) {
          subCtrl.enable({ emitEvent: false });
        }

        // optionally reset so user chooses fresh value (keeps validators)
        subCtrl?.reset();

        // If you want to require sub-expense when present:
        // subCtrl?.setValidators([Validators.required]);
        // subCtrl?.updateValueAndValidity();
      } else {
        // no sub-expenses: hide control and clear previous value/state
        this.subexpense = false;

        // clear value and state so old ids/names don't persist
        subCtrl?.reset();                  // clears value and marks pristine/touched = false
        subCtrl?.setErrors(null);         // clear any leftover errors
        subCtrl?.clearValidators();       // optional: remove validators if you don't want them
        subCtrl?.updateValueAndValidity();

        // disable so it won't be submitted if you're reading rawValue or form.value
        if (subCtrl?.enabled) {
          subCtrl.disable({ emitEvent: false });
        }
      }
    });
  }

  getMainExpName111(id: any) {
    for (let index = 0; index < Object.keys(this.mainExpData).length; index++) {
      if (this.mainExpData[index]['id'] === id) {
        this.mainexpId = this.mainExpData[index]['id'];
        this.mainexpName = this.mainExpData[index]['exp_name'];
      }
    }
    // console.log(exp, this.mainExpData);
    this.service.getSubExpenseLedgerWithId(id).subscribe((res) => {
      this.getSubExpData = res;
      // console.log(this.getSubExpData);
      if (Object.keys(this.getSubExpData).length > 0) {
        this.subexpense = true;
      } else {
        this.subexpense = false;
      }
    });
  }

  getMainExpName3(event) {
    for (let index = 0; index < Object.keys(this.mainExpData).length; index++) {
      if (this.mainExpData[index]['id'] === event.value) {
        this.mainexpId = this.mainExpData[index]['id'];
        this.mainexpName = this.mainExpData[index]['exp_name'];
      }
    }
    // console.log(exp, this.mainExpData);
    this.service.getSubExpenseLedgerWithId(event.value).subscribe((res) => {
      this.getSubExpData = res;
      // console.log(this.getSubExpData);
      if (Object.keys(this.getSubExpData).length > 0) {
        this.subexpense2 = true;
      } else {
        this.subexpense2 = false;
      }
    });
  }

  expIdForPackageManager: any
  getMainExpNameForPackageManager(event) {
    for (let index = 0; index < Object.keys(this.mainExpDataForPackageManager).length; index++) {
      if (this.mainExpDataForPackageManager[index]['id'] === event.value) {
        this.expIdForPackageManager = this.mainExpDataForPackageManager[index]['id'];
      }
    }
  }

  // expIdForPackageManager1: any
  // getMainExpNameForPackageManager1(event) {
  //   for (let index = 0; index < Object.keys(this.mainExpDataForPackageManager).length; index++) {
  //     if (this.mainExpDataForPackageManager[index]['id'] === event.value) {
  //       this.expIdForPackageManager1 = this.mainExpDataForPackageManager[index]['id'];
  //     }
  //   }
  // }

  // expIdForPackageManager2: any
  // getMainExpNameForPackageManager2(event) {
  //   for (let index = 0; index < Object.keys(this.mainExpDataForPackageManager).length; index++) {
  //     if (this.mainExpDataForPackageManager[index]['id'] === event.value) {
  //       this.expIdForPackageManager2 = this.mainExpDataForPackageManager[index]['id'];
  //     }
  //   }
  // }

  sub_expId = 0;
  sub_expName = '';

  sub_expId1 = 0;
  sub_expName1 = '';
  getSubExpName1(event) {

    if (!this.hasCreditorsAddPermission) {
      alert("You don't have permission to Add Creditors!!!");
      this.kharedi.get('subexpnameother').setValue(null);
      return;
    }


    for (
      let index = 0;
      index < Object.keys(this.getSubExpData1).length;
      index++
    ) {
      if (this.getSubExpData1[index]['sub_id'] === event.value) {
        this.sub_expId1 = this.getSubExpData1[index]['sub_id'];
        this.sub_expName1 = this.getSubExpData1[index]['sub_exp_name'];
      }
    }


  }

  sub_expId_3 = 0;
  sub_expName_3 = '';

  sub_expId_4 = 0;
  sub_expName_4 = '';
  getSubExpName3(event) {


    for (
      let index = 0;
      index < Object.keys(this.getSubExpData1).length;
      index++
    ) {
      if (this.getSubExpData1[index]['sub_id'] === event.value) {
        // console.log(this.getSubExpData[index]);
        this.sub_expId1 = this.getSubExpData1[index]['sub_id'];
        this.sub_expName1 = this.getSubExpData1[index]['sub_exp_name'];
      }
    }


  }

  commasepId: any
  getSubNameids(event) {
    this.commasepId = event.value.join(',');
  }

  getSubExpName2(event, item) {

    const subIdToCheck = 58; // Set default value to 58 if event.value is undefined

    for (
      let index = 0;
      index < Object.keys(item.getSubExpData1).length;
      index++
    ) {
      if (item.getSubExpData1[index]['sub_id'] === event.value) {
        // console.log(this.getSubExpData[index]);
        // this.sub_expId = this.getSubExpData[index]['sub_id'];
        let sub_expName = item.getSubExpData1[index]['sub_exp_name'];

        let name = sub_expName.split(' ');

        let name2 = name[1].split('%');
        console.log(name2[0])
        let gstPercentage = parseFloat(name2[0]);

        if (!isNaN(gstPercentage)) {
          //  let netamount:any= (this.items.length -1 )- 1;
          // Assuming you want to calculate GST for the exp_amt field in the item
          let expAmount = parseFloat(this.items[0].netAmount);
          let gstAmount = expAmount * (gstPercentage / 100);
          console.log(`GST Amount: ${gstAmount}`);
          item.netAmount = gstAmount.toFixed(2);
          item.totalAmount = gstAmount.toFixed(2);


        } else {
          console.log('Invalid GST percentage');
        }

      }
    }


    this.totalAmounts = 0
    this.items.forEach(element => {
      this.totalAmounts =
        Math.round((this.totalAmounts + Number(element.netAmount)) * 100) / 100;
    });
  }

  getSubExpName(event) {
    // console.log(this.getSubExpData, event.value);

    for (
      let index = 0;
      index < Object.keys(this.getSubExpData).length;
      index++
    ) {
      if (this.getSubExpData[index]['sub_id'] === event.value) {
        // console.log(this.getSubExpData[index]);
        this.sub_expId = this.getSubExpData[index]['sub_id'];
        this.sub_expName = this.getSubExpData[index]['sub_exp_name'];
      }
    }
  }

  getSubExpName111(id: any) {
    // console.log(this.getSubExpData, event.value);

    for (
      let index = 0;
      index < Object.keys(this.getSubExpData).length;
      index++
    ) {
      if (this.getSubExpData[index]['sub_id'] === id) {
        // console.log(this.getSubExpData[index]);
        this.sub_expId = this.getSubExpData[index]['sub_id'];
        this.sub_expName = this.getSubExpData[index]['sub_exp_name'];
      }
    }
  }

  selectedsubExpenses = [];
  selectedMainExpenses = [];

  selectedsubExpenses1 = [];
  selectedMainExpenses1 = [];

  addMainExpense1() {

    const subCtrl = this.creditvoucherForm.get('subexpnameotherd');
    const amtCtrl = this.creditvoucherForm.get('exp_amtother');

    // Case: sub expense is required and not selected
    if (this.subexpense1 && (!subCtrl?.value || subCtrl.value === '')) {
      alert('Please select sub expense');
      return;
    }

    if (!amtCtrl?.value || Number(amtCtrl.value) <= 0) {
      alert('Please enter expense amount');
      return;
    }

    if (this.subexpense1) {
      this.selectedsubExpenses1.push({
        mainexpname: this.mainexpName1,
        mainexpid: this.mainexpId1,
        subexpname: this.sub_expName1,
        subexpid: this.sub_expId1,
        expamt: this.creditvoucherForm.get('exp_amtother').value,
        isNew: true,
        isUpdated: false,
        isSubExp: 'Y'
      });

      if (Object.keys(this.selectedMainExpenses1).length === 0) {
        this.selectedMainExpenses1.push({
          mainexpname: this.mainexpName1,
          mainexpid: this.mainexpId1,
          expamt: this.creditvoucherForm.get('exp_amtother').value
        });
      } else {
        let flag = false;
        for (
          let index = 0;
          index < Object.keys(this.selectedMainExpenses1).length;
          index++
        ) {
          if (
            this.selectedMainExpenses1[index]['mainexpid'] === this.mainexpId1
          ) {
            this.selectedMainExpenses1[index]['expamt'] =
              parseFloat(this.selectedMainExpenses1[index]['expamt']) +
              parseFloat(this.creditvoucherForm.get('exp_amtother').value);
            flag = true;
            break;
          } else {
            console.log('else is running', flag);
          }
        }
        if (!flag) {
          this.selectedMainExpenses1.push({
            mainexpname: this.mainexpName1,
            mainexpid: this.mainexpId1,
            expamt: this.creditvoucherForm.get('exp_amtother').value,
          });
        }
      }
      this.sub_expName1 = '';
      this.sub_expId1 = 0;
      this.creditvoucherForm.get('subexpnameotherd').reset();
      this.subexpense1 = false;
    } else {
      this.selectedMainExpenses1.push({
        mainexpname: this.mainexpName1,
        mainexpid: this.mainexpId1,
        expamt: this.creditvoucherForm.get('exp_amtother').value,
        isSubExp: 'N'
      });
    }

    this.mainexpName1 = '';
    this.mainexpId1 = 0;
    this.creditvoucherForm.get('expnameotherd').reset();
    this.creditvoucherForm.get('exp_amtother').reset();
    this.totalAmount1();
    this.otherDepositExpensesUpdated = true;
  }

  expamt1 = 0;
  total_amt1 = 0;
  totalAmount1() {
    this.expamt1 = 0;
    this.selectedMainExpenses1.map((exp) => {
      this.expamt1 = this.expamt1 + parseFloat(exp['expamt']);
    });
    this.creditvoucherForm.get('totalexp').setValue(this.expamt1);
    if (this.total_amt1 != 0) {
      // console.log(this.total_amt);

      this.creditvoucherForm
        .get('ndeposit')
        .setValue(this.total_amt1 - this.expamt1);
    }
  }

  // addMainExpense() {
  //   if (this.subexpense) {
  //     this.selectedsubExpenses.push({
  //       mainexpname: this.mainexpName,
  //       mainexpid: this.mainexpId,
  //       subexpname: this.sub_expName,
  //       subexpid: this.sub_expId,
  //       expamt: this.creditvoucherForm.get('exp_amt').value
  //     });

  //     if (Object.keys(this.selectedMainExpenses).length === 0) {
  //       this.selectedMainExpenses.push({
  //         mainexpname: this.mainexpName,
  //         mainexpid: this.mainexpId,
  //         expamt: this.creditvoucherForm.get('exp_amt').value,
  //       });
  //     } else {
  //       let flag = false;
  //       for (
  //         let index = 0;
  //         index < Object.keys(this.selectedMainExpenses).length;
  //         index++
  //       ) {
  //         if (
  //           this.selectedMainExpenses[index]['mainexpid'] === this.mainexpId
  //         ) {
  //           this.selectedMainExpenses[index]['expamt'] =
  //             parseFloat(this.selectedMainExpenses[index]['expamt']) +
  //             parseFloat(this.creditvoucherForm.get('exp_amt').value);
  //           flag = true;
  //           break;
  //         } else {
  //           console.log('else is running', flag);
  //         }
  //       }
  //       if (!flag) {
  //         this.selectedMainExpenses.push({
  //           mainexpname: this.mainexpName,
  //           mainexpid: this.mainexpId,
  //           expamt: this.creditvoucherForm.get('exp_amt').value,
  //         });
  //       }
  //     }
  //     this.sub_expName = '';
  //     this.sub_expId = 0;
  //     this.creditvoucherForm.get('subexpname').reset();
  //     this.subexpense = false;
  //   } else {
  //     this.selectedMainExpenses.push({
  //       mainexpname: this.mainexpName,
  //       mainexpid: this.mainexpId,
  //       expamt: this.creditvoucherForm.get('exp_amt').value,
  //     });
  //   }

  //   this.mainexpName = '';
  //   this.mainexpId = 0;
  //   this.creditvoucherForm.get('expname').reset();
  //   this.creditvoucherForm.get('exp_amt').reset();
  //   this.totalAmount();
  // }

  addMainExpense() {

    const subCtrl = this.creditvoucherForm.get('subexpname');
    const amtCtrl = this.creditvoucherForm.get('exp_amt');

    //sub expense validation
    if (this.subexpense && (!subCtrl?.value || subCtrl.value === '')) {
      alert('Please select sub expense');
      return;
    }

    //expense amount validation
    if (!amtCtrl?.value || Number(amtCtrl.value) <= 0) {
      alert('Please enter expense amount');
      return;
    }

    const expAmt = parseFloat(this.creditvoucherForm.get('exp_amt').value);

    if (this.subexpense) {
      // Add to selectedSubExpenses list
      this.selectedsubExpenses.push({
        mainexpname: this.mainexpName,
        mainexpid: this.mainexpId,
        subexpname: this.sub_expName,
        subexpid: this.sub_expId,
        expamt: expAmt
      });

      // Check if main expense already exists
      let mainExpense = this.selectedMainExpenses.find(
        exp => exp.mainexpid === this.mainexpId
      );

      if (mainExpense) {
        mainExpense.expamt = parseFloat(mainExpense.expamt) + expAmt;
      } else {
        this.selectedMainExpenses.push({
          mainexpname: this.mainexpName,
          mainexpid: this.mainexpId,
          expamt: expAmt
        });
      }

      // Reset subexpense-related fields
      this.sub_expName = '';
      this.sub_expId = 0;
      this.creditvoucherForm.get('subexpname').reset();
      this.subexpense = false;
    } else {
      // Check if main expense already exists (to prevent duplicate)
      let mainExpense = this.selectedMainExpenses.find(
        exp => exp.mainexpid === this.mainexpId
      );

      if (mainExpense) {
        mainExpense.expamt = parseFloat(mainExpense.expamt) + expAmt;
      } else {
        this.selectedMainExpenses.push({
          mainexpname: this.mainexpName,
          mainexpid: this.mainexpId,
          expamt: expAmt
        });
      }
    }

    // Reset main expense fields
    this.mainexpName = '';
    this.mainexpId = 0;
    this.creditvoucherForm.get('expname').reset();
    this.creditvoucherForm.get('exp_amt').reset();

    this.totalAmount();
    this.expenditureExpensesUpdated = true;
  }

  removeMainExp(mainId) {
    if (confirm('Do you really want to remove?')) {
      // console.log(mainId);
      this.selectedMainExpenses = this.selectedMainExpenses.filter(
        (a) => a['mainexpid'] !== mainId
      );
      this.selectedsubExpenses = this.selectedsubExpenses.filter(
        (a) => a['mainexpid'] !== mainId
      );

      this.totalAmount();
    }
  }

  removeMainExp1(mainId) {
    if (confirm('Do you really want to remove?')) {
      // console.log(mainId);
      this.selectedMainExpenses1 = this.selectedMainExpenses1.filter(
        (a) => a['mainexpid'] !== mainId
      );
      this.selectedsubExpenses1 = this.selectedsubExpenses1.filter(
        (a) => a['mainexpid'] !== mainId
      );

      this.totalAmount();
    }
  }

  removeSubExp(subId) {
    if (confirm('Do you really want to remove?')) {
      // console.log(subId);
      let data = this.selectedsubExpenses.find((a) => a['subexpid'] === subId);
      // console.log(data);
      this.selectedMainExpenses.map((exp) => {
        if (exp['mainexpid'] === data['mainexpid']) {
          exp['expamt'] =
            parseFloat(exp['expamt']) - parseFloat(data['expamt']);
        }
      });
      // console.log(this.selectedMainExpenses);

      this.selectedsubExpenses = this.selectedsubExpenses.filter(
        (a) => a['subexpid'] !== subId
      );

      this.totalAmount();
    }
  }

  removeSubExp1(subId) {
    if (confirm('Do you really want to remove?')) {
      // console.log(subId);
      let data = this.selectedsubExpenses1.find((a) => a['subexpid'] === subId);
      // console.log(data);
      this.selectedMainExpenses1.map((exp) => {
        if (exp['mainexpid'] === data['mainexpid']) {
          exp['expamt'] =
            parseFloat(exp['expamt']) - parseFloat(data['expamt']);
        }
      });
      // console.log(this.selectedMainExpenses);

      this.selectedsubExpenses1 = this.selectedsubExpenses1.filter(
        (a) => a['subexpid'] !== subId
      );

      this.totalAmount();
    }
  }

  totalAmount() {
    this.expamt = 0;
    this.selectedMainExpenses.map((exp) => {
      this.expamt = this.expamt + parseFloat(exp['expamt']);
    });
    this.creditvoucherForm.get('totalexp').setValue(this.expamt);
    if (this.total_amt != 0) {
      // console.log(this.total_amt);

      this.creditvoucherForm
        .get('ndeposit')
        .setValue(parseFloat((this.total_amt - this.expamt).toFixed(2)));

    }
  }

  debitmainexpId = 0;
  debitmainexpName = '';
  getDebitMainExpName(event) {

    for (let index = 0; index < Object.keys(this.mainExpData).length; index++) {
      if (this.mainExpData[index]['id'] === event.value) {
        this.debitmainexpId = this.mainExpData[index]['id'];
        this.debitmainexpName = this.mainExpData[index]['exp_name'];
      }
    }
    // console.log(event.value, this.mainExpData);
    this.service.getSubExpenseLedgerWithId(event.value).subscribe((res) => {
      this.getDebitSubExpData = res;
      this.filteredSubExpData = res;

      // console.log(this.getSubExpData);
      if (Object.keys(this.getDebitSubExpData).length > 0) {
        this.debitsubexpense = true;
      } else {
        this.debitsubexpense = false;
      }
    });
  }

  debitsub_expId = 0;
  debitsub_expName = '';
  getDebitSubExpName(event) {
    // console.log(this.getDebitSubExpData, event.value);

    for (
      let index = 0;
      index < Object.keys(this.getDebitSubExpData).length;
      index++
    ) {
      if (this.getDebitSubExpData[index]['sub_id'] === event.value) {
        // console.log(this.getDebitSubExpData[index]);
        this.debitsub_expId = this.getDebitSubExpData[index]['sub_id'];
        this.debitsub_expName = this.getDebitSubExpData[index]['sub_exp_name'];
      }
    }
  }

  selecteddebitsubExpenses = [];
  selecteddebitMainExpenses = [];
  addDebitExpense() {

    const subCtrl = this.debitForm.get('subexpname');
    const amtCtrl = this.debitForm.get('expamt');

    if (this.debitsubexpense && (!subCtrl?.value || subCtrl.value === '')) {
      alert('Please select sub expense');
      return;
    }

    if (!amtCtrl?.value || Number(amtCtrl.value) <= 0) {
      alert('Please enter expense amount');
      return;
    }

    if (this.debitsubexpense) {
      this.selecteddebitsubExpenses.push({
        mainexpname: this.debitmainexpName,
        mainexpid: this.debitmainexpId,
        subexpname: this.debitsub_expName,
        subexpid: this.debitsub_expId,
        expamt: this.debitForm.get('expamt').value,
        status: 'SaveMode'
      });

      if (Object.keys(this.selecteddebitMainExpenses).length === 0) {
        this.selecteddebitMainExpenses.push({
          mainexpname: this.debitmainexpName,
          mainexpid: this.debitmainexpId,
          expamt: this.debitForm.get('expamt').value,
          status: 'SaveMode'
        });
      } else {
        let flag = false;
        for (
          let index = 0;
          index < Object.keys(this.selecteddebitMainExpenses).length;
          index++
        ) {
          if (
            this.selecteddebitMainExpenses[index]['mainexpid'] ===
            this.debitmainexpId
          ) {
            this.selecteddebitMainExpenses[index]['expamt'] =
              parseFloat(this.selecteddebitMainExpenses[index]['expamt']) +
              parseFloat(this.debitForm.get('expamt').value);
            flag = true;
            break;
          } else {
            console.log('else is running', flag);
          }
        }
        if (!flag) {
          this.selecteddebitMainExpenses.push({
            mainexpname: this.debitmainexpName,
            narration: this.debitForm.value.othername,
            mainexpid: this.debitmainexpId,
            expamt: this.debitForm.get('expamt').value,
            status: 'SaveMode'
          });
        }
      }
      this.debitsub_expName = '';
      this.debitsub_expId = 0;
      this.debitForm.get('subexpname').reset();
      this.debitsubexpense = false;
    } else {
      this.selecteddebitMainExpenses.push({
        mainexpname: this.debitmainexpName,
        narration: this.debitForm.value.othername,
        mainexpid: this.debitmainexpId,
        expamt: this.debitForm.get('expamt').value,
        status: 'SaveMode'
      });
    }

    this.debitmainexpName = '';
    this.debitmainexpId = 0;
    this.debitForm.get('expname').reset();
    this.debitForm.get('expamt').reset();
    this.debitTotalAmount();
  }

  updateDebitExpense() {
    // If sub-expense mode is active
    if (this.debitsubexpense) {
      debugger
      // Update sub-expense entry
      const subIndex = this.selecteddebitsubExpenses.findIndex(
        exp =>
          exp.mainexpid === this.debitmainexpId &&
          exp.subexpid === this.debitsub_expId
      );

      if (subIndex !== -1) {
        const existingExp = this.selecteddebitsubExpenses[subIndex];
        this.selecteddebitsubExpenses[subIndex] = {
          ...existingExp, // keep all existing properties including id and status
          mainexpname: this.debitmainexpName,
          mainexpid: this.debitmainexpId,
          subexpname: this.debitsub_expName,
          subexpid: this.debitsub_expId,
          expamt: this.debitForm.get('expamt').value
        };
      }

      // Update or recalculate main expense total
      const mainIndex = this.selecteddebitMainExpenses.findIndex(
        exp => exp.mainexpid === this.debitmainexpId
      );

      if (mainIndex !== -1) {
        // Recalculate total for this main expense
        const total = this.selecteddebitsubExpenses
          .filter(exp => exp.mainexpid === this.debitmainexpId)
          .reduce((sum, exp) => sum + parseFloat(exp.expamt), 0);

        this.selecteddebitMainExpenses[mainIndex].expamt = total;
      }
    } else {
      debugger
      // Only updating a main expense (no sub-expense)
      const mainIndex = this.selecteddebitMainExpenses.findIndex(
        exp => exp.mainexpid === this.debitmainexpId
      );

      if (mainIndex !== -1) {
        const existingExp = this.selecteddebitMainExpenses[mainIndex];

        this.selecteddebitMainExpenses[mainIndex] = {
          ...existingExp, // keep all existing properties including id and status
          mainexpid: this.debitmainexpId,
          mainexpname: this.debitmainexpName,
          expamt: this.debitForm.get('expamt').value,
        };
      }

    }

    // Clear form state after update
    this.debitmainexpName = '';
    this.debitmainexpId = 0;
    this.debitsub_expName = '';
    this.debitsub_expId = 0;

    this.debitForm.get('expname').reset();
    this.debitForm.get('subexpname').reset();
    this.debitForm.get('expamt').reset();
    this.debitsubexpense = false;

    this.debitTotalAmount(); // Recalculate the full total
  }

  debitTotalAmount() {
    debugger
    this.expdamt = 0;
    let amt = parseFloat(this.debitForm.get('totalexp').value || 0);

    this.selecteddebitMainExpenses.map((exp) => {
      this.expdamt += parseFloat(exp['expamt']) || 0;
    });
    this.debitForm.get('totalexp').setValue(this.expdamt);
  }

  removeDebitMainExp(item) {
    if (confirm('Do you really want to remove?')) {
      debugger
      item.visible = false;
      this.deleterow.push(item.mainexpid);
      this.transformedResult = {
        debitvoucher: this.deleterow.map(id => ({ id: id }))
      };
      // this.selecteddebitMainExpenses = this.selecteddebitMainExpenses.filter(
      //   (a) => a['mainexpid'] !== item.mainexpid
      // );

      // 1. Track deleted items (for sending to backend)
      this.deletedMainExpenses = this.deletedMainExpenses || [];

      const deletedItem = this.selecteddebitMainExpenses.find(
        (a) => +a['mainexpid'] === +item.mainexpid
      );

      if (deletedItem) {
        this.deletedMainExpenses.push({ ...deletedItem, status: 'DeleteMode' });
      }

      // 2. Remove from visible list
      this.selecteddebitMainExpenses = this.selecteddebitMainExpenses.filter(
        (a) => +a['mainexpid'] !== +item.mainexpid
      );


      this.selecteddebitsubExpenses = this.selecteddebitsubExpenses.filter(
        (a) => a['mainexpid'] !== item.mainexpid
      );

      this.debitTotalAmount();
    }
  }

  removeDebitSubExp(subId) {
    if (confirm('Do you really want to remove?')) {
      let data = this.selecteddebitsubExpenses.find(
        (a) => a['subexpid'] === subId
      );
      this.selecteddebitMainExpenses.map((exp) => {
        if (exp['mainexpid'] === data['mainexpid']) {
          exp['expamt'] =
            parseFloat(exp['expamt']) - parseFloat(data['expamt']);
        }
      });
      // console.log(this.selecteddebitMainExpenses);

      // this.selecteddebitsubExpenses = this.selecteddebitsubExpenses.filter(
      //   (a) => a['subexpid'] !== subId
      // );

      const removedItems = this.selecteddebitsubExpenses.filter(item => item.subexpid === subId)
        .map(item => ({ ...item, status: 'DeleteMode' }));

      // Optionally store removed items
      this.deletedSubExpenses = [...(this.deletedSubExpenses || []), ...removedItems];

      // Remove from original list
      this.selecteddebitsubExpenses = this.selecteddebitsubExpenses.filter(item => item.subexpid !== subId);


      this.debitTotalAmount();
    }
  }
  generateCreditorsdate(event) {
    let newpb = 1;
    let today = new Date(event.target.value);
    let voucherNo = `PB${('0' + (today.getMonth() + 1)).slice(-2)}${(
      '0' + today.getDate()
    ).slice(-2)}${newpb}`;
    this.kharedi.get('creditorsnum').setValue(voucherNo);
  }

  generateCreditorsDate(event: any): void {
    const voucherDateStr = this.kharedi.get('voucherdate')?.value;

    if (!voucherDateStr) {
      alert('Please select a voucher date.');
      return;
    }

    const selectedDate = new Date(voucherDateStr);

    // Optional: Add financial year range check
    const minDate = this.financialYearMin;
    const maxDate = this.financialYearMax;

    if (selectedDate < minDate || selectedDate > maxDate) {
      alert('Voucher date must be within the financial year.');
      this.kharedi.get('voucherdate')?.setValue(null);
      return;
    }

    if (selectedDate instanceof Date) {
      const yyyy = selectedDate.getFullYear();
      const mm = ('0' + (selectedDate.getMonth() + 1)).slice(-2);
      const dd = ('0' + selectedDate.getDate()).slice(-2);
      const formattedDate = `${yyyy}-${mm}-${dd}`; // Format: YYYY-MM-DD

      this.service.generateCreditorNo(formattedDate).subscribe({
        next: (response) => {
          if (response && response.creditorsNumber) {
            this.kharedi.patchValue({ creditorsnum: response.creditorsNumber });
          }
        },
        error: (err) => {
          console.error('Error generating creditor number:', err);
        }
      });
    }
  }

  addItem() {
    this.items.push({
      expense: '',
      subExpense: '',
      netAmount: 0,
      totalAmount: 0,
      status: 'ADDED'
    });
  }

  removeItem(index: number): void {
    const item = this.items[index];
    debugger
    // If the item has an ID, it's an existing record, so we need to mark it as DELETED
    if (item.id) {
      item.status = 'DELETED';
      this.deleteditems.push(item); // Track for backend deletion
    }

    // Always remove from the visible items list
    this.items.splice(index, 1);

    // Recalculate total after removal
    this.calReTotal();
  }

  addItem1() {


    this.items1.push({
      expense: '',
      subExpense: '',
      amt: 0,
      amt_status: '',
      entry_date: this.jdate,
      journal_voucher: this.jnumber,
      narration: this.journalvoucher.value.narration

    });
  }

  // removeItem1(index: number) {
  //   if (confirm("Are you sure you want to remove this row?")) {
  //     this.items1.splice(index, 1);
  //   }
  // }

  removeItem1(index: number) {
    if (!confirm("Are you sure you want to remove this row?")) {
      return;
    }

    // Grab the item to be deleted
    const itemToDelete = this.items1[index];
    // Tag its status as 'delete' (or whatever your backend expects)
    itemToDelete.status = 'delete';

    // Push it into the deletedItems array
    this.deletedItems.push(itemToDelete);

    // Now remove it from the visible list
    this.items1.splice(index, 1);
  }

  getnarration(event: any) {

    // this.narrationname = event.value;
    for (
      let index = 0;
      index < Object.keys(this.getSubExpData1).length;
      index++
    )
      if (this.getSubExpData1[index]['sub_id'] === event.value) {
        // console.log(this.getSubExpData[index]);
        // this.sub_expId = this.getSubExpData[index]['sub_id'];
        this.sub_expName = this.getSubExpData1[index]['sub_exp_name'];
        this.sub_expName = this.sub_expName + " यांसकडून खरेदी "
        this.kharedi.patchValue({
          narration: this.sub_expName
        })
      }

    console.log(this.sub_expName, "narration name")
  }

  //testing purpose created this function
  // test() {
  //   console.log(this.selectedMainExpenses);
  //   console.log(this.selectedsubExpenses);
  //   console.log('***************************');

  //   this.selectedMainExpenses.map((exp) => {
  //     if (exp['isUpdated'] !== 'N') {
  //       console.log(exp);
  //       let data = {
  //         id: exp.id,
  //         mainexpid: exp.exp_id,
  //         expamt: exp.expamt,
  //       };

  //       this.service.updateCreditMainExpense(data).subscribe((res) => {
  //         console.log(res);
  //         let subData = this.selectedsubExpenses.filter(
  //           (a) => a['exp_id'] === data['mainexpid']
  //         );
  //         console.log(subData);

  //         if (Object.keys(subData).length > 0) {
  //           subData.map((subexp) => {
  //             if (subexp['isUpdated'] !== 'N') {
  //               console.log(subexp);
  //               let subexpdata = {
  //                 id: subexp['id'],
  //                 subexpid: subexp['sub_exp_id'],
  //                 expamt: subexp['expamt'],
  //               };
  //               this.service
  //                 .updateCreditSubExpense(subexpdata)
  //                 .subscribe((data) => {
  //                   console.log(data);
  //                 });
  //             }
  //           });
  //         }
  //       });
  //     }
  //   });
  // }
  totalAmounts: any = 0.0

  calTotal(event: any, item: any) {

    debugger

    item.totalAmount = event.target.value
    this.totalAmounts = 0

    this.items.forEach(element => {
      const net = typeof element.netAmount === 'string' ? parseFloat(element.netAmount) : element.netAmount;
      this.totalAmounts += net;
    });

    console.log(this.items, item.totalAmount)
  }

  calReTotal() {

    this.totalAmounts = 0;

    this.items.forEach(element => {
      const net = typeof element.netAmount === 'string' ? parseFloat(element.netAmount) : element.netAmount;
      this.totalAmounts += net;
    });

  }

  getTotal(type: string): number {
    return this.items.reduce((sum, item) => sum + (item[type] || 0), 0);
  }

  save_creditors() {

    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i];

      // Check if this main expense has sub expenses
      if (item.subExpenses && item.subExpenses.length > 0) {
        if (!item.subExpense || item.subExpense === '') {
          alert(`Please select sub expense for row ${i + 1}`);
          return;
        }
      }
    }

    const formattedDate = formatDate(this.kharedi.value.voucherdate, 'yyyy-MM-dd', 'en-IN');

    //generate creditor no based on voucher date
    this.service.creditorsbookingnum(formattedDate).subscribe((data) => {
      this.creditornumber = data;

      let req: any = {
        creditornumber: this.kharedi.value.creditorsnum,
        main_exp: this.kharedi.value.expnameother,
        sub_exp: this.kharedi.value.subexpnameother,
        voucher_date: formattedDate,
        total_amt: this.kharedi.value.totalamount,
        bill_no: this.kharedi.value.billno,
        narration: this.kharedi.value.narration,
      }

      //add creditors data
      if (confirm('Are you sure you want to add this creditor?')) {
        this.service.savecreditorsdetail(req).subscribe((data) => {
          this.insertid = data;

          this.items.forEach(element => {
            element.linkid = this.insertid.id
          });

          this.service.savecreditorsdetail1(this.items).subscribe((data) => {
            this.insertid = data;
          }
          );

          alert('Creditor added successfully...');

          this.kharedi.reset();
          this.items = [];
          this.deleteditems = [];
          this.totalAmounts = 0;

        });
      }
    });

  }

  update_creditors() {
    const req: any = {
      main_exp: this.kharedi.value.expnameother,
      sub_exp: this.kharedi.value.subexpnameother,
      total_amt: this.kharedi.value.totalamount,
      bill_no: this.kharedi.value.billno,
      narration: this.kharedi.value.narration,
    };

    if (confirm('Are you sure you want to update this creditor?')) {
      this.service.updateCreditorsDetail(this.creditorId, req).subscribe({
        next: () => {
          debugger
          const allItemsToSend = [
            ...this.items,
            ...this.deleteditems
          ];

          this.service.updateCreditorsDetail1(this.creditorId, allItemsToSend).subscribe({
            next: () => {
              alert('Creditor updated successfully...');
              // Optional: Reset form and items after update
              this.kharedi.reset();
              this.items = [];
              this.deleteditems = [];
              this.totalAmounts = 0;
            },
            error: (err) => {
              console.error('Error updating creditor details (part 2):', err);
              alert('Error occurred while updating creditor items.');
            }
          });
        },
        error: (err) => {
          console.error('Error updating creditor details:', err);
          alert('Error occurred while updating creditor.');
        }
      });
    }
  }

  // delete_creditvoucher() {

  //   this.deletevoucher_no = this.creditvoucherForm.get('vnumber').value;

  //   if (confirm('Are you sure you want to delete this credit voucher? This action cannot be undone.')) {
  //     this.service.checkrepforcredit(this.deletevoucher_no).subscribe((data) => {
  //       this.checkedstatus = data.status
  //       if (this.checkedstatus == false) {
  //         this.toaster.success('success', 'Credit voucher is deleted');

  //         this.service.deletecrvoucher(this.crdt_voucher_id).subscribe((data) => {
  //         });

  //         const entrydateValue = this.creditvoucherForm.get('entrydate')?.value;

  //         this.creditvoucherForm.reset();

  //         // Restore entrydate after reset
  //         this.creditvoucherForm.get('entrydate')?.setValue(entrydateValue);

  //         // Enable specific fields
  //         this.creditvoucherForm.get('bcaccount')?.enable();
  //         this.creditvoucherForm.get('voucherdate')?.enable();
  //         this.creditvoucherForm.get('vnumber')?.enable();

  //         this.selectedMainExpenses = [];
  //         this.selectedsubExpenses = [];
  //         this.selectedMainExpenses1 = [];
  //         this.selectedsubExpenses1 = [];
  //         this.selectedPackages = [];
  //         this.showpkg = false;
  //         this.showCreditupdate = false;
  //       }
  //       else {
  //         this.toaster.error('error', 'Sorry, Credit voucher is already used. Cannot delete credit voucher');
  //       }
  //     });
  //   }
  // }

  delete_creditvoucher() {
    this.deletevoucher_no = this.creditvoucherForm.get('vnumber').value;

    Swal.fire({
      title: 'Are you sure?',
      html: `You are about to delete voucher: <b style="color:red;">${this.deletevoucher_no}</b><br><br>This action cannot be undone!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.service.checkrepforcredit(this.deletevoucher_no).subscribe((data) => {
          this.checkedstatus = data.status;

          if (this.checkedstatus == false) {
            this.service.deletecrvoucher(this.crdt_voucher_id).subscribe({
              next: () => {
                // Success dialog with red styling
                Swal.fire({
                  title: 'Deleted!',
                  html: `
                  <div style="text-align: center;">
                    <div style="color: #d33; font-size: 48px; margin-bottom: 20px;">
                      <i class="fas fa-trash-alt"></i>
                    </div>
                    <div style="color: #d33; font-weight: bold; font-size: 24px; margin-bottom: 10px;">
                      Credit Voucher Deleted!
                    </div>
                    <div style="margin-bottom: 20px;">
                      Voucher No: <b style="color: #d33;">${this.deletevoucher_no}</b>
                    </div>
                    <div style="background-color: #f8d7da; color: #721c24; padding: 10px; border-radius: 5px; border: 1px solid #f5c6cb;">
                      <i class="fas fa-exclamation-triangle"></i> This action cannot be undone
                    </div>
                  </div>
                `,
                  icon: 'success',
                  confirmButtonColor: '#d33',
                  confirmButtonText: 'OK'
                }).then(() => {
                  const entrydateValue = this.creditvoucherForm.get('entrydate')?.value;
                  this.creditvoucherForm.reset();

                  // Restore entrydate after reset
                  this.creditvoucherForm.get('entrydate')?.setValue(entrydateValue);

                  // Enable specific fields
                  this.creditvoucherForm.get('bcaccount')?.enable();
                  this.creditvoucherForm.get('voucherdate')?.enable();
                  this.creditvoucherForm.get('vnumber')?.enable();

                  this.selectedMainExpenses = [];
                  this.selectedsubExpenses = [];
                  this.selectedMainExpenses1 = [];
                  this.selectedsubExpenses1 = [];
                  this.selectedPackages = [];
                  this.showpkg = false;
                  this.showCreditupdate = false;
                  this.names = [];
                  this.names1 = [];
                  this.names2 = [];
                });
              },
              error: (err) => {
                console.error('Delete error:', err);
                Swal.fire({
                  title: 'Error!',
                  text: 'Failed to delete credit voucher.',
                  icon: 'error',
                  confirmButtonColor: '#d33'
                });
              }
            });
          } else {
            // Error dialog for already used voucher
            Swal.fire({
              title: 'Cannot Delete!',
              html: `
              <div style="text-align: center;">
                <div style="color: #d33; font-size: 48px; margin-bottom: 20px;">
                  <i class="fas fa-ban"></i>
                </div>
                <div style="color: #d33; font-weight: bold; font-size: 24px; margin-bottom: 10px;">
                  Operation Not Allowed
                </div>
                <div style="margin-bottom: 20px;">
                  Voucher No: <b style="color: #d33;">${this.deletevoucher_no}</b>
                </div>
                <div style="background-color: #f8d7da; color: #721c24; padding: 15px; border-radius: 5px; border: 1px solid #f5c6cb; font-size: 16px;">
                  <i class="fas fa-exclamation-circle"></i> 
                  <b>Credit voucher is already used.</b><br>
                  Cannot delete this credit voucher.
                </div>
              </div>
            `,
              icon: 'error',
              confirmButtonColor: '#d33',
              confirmButtonText: 'Understood'
            });
          }
        });
      }
    });
  }

  // delete_creditvoucher() {
  //   this.deletevoucher_no = this.creditvoucherForm.get('vnumber').value;

  //   Swal.fire({
  //     title: 'Delete Credit Voucher?',
  //     html: `Voucher No: <b style="color:red;">${this.deletevoucher_no}</b><br><br>
  //          <span style="color: #d33;">This action is permanent and cannot be undone!</span>`,
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#d33',
  //     cancelButtonColor: '#6c757d',
  //     confirmButtonText: 'Delete',
  //     cancelButtonText: 'Cancel',
  //     focusCancel: true
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       this.service.checkrepforcredit(this.deletevoucher_no).subscribe((data) => {
  //         this.checkedstatus = data.status;

  //         if (this.checkedstatus == false) {
  //           this.service.deletecrvoucher(this.crdt_voucher_id).subscribe({
  //             next: () => {
  //               Swal.fire({
  //                 icon: 'success',
  //                 title: '<span style="color: #d33;">DELETED</span>',
  //                 html: `
  //                 <div style="border-left: 4px solid #d33; padding-left: 15px; margin: 20px 0;">
  //                   <div>Credit voucher has been deleted successfully:</div>
  //                   <div style="font-size: 1.2em; margin-top: 10px;">
  //                     <b style="color: #d33;">${this.deletevoucher_no}</b>
  //                   </div>
  //                 </div>
  //               `,
  //                 confirmButtonColor: '#d33'
  //               }).then(() => {
  //                 this.resetFormAndSelections();
  //               });
  //             },
  //             error: () => {
  //               Swal.fire({
  //                 icon: 'error',
  //                 title: 'Deletion Failed',
  //                 text: 'An error occurred while deleting the credit voucher.',
  //                 confirmButtonColor: '#d33'
  //               });
  //             }
  //           });
  //         } else {
  //           Swal.fire({
  //             icon: 'error',
  //             title: '<span style="color: #d33;">Cannot Delete</span>',
  //             html: `
  //             <div>
  //               <div style="margin-bottom: 15px;">
  //                 Voucher <b style="color: #d33;">${this.deletevoucher_no}</b> is already in use.
  //               </div>
  //               <div style="background-color: #fff3cd; padding: 10px; border-radius: 5px; border: 1px solid #ffeaa7;">
  //                 <i class="fas fa-info-circle"></i> Used vouchers cannot be deleted to maintain data integrity.
  //               </div>
  //             </div>
  //           `,
  //             confirmButtonColor: '#d33'
  //           });
  //         }
  //       });
  //     }
  //   });
  // }

  // Helper method for resetting form and selections
  resetFormAndSelections() {
    const entrydateValue = this.creditvoucherForm.get('entrydate')?.value;
    this.creditvoucherForm.reset();
    this.creditvoucherForm.get('entrydate')?.setValue(entrydateValue);

    // Enable specific fields
    this.creditvoucherForm.get('bcaccount')?.enable();
    this.creditvoucherForm.get('voucherdate')?.enable();
    this.creditvoucherForm.get('vnumber')?.enable();

    this.selectedMainExpenses = [];
    this.selectedsubExpenses = [];
    this.selectedMainExpenses1 = [];
    this.selectedsubExpenses1 = [];
    this.selectedPackages = [];
    this.showpkg = false;
    this.showCreditupdate = false;
  }

  onTabClick(event: any) {

    localStorage.setItem("tab", event.index)

  }

  creditors_report() {
    this.dialog.open(CreditorsreportComponent, {
      data: {
        startDate: this.expenReportStartDate,
        endDate: this.expenReportEndDate,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }
  jdate: any
  generateJvocuhernum(event) {
    debugger
    if (!this.hasJournalVoucherAddPermission) {
      alert("You don't have permission to add Journal Voucher!!!");
      this.journalvoucher.get('voucherdate').setValue(null);
    }
    this.jdate = formatDate(event.target.value, 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
    console.log(this.jdate, "date format");

    // Get the selected date
    const selectedDate = new Date(this.jdate);

    const minDate = new Date(this.financialYearMin);
    const maxDate = new Date(this.financialYearMax);

    if (selectedDate < minDate || selectedDate > maxDate) {
      alert('Date must be within financial year.');
      this.journalvoucher.get('voucherdate')?.setValue(null);
      return;
    }

    const startDateStr = sessionStorage.getItem('startDate'); // e.g. "2025-04-01"
    const endDateStr = sessionStorage.getItem('endDate');     // e.g. "2026-03-31"

    // Get the current date
    const currentDate = new Date();

    // Determine financial year start and end
    let fyStart, fyEnd;
    if (currentDate.getMonth() + 1 >= 4) { // If current month is April or later
      fyStart = new Date(currentDate.getFullYear(), 3, 1); // April 1st of current year
      fyEnd = new Date(currentDate.getFullYear() + 1, 2, 31); // March 31st of next year
    } else {
      fyStart = new Date(currentDate.getFullYear() - 1, 3, 1); // April 1st of last year
      fyEnd = new Date(currentDate.getFullYear(), 2, 31); // March 31st of current year
    }

    // Check if the selected date is within the financial year
    // if (selectedDate >= fyStart && selectedDate <= fyEnd) {
    // Call the service to generate JV number
    this.service.getJournalVoucherNumber(this.jdate, startDateStr, endDateStr).subscribe((res) => {
      this.journalvouchernumber = res;
      this.jnumber = this.journalvouchernumber.new_journal_number;
      this.journalvoucher.get('jvouchernum').setValue(this.jnumber);
    });
    // } else {
    //   alert("Error: Selected date is outside the current financial year!");
    //   this.journalvoucher.get('jvouchernum').setValue(""); // Clear the field
    // }
  }

  calTotal1(event: any, item: any) {

    item.amt = event.target.value
    console.log(this.items, item.totalAmount)
  }

  selectstatus(event: any, item: any) {
    item.amt_status = event.value
      ;
  }

  save_jvocuher() {

    for (let i = 0; i < this.items1.length; i++) {
      const item = this.items1[i];

      // Check if this main expense has sub expenses
      if (item.subExpenses && item.subExpenses.length > 0) {
        if (!item.subExpense || item.subExpense === '') {
          alert(`Please select sub expense for row ${i + 1}`);
          return;
        }
      }
    }

    if (!this.items1 || this.items1.length === 0) {
      alert("Please add at least one valid entry before saving!");
      return;
    }

    let list: any = [];
    let totalDebit = 0;
    let totalCredit = 0;
    let isValid = true;
    let missingFieldsMsg: string[] = [];

    this.items1.forEach((element, index) => {

      let rowErrors: string[] = [];

      if (!element.journal_voucher) {
        rowErrors.push("Journal Voucher is required.");
      }
      if (!element.amt) {
        rowErrors.push("Amount is required.");
      }
      if (!element.expense) {
        rowErrors.push("Expense is required.");
      }
      if (!element.amt_status) {
        rowErrors.push("Amount status (Debit/Credit) is required.");
      }

      if (rowErrors.length > 0) {
        isValid = false;
        missingFieldsMsg.push(`Row ${index + 1}: ${rowErrors.join(" ")}`);
      }

      const data: any = {
        amt: element.amt,
        expense: element.expense,
        subExpense: element.subExpense,
        amt_status: element.amt_status,
        journal_voucher: element.journal_voucher,
        entry_date: element.entry_date,
        narration: element.narration
      }
      list.push(data);

      // If any validation error exists, show alert and stop execution
      if (!isValid) {
        alert(`Please correct the following errors before saving:\n\n${missingFieldsMsg.join("\n")}`);
        return;
      }

      // Calculate total debit and credit amounts
      if (element.amt_status === 'DR') {
        totalDebit += parseFloat(element.amt) || 0;
      } else if (element.amt_status === 'CR') {
        totalCredit += parseFloat(element.amt) || 0;
      }
    });

    if (!isValid) {
      alert(`Please correct the following errors before saving:\n\n${missingFieldsMsg}`);
      return;
    }

    // Check if Debit and Credit totals match
    if (totalDebit !== totalCredit) {
      alert("Total Debit and Credit amounts must be equal before saving!");
      return; // Stop execution if they are not equal
    }

    this.service.getsavejournal(list).subscribe((res) => {
      this.journaldata = res;
      alert('Journal Voucher Added Successfully...');
      this.journalvoucher.reset();
      this.items1 = [];
    });
    this.ngOnInit();
  }

  update_jvoucher() {
    debugger
    let totalDebit = 0;
    let totalCredit = 0;
    let list: any = [];

    // Check if any items exist
    if (!this.items1 || this.items1.length === 0) {
      alert("No entries found. Please add at least one record before updating!");
      return;
    }

    // First, calculate total debit and credit amounts
    this.items1.forEach(element => {
      totalDebit += element.amt_status === 'DR' ? (parseFloat(element.amount) || 0) : 0;
      totalCredit += element.amt_status === 'CR' ? (parseFloat(element.amount) || 0) : 0;

      // Prepare data for update
      list.push({
        id: element.id,
        amt: element.amount,
        expense: element.expense,
        subExpense: element.subExpense,
        amt_status: element.amt_status,
        status: element.status,
        journal_voucher: this.journalvoucher.get('jvouchernum')?.value,
        entry_date: this.journalvoucher.get('voucherdate')?.value,
        narration: this.journalvoucher.get('narration')?.value
      });
    });

    this.deletedItems.forEach(element => {
      list.push({
        id: element.id,                               // backend needs to know which row to delete
        expense: element.expense,
        subExpense: element.subExpense,
        amt: element.amount,
        amt_status: element.amt_status,
        status: 'delete',
        journal_voucher: this.journalvoucher.get('jvouchernum')?.value,
        entry_date: this.journalvoucher.get('voucherdate')?.value,
        narration: this.journalvoucher.get('narration')?.value
      });
    });

    // Validate if total Debit and Credit match
    if (totalDebit !== totalCredit) {
      alert("Total Debit and Credit amounts must be equal before updating!");
      return; // Stop execution if they are not equal
    }

    if (confirm('Are you sure you want to update Journal Vocuher?')) {

      // Call the update API with the valid data
      this.service.getsavejournal(list).subscribe(
        (res) => {
          this.journaldata = res;
          alert("Journal Voucher Updated Successfully...");

          // Clear all fields after updating
          this.items1 = [];
          totalDebit = 0;
          totalCredit = 0;
          this.showJVupdate = false;

          // Reset the form if using Reactive Forms
          if (this.journalvoucher) {
            this.journalvoucher.reset();
          }
        },
        (error) => {
          console.error("Error updating journal voucher:", error);
        }
      );
    }
  }

  selectJournal(exp) {
    // console.log(exp)
    this.dialog.open(UpdatejournalvoucherComponent, {
      data: {
        data: exp,
      },

      width: '600px',
      height: '400px',
      maxWidth: '100%',

    });
  }
  deletejvoucher() {
    debugger
    if (confirm('Are you sure you want to delete this Journal Vocuher?')) {
      this.service.getdeletejvoucher(this.updatevoucherno).subscribe((res) => {

        // Clear all fields after updating
        this.items1 = [];
        this.showJVupdate = false;

        // Reset the form if using Reactive Forms
        if (this.journalvoucher) {
          this.journalvoucher.reset();
        }

      });
      alert('Journal Voucher Deleted Successfully!!!');
      this.ngOnInit();
    }
  }

  // canclecheque1(credit_voucher_id, voucher_no, cheque) {
  //   this.service.changestatus(credit_voucher_id, voucher_no, cheque).subscribe((res) => {

  //   });

  //   this.service.changestatusadvt_sub(credit_voucher_id, voucher_no, cheque).subscribe((res) => {
  //   });
  // }

  canclecheque(voucher_no) {

    //#1. delete receipt from departments
    this.service.changestatusadvt_sub(voucher_no).subscribe((res) => {
      this.getCVData(voucher_no);
    });

  }

  getCVData(voucher_no: string) {
    //#2. get credit voucher data
    this.service.getCreditVoucherData(voucher_no).subscribe((res) => {

      this.generateDebitVoucherNo1(res);

    });

  }

  getMissingCVNumbers(voucher_date: string, bank: string) {
    //#2. get credit voucher data
    this.service.getMissingCreditVoucherNumbers(voucher_date, bank).subscribe((res: any) => {

      this.missingCVData = res;

    });

  }

  getMissingDVNumbers(voucher_date: string, bank: string) {
    //#2. get credit voucher data
    this.service.getMissingDebitVoucherNumbers(voucher_date, bank).subscribe((res: any) => {

      this.missingDVData = res;

    });

  }

  enableUpdateMode() {
    this.updateMode = true;

    // Disable specific fields when updating
    this.debitForm.controls['bcaccount'].disable();
    this.debitForm.controls['dvoucherdate'].disable();
  }

  enableCVUpdateMode() {
    this.updateMode = true;

    // Disable specific fields when updating
    this.creditvoucherForm.controls['bcaccount'].disable();
    this.creditvoucherForm.controls['voucherdate'].disable();
    this.creditvoucherForm.controls['vnumber'].disable();
  }

  exitUpdateMode() {
    this.updateMode = false;

    // Re-enable fields when exiting update mode
    this.debitForm.controls['dv_no'].enable();
    this.debitForm.controls['bcaccount'].enable();
    this.debitForm.controls['dvoucherdate'].enable();
  }

  hasSubExpenses(mainexpid: number): boolean {
    return this.selecteddebitsubExpenses.some(
      (sub) => sub['mainexpid'] === mainexpid
    );
  }

  print_debitvoucher() {

    // this.issuedatelist = this.advtinvoiceForm.value.issuedate.split(',')[0];
    this.dialog.open(DebitVoucherBillComponent, {
      data: {
        dvoucherno: this.debitForm.get('dvnumber').value,
        repname: this.debitForm.get('rname').value,
        narration: this.debitForm.get('othername').value,
        dvoucherdate: this.debitForm.get('dvoucherdate').value,
        debitmainexpenses: this.selecteddebitMainExpenses,
        debitsubexpenses: this.selecteddebitsubExpenses
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }

  get jvDebitTotal(): number {
    return this.items1
      .filter(item => item.amt_status === 'DR')
      .reduce((sum, item) => sum + Number(item.amount || 0), 0);
  }

  get jvCreditTotal(): number {
    return this.items1
      .filter(item => item.amt_status === 'CR')
      .reduce((sum, item) => sum + Number(item.amount || 0), 0);
  }

  fetchData() {

    this.service.getchequedata(this.selectedRCSBank2).subscribe((res) => {
      this.getchquedata = res
    });

  }

  moveTo(direction: string, event: KeyboardEvent) {
    event.preventDefault();
    const currentElement = event.target as HTMLElement;
    const allInputs = Array.from(document.querySelectorAll('input[type="date"]'));
    const currentIndex = allInputs.indexOf(currentElement);

    let nextIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
    if (nextIndex >= allInputs.length) nextIndex = 0;
    if (nextIndex < 0) nextIndex = allInputs.length - 1;

    (allInputs[nextIndex] as HTMLElement).focus();
  }

  getMainExpensesByType(event: any) {
    debugger
    const selectedExpTypeName = event.value;

    this.filteredMainExpData = this.mainExpData.filter(
      exp => exp.exp_type === selectedExpTypeName
    );

    // Reset main expense selection
    this.debitForm.get('expname')?.reset();
    this.expenseledger1.get('expnameother')?.reset();
    this.expenseledger2.get('expnameother')?.reset();
  }

  getMainExpensesForCVByType(event: any) {
    debugger
    const selectedExpTypeName = event.value;

    this.filteredMainExpDataForCV = this.mainExpData.filter(
      exp => exp.exp_type === selectedExpTypeName
    );

    // Reset main expense selection
    this.creditvoucherForm.get('expname')?.reset();
  }

  onMissingDVSelect(event: any) {
    const selectedVoucher = event.value;
    this.debitForm.get('dvnumber').setValue(selectedVoucher);
  }

  onMissingCVSelect(event: any) {
    const selectedVoucher = event.value;
    this.creditvoucherForm.get('vnumber').setValue(selectedVoucher);
  }

  detectIssues() {
    const type = this.issueDetectionForm.value.voucherType;

    switch (type) {
      case 'CREDIT':
        this.detectCreditVoucherIssues();
        break;

      case 'DEBIT':
        this.detectDebitVoucherIssues();
        break;

      case 'CREDITORS':
        this.detectCreditorsIssues();
        break;

      case 'JOURNAL':
        this.detectJournalVoucherIssues();
        break;
    }
  }

  getLekhReport() {
    const dialogdata = this.dialog.open(LekhReportComponent, {
      data: {
        month: this.selectedMonth,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
    dialogdata.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }

  /* API CALL METHODS */

  detectCreditVoucherIssues() {

    const dialogRef = this.dialog.open(CreditVoucherIssuesComponent, {
      data: {
        startDate: this.issueDetectStartDate,
        endDate: this.issueDetectEndDate
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((row) => {
      if (row) {

        this.demo1TabIndex = 0;

        // fill voucher number
        this.creditvoucherForm.patchValue({
          v_no: row.voucher_no
        });

        // trigger load/search
        this.getVoucherNo({ target: { value: row.voucher_no } });
      }

    });

  }

  detectDebitVoucherIssues() {
    const dialogRef = this.dialog.open(DebitVoucherIssuesComponent, {
      data: {
        startDate: this.issueDetectStartDate,
        endDate: this.issueDetectEndDate
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((row) => {
      if (row) {

        this.demo1TabIndex = 1;

        // fill voucher number
        this.debitForm.patchValue({
          dv_no: row.voucher_no
        });

        // trigger load/search
        this.getDVVoucherNo({ target: { value: row.voucher_no } });
      }

    });
  }

  detectCreditorsIssues() {
    const dialogRef = this.dialog.open(CreditorsIssuesComponent, {
      data: {
        startDate: this.issueDetectStartDate,
        endDate: this.issueDetectEndDate
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((row) => {
      if (row) {

        this.demo1TabIndex = 3;

        debugger

        this.kharedi.patchValue({
          creditor_no: row.creditor_no
        });

      }

    });
  }

  detectJournalVoucherIssues() {
    console.log('Detecting Journal Voucher Issues');
    // call API → /api/validate/journal-voucher
  }

  loadIssueList() {
    this.loading1 = true;
    this.service.getIssueList().subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          this.issueList = res.data;
          this.error = '';
        } else {
          this.issueList = [];
          this.error = 'No Issue found';
        }

        this.loading1 = false;
      },
      error: () => {
        this.error = 'Failed to load Issue list';
        this.loading1 = false;
      }
    });
  }

  getMonthName(value: string): string {
    if (!value) return '';

    const month = this.months.find(m => m.value === value);

    return month ? month.name : value;
  }

  loadLekhak() {
    this.loading = true;
    this.service.getLekhakList().subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          this.lekhakList = res.data;
          this.error = '';
        } else {
          this.lekhakList = [];
          this.error = 'No lekhak found';
        }
        this.loading = false;
      },
      error: () => {
        this.error = 'Failed to load lekhak list';
        this.loading = false;
      }
    });
  }

  saveLekhak() {
    if (this.lekhakForm.invalid) return;

    this.loading = true;
    const payload = { ...this.lekhakForm.value, id: this.selectedId };

    const apiCall = this.editMode
      ? this.service.updateLekhak(payload)
      : this.service.addLekhak(payload);

    apiCall.subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          this.resetForm();
          this.loadLekhak();
        } else {
          this.error = res.message || 'Operation failed';
        }
        this.loading = false;
      },
      error: () => {
        this.error = 'Server error';
        this.loading = false;
      }
    });
  }

  saveIssue() {
    debugger
    if (this.issueForm.invalid) return;

    this.loading1 = true;
    const payload = { ...this.issueForm.value, id: this.selectedId1 };

    const apiCall = this.editMode1
      ? this.service.updateIssue(payload)
      : this.service.addIssue(payload);

    apiCall.subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          this.resetIssueForm();
          this.loadIssueList();
        } else {
          this.error = res.message || 'Operation failed';
        }
        this.loading1 = false;
      },
      error: () => {
        this.error = 'Server error';
        this.loading1 = false;
      }
    });
  }

  editLekhak(row: any) {
    this.editMode = true;
    this.selectedId = row.id;
    this.lekhakForm.patchValue(row);
  }

  loadLekhEntryList() {
    this.loadingLekh = true;

    this.service.getLekhEntryList().subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          this.lekhEntryList = res.data;
          this.error = '';
        } else {
          this.lekhEntryList = [];
          this.error = 'No lekh entries found';
        }
        this.loadingLekh = false;
      },
      error: () => {
        this.error = 'Failed to load lekh entry list';
        this.loadingLekh = false;
      }
    });
  }


  deleteLekhak(id: number) {
    if (!confirm('Delete this lekhak?')) return;

    this.loading = true;
    this.service.deleteLekhak(id).subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          this.loadLekhak();
        } else {
          this.error = 'Delete failed';
        }
        this.loading = false;
      },
      error: () => {
        this.error = 'Server error';
        this.loading = false;
      }
    });
  }

  editIssue(row: any) {
    this.editMode1 = true;
    this.selectedId1 = row.id;

    const formattedRow = {
      ...row,
      issue_date: this.formatDate(row.issue_date),
      period_start: this.formatDate(row.period_start_date),
      period_end: this.formatDate(row.period_end_date)
    };

    this.issueForm.patchValue(formattedRow);
  }

  // Helper to format date as YYYY-MM-DD
  formatDate(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  }

  deleteIssue(id: number) {
    if (!confirm('Delete this issue?')) return;

    this.loading1 = true;
    this.service.deleteIssue(id).subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          this.loadIssueList();
        } else {
          this.error = 'Delete failed';
        }
        this.loading1 = false;
      },
      error: () => {
        this.error = 'Server error';
        this.loading1 = false;
      }
    });
  }

  resetForm() {
    this.lekhakForm.reset();
    this.editMode = false;
    this.selectedId = null;
  }

  resetIssueForm() {
    this.issueForm.reset();
    this.editMode1 = false;
    this.selectedId1 = null;
  }

  saveLekhEntry() {
    if (this.lekhEntryForm.invalid) return;

    this.loadingLekh = true;

    const payload = {
      ...this.lekhEntryForm.value,
      id: this.editLekhId
    };

    const apiCall = this.editLekhMode
      ? this.service.updateLekhEntry(payload)
      : this.service.addLekhEntry(payload);

    apiCall.subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          this.resetLekhEntryForm();
          this.loadLekhEntryList();
        } else {
          this.error = res.message || 'Operation failed';
        }
        this.loadingLekh = false;
      },
      error: () => {
        this.error = 'Server error';
        this.loadingLekh = false;
      }
    });
  }

  editLekhEntry(e: any) {
    this.editLekhMode = true;
    this.editLekhId = e.id;

    /* 🔁 HARD RESET (important) */
    this.issueList1 = [];
    this.lekhEntryForm.reset();

    // 1. Patch base fields
    this.lekhEntryForm.patchValue({
      lekhak_id: Number(e.lekhak_id),
      month: e.month,
      lekh_rate: e.rate,
      issue_id: ''   // reset issue first
    });

    // 2. Load issues for selected month
    this.service.getIssuesByMonth(e.month).subscribe({
      next: (res: any) => {
        if (res.status === 'success') {

          // force number type for ids
          this.issueList1 = (res.data || []).map((i: any) => ({
            ...i,
            id: Number(i.id)
          }));

          // 3. Patch issue AFTER list is ready
          this.lekhEntryForm.patchValue({
            issue_id: Number(e.issue_id)
          });

        } else {
          this.issueList1 = [];
        }
      },
      error: () => {
        this.issueList1 = [];
      }
    });
  }

  resetLekhEntryForm() {
    this.lekhEntryForm.reset();
    this.editLekhMode = false;
    this.editLekhId = null;
  }

  deleteLekhEntry(id: number) {
    if (!confirm('Delete this Lekh Entry?')) return;

    this.loadingLekh = true;

    this.service.deleteLekhEntry(id).subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          this.loadLekhEntryList();
        } else {
          this.error = 'Delete failed';
        }
        this.loadingLekh = false;
      },
      error: () => {
        this.error = 'Server error';
        this.loadingLekh = false;
      }
    });
  }

  onMonthChange() {
    const monthValue = this.lekhEntryForm.value.month;

    if (monthValue) {
      this.loadIssues(monthValue);
    }
  }

  loadIssues(monthValue: string) {
    this.service.getIssuesByMonth(monthValue).subscribe((res: any) => {
      this.issueList1 = res.data || [];
    });
  }

  marathiMonths = [
    'जानेवारी', 'फेब्रुवारी', 'मार्च', 'एप्रिल',
    'मे', 'जून', 'जुलै', 'ऑगस्ट',
    'सप्टेंबर', 'ऑक्टोबर', 'नोव्हेंबर', 'डिसेंबर'
  ];

  generateFinancialMonths(start: string | Date, end: string | Date) {

    const startDate = start ? new Date(start) : new Date('1900-01-01');
    const endDate = end ? new Date(end) : new Date('2099-12-31');

    this.financialYearMin = startDate;
    this.financialYearMax = endDate;

    this.months = [];

    let current = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    const last = new Date(endDate.getFullYear(), endDate.getMonth(), 1);

    while (current <= last) {

      const monthIndex = current.getMonth(); // 0-11
      const year = current.getFullYear();

      const monthNumber = (monthIndex + 1).toString().padStart(2, '0'); // 01-12
      const marathiName = this.marathiMonths[monthIndex];

      this.months.push({
        name: `${marathiName}-${year}`,
        value: `${monthNumber}-${year}`
      });

      // move to next month
      current.setMonth(current.getMonth() + 1);
    }
  }

  downloadPaymentExcel(fileName: string = 'lekhak_payments'): void {

    // call your API
    this.service.getLekhExcelData(this.selectedMonth)
      .subscribe((res: any) => {

        if (!res || !res.data || !res.data.length) {
          alert('No data found for export');
          return;
        }

        const rows: any[] = [];

        // ===== Column Headings =====
        rows.push({
          'Amount': 'AMOUNT',
          'Account Number': 'ACCOUNT NUMBER',
          'Benef Acc No': 'BENEF ACCOUNT NO',
          'Benef Name': 'BEN NAME',
          'Benef Address': 'BEN ADDRESS',
          'Sender Name': 'SENDER NAME',
          'IFSC': 'IFSC CODE',
          'Enter1': 'ENTER1',
          'Mobile': 'MOBILE NO'
        });

        // ===== Data Rows =====
        res.data.forEach((item: any) => {
          rows.push({
            'Amount': item.amount,
            'Account Number': `'${item.account_number}`,
            'Benef Acc No': `'${item.benef_accno}`,
            'Benef Name': item.ben_name,
            'Benef Address': item.address,
            'Sender Name': item.sender_name,
            'IFSC': item.ifsc,
            'Enter1': item.enter1,
            'Mobile': item.mobile
          });
        });

        // ===== Create Excel =====
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rows, { skipHeader: true });

        // Column widths
        (ws as any)['!cols'] = [
          { wch: 14 }, // Amount
          { wch: 18 }, // Account Number
          { wch: 22 }, // Benef Acc No
          { wch: 28 }, // Benef Name
          { wch: 28 }, // Benef Address
          { wch: 32 }, // Sender Name
          { wch: 16 }, // IFSC
          { wch: 10 }, // Enter1
          { wch: 16 }  // Mobile
        ];

        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Payments');

        XLSX.writeFile(wb, `${fileName}.xlsx`);
      });
  }

  // getDailyReportData(
  //   startDate,
  //   endDate,
  //   repName,
  //   offRepName,
  //   districtName,
  //   talukaName
  // ) {
  //   // console.log('repName.toString()', repName.toString());

  //   this.service
  //     .getDatewiseAndRepwiseData(
  //       startDate,
  //       endDate,
  //       repName.toString(),
  //       offRepName,
  //       districtName,
  //       talukaName
  //     )
  //     .subscribe((res) => {
  //       // console.log(res);
  //       this.Filtereddatewiserepwisedata = res;
  //       this.Filtereddatewisedata = res;
  //       this.Filteredmonthwisedata = res;
  //       this.Filteredoffrepwisedata = res;
  //       this.Filtereddistricttalukawisedata = res;
  //       // this.Filtereddatewisedata1 = res;
  //       this.getoffice_rep_data();
  //     });
  // }

}

// SELECT a.pkg_id as pkg_id, a.pkg_name as pkg_name, a.pkg_start_date as pkg_start_date, a.pkg_end_date as pkg_end_date, a.pkg_amt as pkg_amt, a.periodicity as periodicity,  b.vivek_m_1_concession_amt as vivek_m_1_concession_amt, b.vivek_h_1_actual_amt as vivek_h_1_actual_amt, b.vivek_h_1_concession_amt as vivek_h_1_concession_amt, b.vaidyraj_1_actual_amt as vaidyraj_1_actual_amt, b.vaidyraj_1_concession_amt as vaidyraj_1_concession_amt, b.granth1_1_actual_amt as granth1_1_actual_amt, b.granth1_1_concession_amt as granth1_1_concession_amt, b.granth2_1_actual_amt as granth2_1_actual_amt, b.granth2_1_concession_amt as granth2_1_concession_amt, b.donation_1_actual_amt as donation_1_actual_amt, b.donation_1_concession_amt as donation_1_concession_amt, b.advt_1_actual_amt as advt_1_actual_amt, b.advt_1_concession_amt as advt_1_concession_amt, b.courier_1_actual_amt as courier_1_actual_amt, b.courier_1_concession_amt as courier_1_concession_amt, b.other_1_actual_amt as other_1_actual_amt, b.other_1_concession_amt as other_1_concession_amt from Package_Details a Join package_details_of_1_year b ON a.pkg_id=b.pkg_id;
